/* sf-core.js v0.1.0 — storefront-core opt-in behaviors (scoped to selected components).
 * Critical add-to-cart ships separately in sf-core-cart.js. Binds data-ds-* hooks only.
 * Generated — do not edit in the theme. */
/* accordion.js */
(function () {
try {
/* accordion — expand/collapse with height animation + chevron rotation.
 * Binds [data-ds-accordion] and data-ds-accordion-{trigger,content,chevron}
 * (see snippets/ds-accordion.liquid). aria-expanded on the trigger is the state.
 * Progressive enhancement: without JS the content stays visible (open).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsAccordionBound) {
  document.__dsAccordionBound = true;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ds-accordion-trigger]');
    if (!trigger) return;
    var root = trigger.closest('[data-ds-accordion]');
    if (!root) return;
    var content = root.querySelector('[data-ds-accordion-content]');
    if (!content) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    if (isOpen) {
      // Closing: pin the current height, then animate to 0 next frame.
      content.style.maxHeight = content.scrollHeight + 'px';
      requestAnimationFrame(function () { content.style.maxHeight = '0'; });
    } else {
      // Opening: measure real height, then animate 0 → height.
      content.style.maxHeight = 'none';
      var h = content.scrollHeight;
      content.style.maxHeight = '0';
      requestAnimationFrame(function () { content.style.maxHeight = h + 'px'; });
      content.addEventListener('transitionend', function onEnd() {
        content.style.maxHeight = 'none';
        content.removeEventListener('transitionend', onEnd);
      });
    }

    var chevron = root.querySelector('[data-ds-accordion-chevron]');
    if (chevron) chevron.classList.toggle('sf-rotate-180', !isOpen);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "accordion" failed to initialise:', sfError);
}
})();

/* announcement.js */
(function () {
try {
/* announcement — rotate announcement item blocks vertically.
 *
 * Pauses while shoppers hover/focus the bar and restarts after Theme Editor
 * section renders. Progressive enhancement: the first message is visible and
 * the remaining faces are inert without JS.
 *
 * No external CSS required. Animation/layout styles are applied inline.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var ANNOUNCEMENT = '[data-ds-header-announcement]';
var ANNOUNCEMENT_SLIDE = '[data-ds-announcement-slide]';
var ANNOUNCEMENT_VIEWPORT = '[data-ds-announcement-viewport]';
var ANNOUNCEMENT_TRACK = '[data-ds-announcement-track]';

function bindAnnouncement(root) {
  if (root.dataset.dsAnnouncementBound) return;
  root.dataset.dsAnnouncementBound = '1';

  var viewport = root.querySelector(ANNOUNCEMENT_VIEWPORT);
  var track = root.querySelector(ANNOUNCEMENT_TRACK);
  var slides = Array.from(root.querySelectorAll(ANNOUNCEMENT_SLIDE));

  if (!viewport || !track || !slides.length) return;

  var active = 0;
  var timer = null;
  var animating = false;

  var duration = 500;
  var interval = Number(root.dataset.dsAnnouncementInterval || 4000);

  interval = Math.max(2000, interval);

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /*
   * Viewport
   *
   * Critical one-line layout is already present in the server-rendered markup
   * so the first paint has the same height as the hydrated state (no CLS). The
   * band height is owned by the snippet class (sf-h-8 below lg, sf-h-11 at lg —
   * 32/44px), so DON'T pin an inline height here: an inline value beats the
   * class and would force one height at every breakpoint, overflowing the band
   * and knocking the copy off-centre.
   */
  viewport.style.position = 'relative';
  viewport.style.display = 'block';
  viewport.style.overflow = 'hidden';

  /*
   * Keep the track a block box (width = viewport width). As a flex item it would
   * take min-width:auto and grow to the message's min-content width, so a long
   * nowrap message would never be clipped by the viewport — and the marquee,
   * which only scrolls when the copy overflows, would never start. Block layout
   * clamps the copy to the band width so the overflow (and the scroll) is real.
   */
  track.style.position = 'relative';
  track.style.display = 'block';
  track.style.height = '100%';

  /*
   * Initial slide state.
   */
  slides.forEach(function (slide, index) {
    slide.dataset.dsAnnouncementIndex = String(index);
    slide.dataset.state = index === 0 ? 'active' : 'idle';

    slide.style.width = '100%';
    slide.style.minWidth = '0';
    slide.style.boxSizing = 'border-box';
    slide.style.whiteSpace = 'nowrap';
    slide.style.overflow = 'hidden';

    var message = slide.querySelector('[data-ds-announcement-message]');

    if (message) {
      message.style.minWidth = '0';
      message.style.overflow = 'hidden';
      message.style.textOverflow = 'ellipsis';
      message.style.whiteSpace = 'nowrap';
    }

    /*
     * Announcement items can contain message + CTA, so keep their contents
     * centered as one horizontal row.
     */
    slide.style.alignItems = 'center';
    slide.style.justifyContent = 'center';

    /*
     * Don't overwrite display if the nested block already explicitly defines
     * one. Inline-flex is needed for the usual span-based announcement item.
     */
    if (!slide.style.display) {
      slide.style.display = 'flex';
    }

    if (!reduceMotion) {
      slide.style.transition =
        'transform ' +
        duration +
        'ms cubic-bezier(.22, 1, .36, 1), opacity ' +
        duration +
        'ms cubic-bezier(.22, 1, .36, 1)';

      slide.style.willChange = 'transform, opacity';
    }

    if (index === 0) {
      slide.style.position = 'relative';
      slide.style.inset = '';
      slide.style.height = '100%';
      slide.style.transform = 'translate3d(0, 0, 0)';
      slide.style.opacity = '1';
      slide.style.pointerEvents = '';

      slide.removeAttribute('aria-hidden');
    } else {
      slide.style.position = 'absolute';
      slide.style.inset = '0';
      slide.style.transform = 'translate3d(0, 100%, 0)';
      slide.style.opacity = '0';
      slide.style.pointerEvents = 'none';

      slide.setAttribute('aria-hidden', 'true');
    }
  });

  /*
   * Marquee for messages that don't fit on one line (typically mobile).
   *
   * Instead of clipping the copy with an ellipsis ("…"), the active slide's
   * message scrolls horizontally in a continuous one-direction loop so the
   * shopper can read all of it. Skipped entirely under reduced-motion (the
   * server-rendered ellipsis stays) and when the copy already fits.
   */
  var marquee = null;

  function pauseMarquee() {
    if (marquee && marquee.anim) marquee.anim.pause();
  }

  function resumeMarquee() {
    if (marquee && marquee.anim && !reduceMotion) marquee.anim.play();
  }

  function teardownMarquee() {
    if (!marquee) return;
    try { marquee.anim.cancel(); } catch (error) { /* already gone */ }
    if (marquee.inner) marquee.inner.style.transform = '';
    marquee = null;
  }

  function setupMarquee(slide) {
    teardownMarquee();

    if (reduceMotion || !slide) return;

    var message = slide.querySelector('[data-ds-announcement-message]');
    if (!message) return;

    /*
     * Build (once) an inner "track" we can translate while the message box
     * clips. The real copy plus an aria-hidden clone ride the track with a gap
     * between them; translating by exactly one copy + gap lands the clone where
     * the original started, so looping back to 0 is seamless — a continuous
     * one-direction scroll with no visible jump-back. Once the text lives in a
     * child element the parent's text-overflow ellipsis no longer applies.
     */
    var GAP = 48;

    var track = message.querySelector('[data-ds-announcement-marquee]');
    var copy;

    if (!track) {
      track = document.createElement('span');
      track.setAttribute('data-ds-announcement-marquee', '');
      track.style.display = 'inline-flex';
      track.style.flexWrap = 'nowrap';
      track.style.alignItems = 'center';
      track.style.willChange = 'transform';

      copy = document.createElement('span');
      copy.setAttribute('data-ds-announcement-marquee-copy', '');
      copy.style.whiteSpace = 'nowrap';

      while (message.firstChild) {
        copy.appendChild(message.firstChild);
      }

      track.appendChild(copy);
      message.appendChild(track);
    } else {
      track.style.transform = '';
      copy = track.querySelector('[data-ds-announcement-marquee-copy]');
    }

    message.style.overflow = 'hidden';
    message.style.textOverflow = 'clip';
    message.style.whiteSpace = 'nowrap';

    var single = Math.ceil(copy.getBoundingClientRect().width);
    var clone = track.querySelector('[data-ds-announcement-marquee-clone]');

    /* Fits on one line — leave it centered, drop any clone, nothing to loop. */
    if (single <= message.clientWidth + 4) {
      if (clone) track.removeChild(clone);
      track.style.gap = '';
      return;
    }

    if (typeof track.animate !== 'function') return;

    /* Trailing clone makes the wrap-around seamless. */
    if (!clone) {
      clone = copy.cloneNode(true);
      clone.removeAttribute('data-ds-announcement-marquee-copy');
      clone.setAttribute('data-ds-announcement-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.gap = GAP + 'px';

    var distance = single + GAP;

    /* ~55px/s constant scroll. */
    var duration = Math.max(4000, Math.round((distance / 55) * 1000));

    marquee = {
      inner: track,
      slide: slide,
      anim: track.animate(
        [
          { transform: 'translateX(0)' },
          { transform: 'translateX(-' + distance + 'px)' }
        ],
        {
          duration: duration,
          iterations: Infinity,
          easing: 'linear'
        }
      )
    };
  }

  setupMarquee(slides[active]);

  /* Web fonts can reflow the copy after first paint — re-measure once ready. */
  if (document.fonts && document.fonts.ready &&
    typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(function () {
      setupMarquee(slides[active]);
    });
  }

  /* Re-measure when the viewport (and therefore the overflow) changes. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      setupMarquee(slides[active]);
    }, 150);
  });

  /* Pause the scroll while the shopper is reading (hover/focus). */
  root.addEventListener('mouseenter', pauseMarquee);
  root.addEventListener('mouseleave', resumeMarquee);
  root.addEventListener('focusin', pauseMarquee);
  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget)) resumeMarquee();
  });

  if (slides.length < 2) return;

  function clearTimer() {
    window.clearTimeout(timer);
    timer = null;
  }

  function schedule() {
    clearTimer();

    if (!root.isConnected) return;
    if (animating) return;

    timer = window.setTimeout(flip, interval);
  }

  function completeFlip(previous, next, nextIndex) {
    /*
     * Previous slide returns to the waiting position below the viewport.
     */
    previous.dataset.state = 'idle';
    previous.style.position = 'absolute';
    previous.style.inset = '0';
    previous.style.transform = 'translate3d(0, 100%, 0)';
    previous.style.opacity = '0';
    previous.style.pointerEvents = 'none';
    previous.setAttribute('aria-hidden', 'true');

    /*
     * New active slide becomes the element defining the track's natural
     * height.
     */
    next.dataset.state = 'active';
    next.style.position = 'relative';
    next.style.inset = '';
    next.style.height = '100%';
    next.style.transform = 'translate3d(0, 0, 0)';
    next.style.opacity = '1';
    next.style.pointerEvents = '';
    next.removeAttribute('aria-hidden');

    active = nextIndex;
    animating = false;

    setupMarquee(next);

    schedule();
  }

  function flip() {
    if (!root.isConnected) return;
    if (animating) return;

    animating = true;
    clearTimer();

    var previous = slides[active];
    var nextIndex = (active + 1) % slides.length;
    var next = slides[nextIndex];

    /*
     * Reduced motion: swap immediately.
     */
    if (reduceMotion) {
      completeFlip(previous, next, nextIndex);
      return;
    }

    /*
     * Prepare the incoming slide below the viewport.
     */
    next.dataset.state = 'entering';
    next.style.position = 'absolute';
    next.style.inset = '0';
    next.style.transform = 'translate3d(0, 100%, 0)';
    next.style.opacity = '0';
    next.style.pointerEvents = 'none';
    next.removeAttribute('aria-hidden');

    /*
     * Previous remains visually active at its current position.
     */
    previous.style.position = 'relative';
    previous.style.inset = '';
    previous.style.transform = 'translate3d(0, 0, 0)';
    previous.style.opacity = '1';

    /*
     * Commit the incoming slide's starting pose before transitioning it.
     */
    next.getBoundingClientRect();

    requestAnimationFrame(function () {
      if (!root.isConnected) return;

      previous.dataset.state = 'leaving';
      next.dataset.state = 'active';

      previous.style.transform = 'translate3d(0, -100%, 0)';
      previous.style.opacity = '0';
      previous.style.pointerEvents = 'none';

      next.style.transform = 'translate3d(0, 0, 0)';
      next.style.opacity = '1';
    });

    var finished = false;

    function finish(event) {
      if (finished) return;

      /*
       * Ignore transitionend events bubbling from children and ignore opacity;
       * transform is the transition that defines completion.
       */
      if (event) {
        if (event.target !== next) return;
        if (event.propertyName !== 'transform') return;
      }

      finished = true;

      next.removeEventListener('transitionend', finish);

      completeFlip(previous, next, nextIndex);
    }

    next.addEventListener('transitionend', finish);

    /*
     * Safety fallback for browsers/layout changes that prevent transitionend
     * from firing.
     */
    window.setTimeout(function () {
      finish();
    }, duration + 100);
  }

  /*
   * Pause rotation while the shopper is interacting with the bar.
   */
  root.addEventListener('mouseenter', function () {
    clearTimer();
  });

  root.addEventListener('mouseleave', function () {
    if (!animating) schedule();
  });

  root.addEventListener('focusin', function () {
    clearTimer();
  });

  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget) && !animating) {
      schedule();
    }
  });

  schedule();
}

function initAnnouncements(scope) {
  if (!scope) return;

  if (scope.matches && scope.matches(ANNOUNCEMENT)) {
    bindAnnouncement(scope);
  }

  if (scope.querySelectorAll) {
    scope.querySelectorAll(ANNOUNCEMENT).forEach(bindAnnouncement);
  }
}

if (!document.__dsAnnouncementBound) {
  document.__dsAnnouncementBound = true;

  var startAnnouncements = function () {
    initAnnouncements(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAnnouncements);
  } else {
    startAnnouncements();
  }

  /*
   * Shopify Theme Editor: bind newly rendered sections.
   */
  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncements(event.target);
  });

  /*
   * Dismiss announcement bar.
   */
  document.addEventListener('click', function (event) {
    var dismiss =
      event.target.closest &&
      event.target.closest('[data-ds-header-announcement-dismiss]');

    var root = dismiss && dismiss.closest(ANNOUNCEMENT);

    if (root) {
      root.remove();
    }
  });
}
} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "announcement" failed to initialise:', sfError);
}
})();

/* cart-added.js */
(function () {
try {
/* cart-added — opens the "Added to cart" dialog (ds-cart-added with modal: true)
 * after an AJAX add, filled from the line that was just added.
 *
 * Reads the ds:cart:added detail buy-buttons.js emits — the Cart AJAX API
 * response for /cart/add.js, whose first non-child line carries what to show:
 * image, product_title, options_with_values, final_line_price. No component DOM
 * is touched but this dialog's own hooks.
 *
 * The BuildYou path adds its add-ons in a second request (product-addon.js) and
 * then re-emits this event with the parent product line plus its add-on children,
 * so the dialog re-fills with the product, the add-on rows and a combined total.
 * That event lands after the BuildYou SDK bridge's own product-only event
 * (blocks/ds-product-customization-form.liquid), which forwards the SDK's format
 * and falls through to "no line" — the dialog then keeps the line its Liquid
 * rendered, the product and variant on the page, until the add-on event refines it.
 *
 * Progressive enhancement: without this script the dialog stays hidden and the
 * add still happens — buy-buttons.js already falls back to a full-page POST.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsCartAddedBound) return;
  document.__dsCartAddedBound = true;

  var lastFocus = null;

  function modal() {
    return document.querySelector('[data-ds-cart-added-modal]');
  }

  // One attribute is the whole state: src/cart-added.css animates off it.
  function isOpen(el) {
    return Boolean(el) && el.getAttribute('aria-hidden') === 'false';
  }

  // The Cart AJAX API returns the added line itself, or { items: [...] } when
  // several land at once. Take the first line that is not an add-on: a bundle add
  // sends the add-ons FIRST and the main product last (Cross-sell Bundle spec
  // §3.2), and the add-on path (product-addon.js) emits ds:cart:added for a
  // request that contains ONLY add-ons — the dialog must show the product either
  // way, never its gift box.
  function isChild(line) {
    if (!line) return false;
    var properties = line.properties;
    return Boolean(
      line.parent_relationship ||
        line.parent_line_key ||
        (properties && properties._bundle_role === 'addon')
    );
  }

  // The add-on lines of the same response. buy-buttons.js sends main + add-ons in
  // ONE /cart/add.js call, so a bundle arrives here whole and the dialog can show
  // what the shopper actually paid — the product price alone would understate it.
  function addedAddons(detail) {
    if (!detail || !Array.isArray(detail.items)) return [];
    return detail.items.filter(isChild);
  }

  function addedLine(detail) {
    if (!detail) return null;
    if (Array.isArray(detail.items)) {
      for (var i = 0; i < detail.items.length; i += 1) {
        if (!isChild(detail.items[i])) return detail.items[i];
      }
      return null;
    }
    if (isChild(detail)) return null;
    return detail.product_title || detail.title ? detail : null;
  }

  function optionLabels(line) {
    var pairs = line.options_with_values;
    if (!Array.isArray(pairs)) return [];
    return pairs
      .filter(function (pair) {
        // Shopify sends "Title / Default Title" for products with no real options.
        return pair && pair.value && pair.value !== 'Default Title';
      })
      .map(function (pair) {
        return { name: pair.name, value: pair.value };
      });
  }

  // Shopify money fields are integer cents; the shop's format lives in Liquid, not
  // here, so render the store default and let the theme override via data-money.
  function money(cents, root) {
    var format = root.getAttribute('data-ds-cart-added-money') || '${{amount}}';
    var amount = (Number(cents) || 0) / 100;
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
  }

  // A live personalization canvas snapshot, or '' if it can't be read (a
  // cross-origin-tainted canvas throws on toDataURL — never let that break fill).
  function canvasPreview(canvas, type, quality) {
    if (!canvas || typeof canvas.toDataURL !== 'function') return '';
    try {
      return canvas.toDataURL({ format: type, quality: quality }) || '';
    } catch (e) {
      return '';
    }
  }

  function eventPreview(detail) {
    // The exact frame the shopper just personalized, in priority order: a live
    // personalization canvas (buildyouCanvas, then engraver), then the SDK's
    // in-memory preview (window.BuildYou.publicPreviewUrl, usually a data: URI),
    // then whatever preview URL the event detail carried. ds:cart:added fires only
    // after the bridge's /cart.js round trip, so these are set by modal-open time.
    var win = typeof window !== 'undefined' ? window : null;
    var candidate =
      (win && win.buildyouCanvas && canvasPreview(win.buildyouCanvas, 'png', 0.7)) ||
      (win && win.engraver && canvasPreview(win.engraver.canvas, 'jpeg', 0.7)) ||
      (win && win.BuildYou && win.BuildYou.publicPreviewUrl) ||
      (detail &&
        typeof detail === 'object' &&
        (detail.previewUrl ||
          detail.previewImageUrl ||
          detail.publicPreviewUrl ||
          detail.preview_image)) ||
      '';
    if (candidate && typeof candidate === 'object') candidate = candidate.url || candidate.src || '';
    return typeof candidate === 'string' ? candidate : '';
  }

  function fill(root, line, previewUrl) {
    var titleText = line.product_title || line.title || '';
    var image = root.querySelector('[data-ds-cart-added-image]');
    if (image) {
      // The thumbnail IS the personalization preview now — no separate Preview
      // button — so it carries the zoom-lightbox hooks the button used to carry.
      // BuildYou can send the already-rendered browser preview with its success
      // event. Prefer it over the persisted line-property URL: the latter points
      // at S3 and may not be available yet when the modal opens.
      var src =
        previewUrl ||
        (line.properties && line.properties['_customily-preview']) ||
        lineImage(line);
      if (src) {
        // Swapping src on an already-loaded <img> won't re-show the spinner on
        // its own — reset it so the frame goes gray/spinning again, same as a
        // fresh ds-image on the cart page (image-fallback.js hides it once more
        // on the new load/error).
        var wrap = image.closest('[data-ds-image]');
        var spinner = wrap && wrap.querySelector('[data-ds-image-loading]');
        if (spinner) spinner.hidden = false;
        delete image.dataset.dsImageRetries;
        image.src = src;
        image.alt = titleText;
        image.setAttribute('data-ds-image-zoom-src', src);
        image.setAttribute('data-ds-image-zoom-alt', titleText);
        image.setAttribute('data-ds-image-zoom-title', titleText);
        image.removeAttribute('hidden');
      } else {
        image.setAttribute('hidden', '');
      }
    }

    var title = root.querySelector('[data-ds-cart-added-title]');
    if (title && titleText) title.textContent = titleText;

    var options = root.querySelector('[data-ds-cart-added-options]');
    if (options) {
      var labels = optionLabels(line);
      options.textContent = '';
      labels.forEach(function (label) {
        /* Same two spans the Liquid draws: the label in the row's own weight,
         * the chosen value semibold navy. textContent on each, so a value that
         * came back from Shopify can never inject markup. */
        var span = document.createElement('span');
        span.appendChild(document.createTextNode(label.name + ': '));
        var value = document.createElement('span');
        value.className = 'sf-font-semibold sf-text-action-secondary';
        value.textContent = label.value;
        span.appendChild(value);
        options.appendChild(span);
      });
      if (labels.length) {
        options.removeAttribute('hidden');
      } else {
        options.setAttribute('hidden', '');
      }
    }

    var amount = root.querySelector('[data-ds-price-amount]');
    var cents = lineCents(line);
    if (amount && cents !== null) amount.textContent = money(cents, root);


    var qtyValue = Math.max(1, Number(line.quantity) || 1);
    var quantity = root.querySelector('[data-ds-cart-added-quantity]');
    if (quantity) quantity.textContent = String(qtyValue);

    /* "($29.95 USD each)" under the amount, but only when more than one was
     * added — at quantity 1 the amount above already IS the unit price.
     * line.final_price is Shopify's per-unit cents (final_line_price is the
     * line), so nothing has to be divided here. */
    var unit = root.querySelector('[data-ds-cart-added-unit]');
    if (unit) {
      var unitCents = Number(line.final_price);
      if (qtyValue > 1 && isFinite(unitCents) && unitCents > 0) {
        unit.textContent = '(' + money(unitCents, root) + ' each)';
        unit.removeAttribute('hidden');
      } else {
        unit.setAttribute('hidden', '');
      }
    }

    // ponytail: Edit item hidden in this modal on request (2026-09-08) — swap
    // this block back for `fillEdit(root, line);` to restore it.
    var editLinkWrap = root.querySelector('[data-ds-cart-added-edit-link]');
    var editBuildYouWrap = root.querySelector('[data-ds-cart-added-edit-buildyou]');
    if (editLinkWrap) editLinkWrap.setAttribute('hidden', '');
    if (editBuildYouWrap) editBuildYouWrap.setAttribute('hidden', '');

    fillProperties(root, line);
  }

  function fillEdit(root, line) {
    var properties = (line && line.properties) || {};
    var isBuildYou = Boolean(
      line &&
        line.key &&
        properties['_buildyou-customization-id'] &&
        properties['_source_app'] === 'buildyou_nova'
    );
    var linkWrap = root.querySelector('[data-ds-cart-added-edit-link]');
    var link = linkWrap && linkWrap.querySelector('[data-ds-cart-added-edit]');
    var buildYouWrap = root.querySelector('[data-ds-cart-added-edit-buildyou]');

    if (isBuildYou && buildYouWrap) {
      buildYouWrap.setAttribute('data-line-key', line.key);
      buildYouWrap.setAttribute('hidden', '');
      if (linkWrap) linkWrap.setAttribute('hidden', '');
      loadBuildYouCartBundle(buildYouWrap, linkWrap);
      return;
    }

    if (buildYouWrap) {
      buildYouWrap.setAttribute('hidden', '');
      buildYouWrap.removeAttribute('data-line-key');
    }
    if (linkWrap) linkWrap.removeAttribute('hidden');
    if (link && line.url) link.setAttribute('href', line.url);
  }

  // The cart bundle scans `.by-edit-design-slot[data-line-key]` once at startup.
  // Its MutationObserver only watches #cart_line_form, which does not exist on a
  // PDP, so loading it before this modal has the real line key leaves a visible
  // but unbound button. Stamp the key above, then load the exact cart-page bundle.
  function loadBuildYouCartBundle(editControl, fallbackControl) {
    window.BuildYou = window.BuildYou || {};
    if (window.BuildYou.cartScriptState === 'ready') {
      if (editControl.dataset.byEditBound === '1') editControl.removeAttribute('hidden');
      return;
    }
    if (window.BuildYou.cartScriptState === 'loading') {
      return;
    }
    window.BuildYou.cartScriptState = 'loading';

    var main = 'https://assets.buildyou.io/scripts/tuan_dev/re-design-form/';
    var fallback = 'https://cdn.bestbuildyou.com/scripts/tuan_dev/re-design-form/';
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.crossOrigin = 'anonymous';
    css.onerror = function () {
      css.onerror = null;
      css.href = fallback + 'cart.bundle.css';
    };
    css.href = main + 'cart.bundle.css';
    document.head.appendChild(css);

    function appendScript(src, canRetry) {
      var script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.onload = function () {
        window.BuildYou.cartScriptState = 'ready';
        if (editControl.dataset.byEditBound === '1') editControl.removeAttribute('hidden');
      };
      script.onerror = function () {
        if (canRetry) {
          appendScript(fallback + 'cart.bundle.js', false);
        } else {
          window.BuildYou.cartScriptState = 'failed';
          if (fallbackControl) fallbackControl.removeAttribute('hidden');
        }
      };
      script.src = src;
      document.head.appendChild(script);
    }

    appendScript(main + 'cart.bundle.js', true);
  }

  function visibleProperties(line) {
    var properties = (line && line.properties) || {};
    var optionNames = {};
    if (Array.isArray(line && line.options_with_values)) {
      line.options_with_values.forEach(function (option) {
        if (option && option.name) optionNames[option.name] = true;
      });
    }
    return Object.keys(properties).reduce(function (rows, key) {
      var value = properties[key];
      if (!value) return rows;
      if (key.charAt(0) !== '_') {
        rows.push({ name: key, value: value });
        return rows;
      }
      if (key.indexOf('_custom_') !== 0 || /\(originals?\)|\(filtered\)/.test(String(value))) {
        return rows;
      }
      var label = key.replace(/^_custom_\S+\s*/, '').trim();
      if (label && !optionNames[label]) rows.push({ name: label, value: value });
      return rows;
    }, []);
  }

  // Rebuild the plain "Label: Value" lines the static card draws — one per line,
  // the same flat style as the chosen options above (Figma 5543:37874), not the
  // boxed list the full cart line uses.
  function fillProperties(root, line) {
    var el = root.querySelector('[data-ds-cart-added-properties]');
    if (!el) return;
    // ponytail: personalization lines hidden on request (2026-09-05) — matches the
    // snippet's static override; restore `visibleProperties(line)` to bring them back.
    var rows = [];
    el.textContent = '';
    rows.forEach(function (row) {
      var span = document.createElement('span');
      span.textContent = row.name + ': ' + row.value;
      el.appendChild(span);
    });
    if (rows.length) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  // The line total in cents, or null when the payload carries no price at all —
  // the caller then leaves whatever Liquid already rendered rather than writing 0.
  function lineCents(line) {
    var cents = line && line.final_line_price;
    if (cents === undefined || cents === null) cents = line && line.line_price;
    if (cents === undefined || cents === null) cents = line && line.final_price;
    if (cents === undefined || cents === null) return null;
    return Number(cents) || 0;
  }

  function lineImage(line) {
    var src = (line && (line.image || line.featured_image)) || '';
    if (src && src.url) src = src.url;
    return src || '';
  }

  function fillAddonRow(node, addon, root) {
    var image = node.querySelector('[data-ds-cart-addon-image]');
    var src = lineImage(addon);
    if (image) {
      if (src) {
        image.src = src;
        image.alt = '';
        image.removeAttribute('hidden');
      } else {
        image.setAttribute('hidden', '');
      }
    }

    var title = node.querySelector('[data-ds-cart-addon-title]');
    if (title) title.textContent = addon.product_title || addon.title || '';

    // Storybook pm add-on row has Quantity only — no variant line.
    var variant = node.querySelector('[data-ds-cart-addon-variant]');
    if (variant) {
      variant.textContent = '';
      variant.setAttribute('hidden', '');
    }

    var quantity = node.querySelector('[data-ds-cart-addon-quantity]');
    if (quantity) {
      var qty = Number(addon.quantity);
      if (qty > 0) {
        // Same quantity as before (was "× N"); Storybook pm label format only.
        var labelMatch = (quantity.textContent || '').match(/^(.*?:\s*)/);
        quantity.textContent = (labelMatch ? labelMatch[1] : 'Quantity: ') + qty;
        quantity.removeAttribute('hidden');
      } else {
        quantity.setAttribute('hidden', '');
      }
    }

    var price = node.querySelector('[data-ds-cart-addon-price]');
    if (price) price.textContent = money(lineCents(addon) || 0, root);
    return node;
  }

  // No add-ons: the whole block goes, item total included — on its own it would
  // just restate the price already shown above.
  function fillAddons(root, line, addons) {
    var block = root.querySelector('[data-ds-cart-added-addons]');
    if (!block) return;
    var list = root.querySelector('[data-ds-cart-added-addon-list]');
    var template = root.querySelector('[data-ds-cart-added-addon-template]');
    if (!addons.length || !list || !template || !template.content.firstElementChild) {
      block.setAttribute('hidden', '');
      return;
    }

    list.textContent = '';
    var total = lineCents(line) || 0;
    addons.forEach(function (addon) {
      total += lineCents(addon) || 0;
      list.appendChild(fillAddonRow(template.content.firstElementChild.cloneNode(true), addon, root));
    });

    var totalEl = root.querySelector('[data-ds-cart-added-total]');
    if (totalEl) totalEl.textContent = money(total, root);
    block.removeAttribute('hidden');
  }

  function open(detail) {
    var el = modal();
    if (!el) return;
    var line = addedLine(detail);
    if (line) fill(el, line, eventPreview(detail));
    fillAddons(el, line, addedAddons(detail));

    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var closeBtn = el.querySelector('[data-ds-cart-added-close]');
    // Focus after paint so the dialog is on screen first.
    window.requestAnimationFrame(function () {
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    var el = modal();
    if (!isOpen(el)) return;
    // Move focus OUT before hiding. aria-hidden on an ancestor of the focused
    // element is invalid — the browser warns and refuses to hide it from the
    // a11y tree — and the Edit control that triggered a close still holds focus
    // here. Blur first, then restore focus to whatever opened the dialog.
    var active = document.activeElement;
    if (active && el.contains(active) && typeof active.blur === 'function') active.blur();
    // The sheet keeps sliding out on its own — the CSS delays visibility until
    // the transition ends, so nothing here has to wait for it.
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  // Buy buttons with the dialog switched off render no dialog and carry this
  // attribute instead: the add then goes straight to the cart page.
  function redirectTarget() {
    var el = document.querySelector('[data-ds-cart-added-redirect]');
    return (el && el.getAttribute('data-ds-cart-added-redirect')) || '';
  }

  document.addEventListener('ds:cart:added', function (e) {
    if (modal()) {
      open(e.detail);
      return;
    }
    var to = redirectTarget();
    if (to) window.location.assign(to);
  });

  // Edit design: the BuildYou slot opens its editor in-page, and the cart bundle
  // binds its handler on the button itself — that target-phase handler runs
  // before any bubble listener here. Close in the CAPTURE phase so our body
  // scroll-lock is lifted BEFORE the editor opens and snapshots body overflow;
  // otherwise it saves our 'hidden' and restores it on close, leaving the page
  // unscrollable. No preventDefault — the bundle / plain link still runs.
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('[data-ds-cart-added-edit]')) close();
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-ds-cart-added-continue]')) {
      e.preventDefault();
      close();
      // The trigger (e.g. a quick-add card) can be far down the page — send the
      // shopper back to the top, where continued browsing normally starts.
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (e.target.closest('[data-ds-cart-added-close]')) {
      e.preventDefault();
      close();
      return;
    }
    // Backdrop: the overlay itself, never the dialog inside it.
    var el = modal();
    if (isOpen(el) && e.target === el) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isOpen(modal())) close();
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-added" failed to initialise:', sfError);
}
})();

/* cart-alerts.js */
(function () {
try {
/* cart-alerts — drives the state-driven notices under the cart title
 * (snippets/ds-cart-alerts.liquid): the price-update notice's dismiss button and
 * the cart-expiry countdown ticker.
 *
 * Progressive enhancement: Liquid renders both notices fully (the countdown at
 * its starting mm:ss); this only makes them interactive — the countdown ticks
 * down and swaps to the expired copy at zero, and the price-update notice can be
 * dismissed for the session. Without JS the copy still reads correctly.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CART_ALERTS = '[data-ds-cart-alerts]';
var PRICE_UPDATE = '[data-ds-cart-price-update]';
var PRICE_UPDATE_CLOSE = '[data-ds-cart-price-update-close]';
var EXPIRY = '[data-ds-cart-expiry]';
var EXPIRY_TIME = '[data-ds-cart-expiry-time]';
var DISMISS_KEY = 'ds-cart-price-update-dismissed';

function cartAlertsPad(n) {
  return n < 10 ? '0' + n : '' + n;
}

function cartAlertsFormat(seconds) {
  var h = Math.floor(seconds / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = seconds % 60;
  return h > 0
    ? h + ':' + cartAlertsPad(m) + ':' + cartAlertsPad(s)
    : cartAlertsPad(m) + ':' + cartAlertsPad(s);
}

function cartAlertsInitPriceUpdate(region) {
  var pu = region.querySelector(PRICE_UPDATE);
  if (!pu) return;
  var message = pu.textContent.trim();
  try {
    if (sessionStorage.getItem(DISMISS_KEY) === message) pu.hidden = true;
  } catch (e) {}
  var close = pu.querySelector(PRICE_UPDATE_CLOSE);
  if (close) {
    close.addEventListener('click', function () {
      pu.hidden = true;
      try {
        sessionStorage.setItem(DISMISS_KEY, message);
      } catch (e) {}
    });
  }
}

function cartAlertsInitExpiry(region) {
  var exp = region.querySelector(EXPIRY);
  if (!exp) return;
  var seconds = parseInt(exp.getAttribute('data-ds-cart-expiry-seconds'), 10) || 0;
  if (seconds <= 0) return;
  var timeEl = exp.querySelector(EXPIRY_TIME);
  var expiredText = exp.getAttribute('data-ds-cart-expiry-expired') || '';
  var remaining = seconds;
  var timer = setInterval(function () {
    remaining -= 1;
    if (remaining <= 0) {
      clearInterval(timer);
      // Swap the whole row content for the expired message, keeping the tone.
      exp.textContent = '';
      var span = document.createElement('span');
      span.className = 'sf-font-medium';
      span.textContent = expiredText;
      exp.appendChild(span);
      return;
    }
    if (timeEl) timeEl.textContent = cartAlertsFormat(remaining);
  }, 1000);
}

function cartAlertsInit(region) {
  if (!region || region.__dsCartAlertsBound) return;
  region.__dsCartAlertsBound = true;
  cartAlertsInitPriceUpdate(region);
  cartAlertsInitExpiry(region);
}

function cartAlertsInitAll() {
  var regions = document.querySelectorAll(CART_ALERTS);
  for (var i = 0; i < regions.length; i++) cartAlertsInit(regions[i]);
}

if (!document.__dsCartAlertsBound) {
  document.__dsCartAlertsBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartAlertsInitAll, { once: true });
  } else {
    cartAlertsInitAll();
  }

  // The region can also arrive after load — the theme editor re-renders a section
  // by swapping its HTML in, with no DOMContentLoaded. Watch for it so the
  // countdown starts and the dismiss button binds in that case too. (The
  // per-region guard keeps re-scans idempotent.)
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          cartAlertsInitAll();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-alerts" failed to initialise:', sfError);
}
})();

/* cart-checkout-sticky.js */
(function () {
try {
/* cart-checkout-sticky — reveal/hide the mobile sticky checkout bar.
 *
 * Binds [data-ds-cart-checkout-sticky] (snippets/ds-cart-checkout-sticky.liquid).
 * The bar starts hidden (sf-hidden). While the in-card Checkout button
 * ([data-ds-cart-checkout-anchor], in ds-cart-summary) is OFF screen, this shows
 * the bar; once that button scrolls back into view the bar hides again, so the
 * shopper never sees two checkout buttons at once. With no JS the bar never
 * shows and the in-card button still works (progressive enhancement).
 *
 * The bar is CSS-hidden from lg up (lg:sf-hidden, never toggled here) where the
 * Order Summary is a sticky sidebar; the observer still runs there but the CSS
 * keeps the bar gone.
 *
 * It also opens/closes the Order Summary bottom sheet the bar's total expands
 * into — see bindSheet below.
 *
 * Idempotent + Theme-Editor-safe: the section can re-render, so re-scans must
 * not double-observe. Authoring rules: src/behaviors/README.md. No import/export.
 */
function cartCheckoutStickyInit(bar) {
  if (!bar || bar.dataset.dsBound) return;

  // Watch the real in-card checkout button. Scope to this bar's cart so a page
  // with more than one never crosses the wires; fall back to document.
  var scope = bar.closest('[data-ds-cart]') || document;
  var anchor = scope.querySelector('[data-ds-cart-checkout-anchor]');
  if (!anchor) return;

  bar.dataset.dsBound = '1';

  // Without IntersectionObserver, leave the bar hidden: the in-card button is
  // enough and revealing a permanent bar would be worse than none.
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (!entry) return;
      // In view → the shopper has reached the real button; hide the bar.
      // Out of view (above or below) → show it.
      if (entry.isIntersecting) {
        bar.classList.add('sf-hidden');
      } else {
        bar.classList.remove('sf-hidden');
      }
    },
    { threshold: 0 }
  );
  observer.observe(anchor);

  bindSheet(bar, scope);
}

/* The Order Summary sheet the bar's total opens (SF0031). Plain markup behind
 * `hidden`: this flips the scrim + sheet, keeps aria-expanded honest, turns the
 * chevron over, and closes on Escape, on the scrim and on the X. The page
 * behind it is locked while it is open so the sheet is what scrolls. */
function bindSheet(bar, scope) {
  var toggle = bar.querySelector('[data-ds-cart-sticky-toggle]');
  if (!toggle) return;

  var root = scope === document ? document : scope;
  var sheet = root.querySelector('[data-ds-cart-sticky-sheet]');
  var scrim = root.querySelector('[data-ds-cart-sticky-scrim]');
  if (!sheet || !scrim) return;

  var chevron = bar.querySelector('[data-ds-cart-sticky-chevron]');

  function open() {
    sheet.hidden = false;
    scrim.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    if (chevron) chevron.classList.add('sf-rotate-180');
    document.documentElement.style.overflow = 'hidden';
    var close = sheet.querySelector('[data-ds-cart-sticky-close]');
    if (close && typeof close.focus === 'function') close.focus();
  }

  function close() {
    sheet.hidden = true;
    scrim.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (chevron) chevron.classList.remove('sf-rotate-180');
    document.documentElement.style.overflow = '';
    if (typeof toggle.focus === 'function') toggle.focus();
  }

  toggle.addEventListener('click', function () {
    if (sheet.hidden) open();
    else close();
  });

  scrim.addEventListener('click', close);

  sheet.addEventListener('click', function (event) {
    if (event.target.closest('[data-ds-cart-sticky-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !sheet.hidden) close();
  });
}

function cartCheckoutStickyInitAll() {
  var bars = document.querySelectorAll('[data-ds-cart-checkout-sticky]');
  for (var i = 0; i < bars.length; i++) cartCheckoutStickyInit(bars[i]);
}

if (!document.__dsCartCheckoutStickyBound) {
  document.__dsCartCheckoutStickyBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartCheckoutStickyInitAll, { once: true });
  } else {
    cartCheckoutStickyInitAll();
  }

  // The theme editor re-renders a section by swapping its HTML in, with no
  // DOMContentLoaded — re-scan so the bar re-binds. The per-bar guard keeps it
  // idempotent.
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          cartCheckoutStickyInitAll();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-checkout-sticky" failed to initialise:', sfError);
}
})();

/* cart-item-total.js */
(function () {
try {
/* cart-item-total — keeps a cart line's "Item total (incl. add-ons)" honest while
 * the buyer is still stepping. Pure arithmetic, no network: cart-lines.js owns
 * /cart/change.js.
 *
 * It moves the total by the DIFFERENCE against the rendered quantities, never by
 * re-adding the line, so a total the server discounted keeps its discount. A line
 * without data-ds-cart-item-total-cents is left alone.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CART_ITEM = '[data-ds-cart-item]';
var CART_ITEM_TOTAL = '[data-ds-cart-item-total-value] [data-ds-price-amount]';
var CART_ITEM_LINE = '[data-ds-cart-item-line-price] [data-ds-price-amount]';
var CART_ITEM_EACH = '[data-ds-cart-item-each]';

function cartItemCents(el, attr) {
  var raw = el && el.getAttribute(attr);
  if (raw === null || raw === undefined || raw === '') return null;
  var value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

// Blank means mid-edit, not "zero of these".
function cartItemQuantity(scope, rendered) {
  var input = scope && scope.querySelector('input[type="number"]');
  if (!input) return rendered;
  var raw = String(input.value).trim();
  if (raw === '') return rendered;
  var value = Number(raw);
  if (!Number.isFinite(value) || value < 0) return rendered;
  return value;
}

function cartItemMoney(root, cents) {
  // money_format may carry markup; this writes text, so drop the tags.
  var format = (root.getAttribute('data-ds-cart-item-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
}

// The line's own quantity: the first stepper outside any add-on row.
function cartItemMainQuantity(root, renderedQty) {
  var steppers = root.querySelectorAll('[data-ds-number-input]');
  for (var i = 0; i < steppers.length; i += 1) {
    if (!steppers[i].closest('[data-ds-cart-addon-line]')) {
      return cartItemQuantity(steppers[i], renderedQty);
    }
  }
  return renderedQty;
}

function cartItemSync(root) {
  if (!root) return;
  var unit = cartItemCents(root, 'data-ds-cart-item-price');
  var renderedQty = cartItemCents(root, 'data-ds-cart-item-quantity');
  if (renderedQty === null) renderedQty = 1;
  var mainQty = cartItemMainQuantity(root, renderedQty);

  // Purchase-row line total (unit × quantity). Moved by the stepper DIFFERENCE
  // off the rendered line total, not re-multiplied, so a per-line discount the
  // server applied is kept — the same reasoning as the add-ons total below.
  var line = root.querySelector(CART_ITEM_LINE);
  if (line && unit !== null) {
    var lineCents = cartItemCents(root, 'data-ds-cart-item-line-cents');
    if (lineCents === null) lineCents = unit * renderedQty;
    line.textContent = cartItemMoney(root, lineCents + unit * (mainQty - renderedQty));
  }
  // "$X each" is only meaningful once there is more than one; at 1 the line
  // total already IS the unit price.
  var each = root.querySelector(CART_ITEM_EACH);
  if (each) each.hidden = !(mainQty > 1);

  var amount = root.querySelector(CART_ITEM_TOTAL);
  var rendered = cartItemCents(root, 'data-ds-cart-item-total-cents');
  // Nothing to reason from: leave the add-ons total the caller rendered. A line
  // with no add-ons has no such row and is done after the line total above.
  if (!amount || unit === null || rendered === null) return;

  var delta = unit * (mainQty - renderedQty);
  var rows = root.querySelectorAll('[data-ds-cart-addon-line]');
  for (var j = 0; j < rows.length; j += 1) {
    var addonUnit = cartItemCents(rows[j], 'data-ds-cart-addon-line-price');
    if (addonUnit === null) continue;
    var addonRendered = cartItemCents(rows[j], 'data-ds-cart-addon-line-quantity');
    if (addonRendered === null) addonRendered = 1;
    delta += addonUnit * (cartItemQuantity(rows[j], addonRendered) - addonRendered);
  }

  amount.textContent = cartItemMoney(root, rendered + delta);
}

function cartItemTotalBusy(root, busy) {
  if (!root) return;
  var pending = Number(root.getAttribute('data-ds-cart-item-total-pending') || 0);
  pending = Math.max(0, pending + (busy ? 1 : -1));
  root.setAttribute('data-ds-cart-item-total-pending', String(pending));
  busy = pending > 0;
  var value = root.querySelector('[data-ds-cart-item-total-value]');
  var loading = root.querySelector('[data-ds-cart-item-total-loading]');
  if (value) value.hidden = busy;
  if (loading) loading.hidden = !busy;
}

if (!document.__dsCartItemTotalBound) {
  document.__dsCartItemTotalBound = true;

  // The buttons dispatch input+change on the field, so one listener covers both.
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!field || !field.closest || field.type !== 'number') return;
    cartItemSync(field.closest(CART_ITEM));
  });
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field || !field.closest || field.type !== 'number') return;
    cartItemSync(field.closest(CART_ITEM));
  });
  document.addEventListener('ds:cart:updating', function (event) {
    var detail = event.detail || {};
    if (detail.root) cartItemTotalBusy(detail.root, !!detail.busy);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-item-total" failed to initialise:', sfError);
}
})();

/* cart-lines.js */
(function () {
try {
/* cart-lines — the cart page's quantity and remove requests.
 *
 * A cross-sell add-on rides in the cart as its own independent Shopify line,
 * grouped with its main only by the hidden _bundle_group properties — Shopify has
 * no parent/child link between them and cascades nothing. So a quantity change
 * touches only the line it was made on (an add-on's quantity is independent of its
 * main's), but a REMOVAL of a main takes its add-ons with it: they are nested
 * under it on the page and must not be left behind as orphan lines. That cascade
 * is one atomic /cart/update.js; a single line (a main with no add-ons, or an
 * add-on removed on its own) still goes through /cart/change.js. The response is
 * the new truth, so the line's rendered quantities and total are restamped from it.
 *
 * A removal is IMMEDIATE: the line leaves the page optimistically and the
 * request goes to Shopify straight away — there is no undo window. If the
 * request fails the line is put back with the reason, so the page never lies
 * about the cart. A confirmation UI (ds-confirm-modal) can still ask first.
 *
 * Emits, alongside buy-buttons.js:
 *   ds:cart:updated  detail = the full cart
 *   ds:cart:error    detail = { description } | { error }
 *   ds:toast         detail = the error copy, when a removal fails — which here
 *                    means the request itself failed (offline, or the cart
 *                    rejected it), never \"sold out\": removing is a removal, and
 *                    inventory cannot refuse one
 *   ds:cart:removed  detail = { key, title, image } — a plain "removed" notice
 * and asks first, so a confirmation UI can take over:
 *   ds:cart:remove-request  cancelable, detail = { key, root, addon }
 * and listens for:
 *   ds:cart:remove-confirm  detail = { key }, from the confirmation UI
 *
 * Optimistic: the field keeps what the buyer set while the request is in flight
 * and rolls back to the rendered quantity if it fails.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */
var CART_LINE = '[data-ds-cart-item]';
var ADDON_LINE = '[data-ds-cart-addon-line]';

function cartLinesUrl(path) {
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  return (root || '/') + path;
}

function cartLinesScope(el) {
  var addon = el.closest(ADDON_LINE);
  var root = el.closest(CART_LINE);
  return {
    root: root,
    addon: addon,
    el: addon || root,
    key: (addon || root) && (addon || root).getAttribute(addon ? 'data-ds-cart-addon-line-key' : 'data-ds-cart-item-key'),
    quantityAttr: addon ? 'data-ds-cart-addon-line-quantity' : 'data-ds-cart-item-quantity',
  };
}

function cartLinesRendered(scope) {
  var raw = scope.el && scope.el.getAttribute(scope.quantityAttr);
  var value = Number(raw);
  return Number.isFinite(value) ? value : 1;
}

// Requests can overlap — typing a second quantity before the first answers — so
// the line counts them. Stamping each button with its previous state instead
// loses that state on the second call and leaves the steppers disabled for good.
function cartLinesBusy(scope, busy) {
  if (!scope.root) return;
  var inFlight = Number(scope.root.getAttribute('data-ds-cart-lines-pending') || 0);
  inFlight = Math.max(0, inFlight + (busy ? 1 : -1));
  scope.root.setAttribute('data-ds-cart-lines-pending', String(inFlight));
  scope.root.setAttribute('aria-busy', inFlight ? 'true' : 'false');
  // number-input.js owns which stepper is disabled at min/max, so let it decide
  // again by re-running its own sync instead of restoring a remembered flag.
  scope.root.querySelectorAll('[data-ds-number-input] input[type="number"]').forEach(function (input) {
    var field = input.closest('[data-ds-number-input]');
    if (!field) return;
    field.querySelectorAll('button[data-ds-number-input-decrease], button[data-ds-number-input-increase]')
      .forEach(function (button) { button.disabled = !!inFlight; });
    if (!inFlight) input.dispatchEvent(new Event('input', { bubbles: true }));
  });
}

// The buyer's own value stands until the server answers; a failure puts the
// rendered one back and lets cart-item-total.js re-read it.
function cartLinesRestore(scope) {
  var input = scope.el && scope.el.querySelector('input[type="number"]');
  if (!input) return;
  input.value = String(cartLinesRendered(scope));
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

// Restamp EVERY rendered line from the response, not just the one that made the
// request: `key` hashes variant + properties, not an id, so any line's key can
// come back different from what is still stamped in the DOM ("no valid id or
// line parameter" on every request after, until reload) — the response is the
// only place a current key can be read from. Order is what ties a DOM row back
// to its item: cart.items keeps its relative order for lines that still exist
// (a removal only closes the gap it leaves), and the page renders main rows and
// each one's add-on rows in that same order, so zipping DOM order against
// cart.items order re-identifies every row without needing a stored id at all.
function cartLinesApply(cart) {
  if (!cart || !Array.isArray(cart.items)) return;
  var addonsByGroup = {};
  cart.items.forEach(function (item) {
    var group = item.properties && item.properties._bundle_group;
    if (group && item.properties._bundle_role === 'addon') {
      (addonsByGroup[group] = addonsByGroup[group] || []).push(item);
    }
  });
  var mains = cart.items.filter(function (item) {
    return !item.properties || item.properties._bundle_role !== 'addon';
  });
  var mainIndex = 0;
  document.querySelectorAll(CART_LINE).forEach(function (root) {
    var item = mains[mainIndex];
    mainIndex += 1;
    if (!item) return;
    root.setAttribute('data-ds-cart-item-key', item.key);
    root.setAttribute('data-ds-cart-item-quantity', String(item.quantity));
    var lineOnly = Number(item.final_line_price || item.line_price || 0);
    root.setAttribute('data-ds-cart-item-line-cents', String(lineOnly));
    var total = lineOnly;
    var group = item.properties && item.properties._bundle_group;
    var siblings = (group && addonsByGroup[group]) || [];
    var addonIndex = 0;
    root.querySelectorAll('[data-ds-cart-addon-line-key]').forEach(function (row) {
      var child = siblings[addonIndex];
      addonIndex += 1;
      if (!child) return;
      row.setAttribute('data-ds-cart-addon-line-key', child.key);
      row.setAttribute('data-ds-cart-addon-line-quantity', String(child.quantity));
      total += Number(child.final_line_price || child.line_price || 0);
    });
    root.setAttribute('data-ds-cart-item-total-cents', String(total));
    var field = root.querySelector('input[type="number"]');
    if (field) field.dispatchEvent(new Event('input', { bubbles: true }));
  });
}

function cartLinesShowEmpty() {
  var form = document.querySelector('[data-ds-cart-form]');
  var live = document.querySelector('[data-ds-cart-empty-live]');
  var template = document.querySelector('[data-ds-cart-empty-template]');
  if (!live || !template || !template.content) return false;
  if (form) form.hidden = true;
  // The alert band (price-update / expiry countdown) sits in the title group
  // ABOVE the form, so hiding the form alone leaves it on an empty cart. It is a
  // filled-cart notice, so it goes with the lines. Inline display beats the
  // region's own lg:sf-flex class, which the [hidden] attribute would not.
  var alerts = document.querySelector('[data-ds-cart-alerts-region]');
  if (alerts) alerts.style.display = 'none';
  if (!live.firstElementChild) live.appendChild(template.content.cloneNode(true));
  live.hidden = false;
  return true;
}

function cartLinesHideEmpty() {
  var form = document.querySelector('[data-ds-cart-form]');
  var live = document.querySelector('[data-ds-cart-empty-live]');
  if (form) form.hidden = false;
  var alerts = document.querySelector('[data-ds-cart-alerts-region]');
  if (alerts) alerts.style.display = '';
  if (!live) return;
  live.hidden = true;
  live.textContent = '';
}

// The empty Component is already templated by the section, so the last line can
// switch views in the same frame. The response confirms the cart but never needs
// a page reload just to ask Liquid for markup we already have.
function cartLinesReloadIfEmpty(cart) {
  if (!cart || Number(cart.item_count) !== 0) return false;
  cartLinesShowEmpty();
  return true;
}

// Main products only: an add-on is not a piece of its own, so it must not swell
// the heading count either (Cross-sell Bundle spec §3.3). Mirrors the section's
// server-rendered count and dsCartMainItemCount in cart-count.js.
function cartLinesPieceCount(cart) {
  if (cart && Array.isArray(cart.items)) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i += 1) {
      var properties = cart.items[i].properties;
      if (!properties || properties._bundle_role !== 'addon') {
        n += Number(cart.items[i].quantity) || 0;
      }
    }
    return n;
  }
  return Number(cart && cart.item_count) || 0;
}

// The heading carries the count ("Shopping Cart (2)"), so it has to move with the
// cart or it keeps claiming lines that are gone.
function cartLinesTitle(cart) {
  var title = document.querySelector('[data-ds-cart-title]');
  if (!title || !cart || !Array.isArray(cart.items)) return;
  var base = title.getAttribute('data-ds-cart-title-base');
  if (base === null) {
    base = title.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    title.setAttribute('data-ds-cart-title-base', base);
  }
  var count = cartLinesPieceCount(cart);
  title.textContent = count > 0 ? base + ' (' + count + ')' : base;
}

// Removing a main changes the visible piece count with certainty; it does not
// need Shopify to recalculate prices first. Keep the heading in step with the
// detached row while totals wait for the authoritative response.
function cartLinesTitleDelta(delta) {
  var title = document.querySelector('[data-ds-cart-title]');
  if (!title || !delta) return;
  var base = title.getAttribute('data-ds-cart-title-base');
  if (base === null) {
    base = title.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    title.setAttribute('data-ds-cart-title-base', base);
  }
  var match = title.textContent.match(/\((\d+)\)\s*$/);
  var count = Math.max(0, Number(match && match[1]) + delta);
  title.textContent = count > 0 ? base + ' (' + count + ')' : base;
}

function cartLinesUpdating(entry, busy) {
  document.dispatchEvent(new CustomEvent('ds:cart:updating', {
    detail: { busy: busy, root: entry && entry.parentRoot },
  }));
}

function cartLinesFinishUpdating(entry) {
  if (!entry || !entry.loading) return;
  entry.loading = false;
  cartLinesUpdating(entry, false);
}

function cartLinesPublish(cart) {
  cartLinesApply(cart);
  window.tfxCart = cart;
  document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: cart }));
  cartLinesTitle(cart);
  cartLinesReloadIfEmpty(cart);
}

// Concurrent mutations may invalidate rendered line keys. A bundle 404 only
// proves that one old key disappeared, not that its independent add-ons did.
function cartLinesCleanupBundle(entry) {
  if (!entry.group) return Promise.resolve(false);
  return fetch(cartLinesUrl('cart.js'), {
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  }).then(function (res) {
    if (!res.ok) throw new Error('cart read failed');
    return res.json();
  }).then(function (cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties._bundle_group === entry.group) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) {
      cartLinesPublish(cart);
      return true;
    }
    return fetch(cartLinesUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) return false;
        cartLinesPublish(data);
        return true;
      });
    });
  }).catch(function () { return false; });
}

function cartLinesChange(scope, quantity, onDone) {
  if (!scope.key) return;
  cartLinesBusy(scope, true);
  fetch(cartLinesUrl('cart/change.js'), {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ id: scope.key, quantity: quantity }),
  })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    })
    .then(function (result) {
      cartLinesBusy(scope, false);
      if (!result.ok) {
        cartLinesRestore(scope);
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
        return;
      }
      cartLinesApply(result.data);
      window.tfxCart = result.data;
      document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: result.data }));
      cartLinesTitle(result.data);
      cartLinesReloadIfEmpty(result.data);
      if (onDone) onDone(result.data);
    })
    .catch(function (error) {
      cartLinesBusy(scope, false);
      cartLinesRestore(scope);
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
    });
}

var cartLinesInFlight = [];
var cartLinesScreenPending = 0;

function cartLinesScreenLoading(busy) {
  cartLinesScreenPending = Math.max(0, cartLinesScreenPending + (busy ? 1 : -1));
  var root = document.querySelector('[data-ds-cart]');
  var overlay = document.querySelector('[data-ds-cart-screen-loading]');
  if (root) root.setAttribute('aria-busy', cartLinesScreenPending ? 'true' : 'false');
  if (overlay) overlay.hidden = !cartLinesScreenPending;
}

function cartLinesAnnounceRemoved(entry) {
  if (!entry) return;
  entry.announced = true;
  document.dispatchEvent(new CustomEvent('ds:cart:removed', {
    detail: { key: entry.key, title: entry.title, image: entry.image },
  }));
}

function cartLinesDetach(entry) {
  entry.parent = entry.node.parentNode;
  entry.before = entry.node.nextElementSibling;
  if (entry.parent) entry.parent.removeChild(entry.node);
}

// A removal that failed to commit: the line the buyer watched leave comes back,
// with its optimistic count/title decrement undone.
function cartLinesRestoreNode(entry) {
  if (!entry.parent) return;
  if (entry.before && entry.before.parentNode === entry.parent) {
    entry.parent.insertBefore(entry.node, entry.before);
  } else {
    entry.parent.appendChild(entry.node);
  }
  var field = entry.node.querySelector('input[type="number"]');
  if (field) field.dispatchEvent(new Event('input', { bubbles: true }));
  if (entry.mainQuantity) {
    cartLinesTitleDelta(entry.mainQuantity);
    document.dispatchEvent(new CustomEvent('ds:cart:optimistic-count', {
      detail: { delta: entry.mainQuantity },
    }));
  }
  cartLinesFinishUpdating(entry);
  if (document.querySelector(CART_LINE)) cartLinesHideEmpty();
}

// Send the removal the buyer already saw happen. A failure here is the one case
// where the line comes back — with the reason.
function cartLinesCommit(entry) {
  // One key removes through /cart/change.js; a main dragging its add-ons out with
  // it removes them all in one atomic /cart/update.js, so the cart never shows a
  // half-gone bundle.
  var keys = entry.keys && entry.keys.length ? entry.keys : [entry.key];
  var multi = keys.length > 1;
  var payload;
  if (multi) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    payload = { updates: updates };
  } else {
    payload = { id: keys[0], quantity: 0 };
  }
  var request = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  };

  // The add-on row is already gone; its parent card is what's still on
  // screen while this request is in flight, so it carries the busy state.
  if (entry.parentRoot) cartLinesBusy({ root: entry.parentRoot }, true);
  cartLinesScreenLoading(true);
  if (!entry.loading) {
    entry.loading = true;
    cartLinesUpdating(entry, true);
  }

  var operation = fetch(cartLinesUrl(multi ? 'cart/update.js' : 'cart/change.js'), request)
    .then(function (res) {
      return res.json().then(
        function (data) { return { ok: res.ok, status: res.status, data: data }; },
        function () { return { ok: res.ok, status: res.status, data: null }; }
      );
    })
    .then(function (result) {
      if (entry.parentRoot) cartLinesBusy({ root: entry.parentRoot }, false);
      cartLinesScreenLoading(false);
      if (result.ok) {
        cartLinesPublish(result.data);
        cartLinesFinishUpdating(entry);
        if (!entry.announced) cartLinesAnnounceRemoved(entry);
        return true;
      }
      // 404 means the cart no longer has that line — another tab removed it, or
      // the cart was rebuilt. The buyer wanted it gone and it is gone, so this
      // is the outcome, not a failure: leave it removed and say nothing.
      if (result.status === 404 && multi) {
        return cartLinesCleanupBundle(entry).then(function (clean) {
          if (clean) {
            cartLinesFinishUpdating(entry);
            return true;
          }
          cartLinesUncommit(entry, '');
          return false;
        });
      }
      if (result.status === 404) {
        cartLinesFinishUpdating(entry);
        return true;
      }
      cartLinesUncommit(entry, (result.data && result.data.description) || '');
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
      return false;
    })
    .catch(function (error) {
      if (entry.parentRoot) cartLinesBusy({ root: entry.parentRoot }, false);
      cartLinesScreenLoading(false);
      // Offline, blocked, or a non-JSON answer: the line is still in the cart,
      // so put it back rather than leave the page lying about it.
      cartLinesUncommit(entry, '');
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
      return false;
    });
  cartLinesInFlight.push(operation);
  operation.then(function () {
    var index = cartLinesInFlight.indexOf(operation);
    if (index > -1) cartLinesInFlight.splice(index, 1);
  });
  return operation;
}

// The commit failed, so the line the buyer watched leave comes back — say why,
// or it reads as the page breaking.
function cartLinesUncommit(entry, description) {
  cartLinesRestoreNode(entry);
  var region = document.querySelector('[data-ds-toast-region]');
  if (!region) return;
  document.dispatchEvent(new CustomEvent('ds:toast', {
    detail: {
      highlight: entry.title || '',
      message: description || region.getAttribute('data-ds-toast-remove-failed') || 'could not be removed',
    },
  }));
}

function cartLinesLabel(node) {
  var title = node.querySelector('[data-ds-cart-item-title], [data-ds-cart-addon-line-title]');
  var image = node.querySelector('img[src]');
  return {
    title: title ? title.textContent.trim() : '',
    image: image ? image.getAttribute('src') : '',
  };
}

function cartLinesDrop(scope) {
  if (!scope.el || !scope.key) return;
  var label = cartLinesLabel(scope.el);
  // Removing a whole line takes its add-ons with it — they hang off it in the DOM
  // and, being property-grouped rather than Shopify parent/child, Shopify will not
  // drop them on its own. Removing an add-on on its own touches only that add-on.
  var keys = [scope.key];
  if (scope.root && !scope.addon) {
    scope.root.querySelectorAll('[data-ds-cart-addon-line-key]').forEach(function (row) {
      var childKey = row.getAttribute('data-ds-cart-addon-line-key');
      if (childKey && keys.indexOf(childKey) === -1) keys.push(childKey);
    });
  }
  // An add-on removed alone leaves its main's "Item total" row on the page with
  // a now-stale cents value — nothing else restamps it once the commit lands.
  var parentRoot = scope.addon ? scope.root : null;
  var entry = {
    key: scope.key, keys: keys, node: scope.el, parent: null, before: null,
    title: label.title, image: label.image, parentRoot: parentRoot,
    mainQuantity: scope.addon ? 0 : cartLinesRendered(scope), loading: false,
    group: scope.root && scope.root.getAttribute('data-ds-cart-item-bundle-group'),
    announced: false,
  };
  cartLinesDetach(entry);
  if (!document.querySelector(CART_LINE)) cartLinesShowEmpty();
  entry.loading = true;
  cartLinesUpdating(entry, true);
  if (entry.mainQuantity) {
    cartLinesTitleDelta(-entry.mainQuantity);
    document.dispatchEvent(new CustomEvent('ds:cart:optimistic-count', {
      detail: { delta: -entry.mainQuantity },
    }));
  }
  // Immediate: the line is already gone from the page, so send it now.
  cartLinesCommit(entry);
}

function cartLinesRemove(scope) {
  var request = new CustomEvent('ds:cart:remove-request', {
    cancelable: true,
    detail: { key: scope.key, root: scope.root, addon: scope.addon },
  });
  // A confirmation UI (ds-confirm-modal) cancels this and calls back once the
  // buyer has said yes; with nothing listening the removal goes straight through.
  if (!document.dispatchEvent(request)) return;
  cartLinesDrop(scope);
}

if (!document.__dsCartLinesBound) {
  document.__dsCartLinesBound = true;

  // change, not input: one request when the buyer settles, not per keystroke.
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field || !field.closest || field.type !== 'number') return;
    if (!field.closest(CART_LINE)) return;
    var scope = cartLinesScope(field);
    if (cartLinesInFlight.length) return cartLinesRestore(scope);
    var quantity = Number(field.value);
    if (!Number.isFinite(quantity) || quantity < 0) return cartLinesRestore(scope);
    if (quantity === cartLinesRendered(scope)) return;
    cartLinesChange(scope, quantity);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('[data-ds-cart-item-remove], [data-ds-cart-addon-line-remove]')
      : null;
    if (!trigger || !trigger.closest(CART_LINE)) return;
    event.preventDefault();
    if (cartLinesInFlight.length) return;
    cartLinesRemove(cartLinesScope(trigger));
  });

  // The confirmation UI re-requests the removal it cancelled.
  document.addEventListener('ds:cart:remove-confirm', function (event) {
    var key = event.detail && event.detail.key;
    if (!key) return;
    if (cartLinesInFlight.length) return;
    var el = document.querySelector(
      '[data-ds-cart-addon-line-key="' + key + '"], [data-ds-cart-item-key="' + key + '"]',
    );
    if (!el) return;
    var scope = cartLinesScope(el.querySelector('input[type="number"]') || el);
    cartLinesDrop(scope);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-lines" failed to initialise:', sfError);
}
})();

/* cart-photo-lightbox.js */
(function () {
try {
/* cart-photo-lightbox — opens a cart line's personalization photos in the
 * gallery viewer (ds-cart-photo-lightbox). Any element with [data-ds-cart-photo]
 * carries data-ds-cart-photo-target="<overlay id>" and data-ds-cart-photo-index;
 * clicking it opens that line's overlay ON the clicked photo.
 *
 * The viewer itself — track, chevrons, counter, rail — is a plain ds-gallery, so
 * behaviors/gallery.js drives it; this behavior only opens/closes the dialog,
 * jumps it to the clicked photo (`ds:gallery:set`, instant), and retitles the
 * header to the active photo's file name as the shopper steps through. Titles
 * come off the overlay's data-ds-cart-photo-lightbox-titles JSON, so retitling
 * never has to read the gallery's slide markup.
 *
 * It owns only the dialog: open/close, portal to <body> (so a transformed/sticky
 * ancestor never traps its z-index — same reason as media-lightbox.js), scroll
 * lock, focus trap + restore. Progressive enhancement: without this script the
 * card thumbnails are plain images and nothing opens.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsCartPhotoLightboxBound) return;
  document.__dsCartPhotoLightboxBound = true;

  var lastTrigger = null;
  var titleObserver = null;

  // Portal the overlay to <body>: a cart line can sit in a stacking context
  // (transforms during row updates), which would trap a fixed overlay's
  // z-index. Drops any stale twin a section re-render left with the same id.
  function hoist(overlay) {
    if (!overlay) return overlay;
    if (overlay.id) {
      document.querySelectorAll('[data-ds-cart-photo-lightbox]').forEach(function (el) {
        if (el !== overlay && el.id === overlay.id && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    }
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    return overlay;
  }

  function hoistAll() {
    document.querySelectorAll('[data-ds-cart-photo-lightbox]').forEach(hoist);
  }

  function isOpen(overlay) {
    return !!overlay && overlay.getAttribute('aria-hidden') === 'false';
  }

  function openOverlayEl() {
    var list = document.querySelectorAll('[data-ds-cart-photo-lightbox]');
    for (var i = 0; i < list.length; i++) {
      if (isOpen(list[i])) return list[i];
    }
    return null;
  }

  function titlesFor(overlay) {
    var raw = overlay.getAttribute('data-ds-cart-photo-lightbox-titles');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setTitle(overlay, index) {
    var titleEl = overlay.querySelector('[data-ds-cart-photo-lightbox-title]');
    if (!titleEl) return;
    var titles = titlesFor(overlay);
    var name = titles[index];
    if (name) titleEl.textContent = name;
  }

  // Retitle the header whenever the gallery moves to another slide, by watching
  // its active-index attribute — no dependency on gallery.js emitting an event.
  function watchTitle(overlay, gallery) {
    if (titleObserver) titleObserver.disconnect();
    if (!gallery || typeof MutationObserver === 'undefined') return;
    titleObserver = new MutationObserver(function () {
      setTitle(overlay, Number(gallery.dataset.dsGalleryActive || 0));
    });
    titleObserver.observe(gallery, {
      attributes: true,
      attributeFilter: ['data-ds-gallery-active'],
    });
  }

  function open(trigger) {
    var id = trigger.getAttribute('data-ds-cart-photo-target');
    var overlay = id ? hoist(document.getElementById(id)) : null;
    if (!overlay) return;

    var index = Number(trigger.getAttribute('data-ds-cart-photo-index') || 0);
    lastTrigger = trigger;

    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    // Jump the gallery straight to the clicked photo — instant, so the viewer
    // opens already on that slide instead of sliding to it.
    var gallery = overlay.querySelector('[data-ds-gallery]');
    if (gallery) {
      gallery.dispatchEvent(
        new CustomEvent('ds:gallery:set', {
          bubbles: true,
          detail: { index: index, instant: true },
        }),
      );
      watchTitle(overlay, gallery);
    }
    setTitle(overlay, index);

    var close = overlay.querySelector('[data-ds-cart-photo-lightbox-close]');
    if (close) window.requestAnimationFrame(function () { close.focus(); });
  }

  function close(overlay) {
    if (!overlay) return;
    if (titleObserver) { titleObserver.disconnect(); titleObserver = null; }
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function trapTab(e, overlay) {
    var dialog = overlay.querySelector('[data-ds-cart-photo-lightbox-dialog]') || overlay;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var closeBtn = e.target.closest('[data-ds-cart-photo-lightbox-close]');
    if (closeBtn) {
      e.preventDefault();
      close(closeBtn.closest('[data-ds-cart-photo-lightbox]'));
      return;
    }

    var trigger = e.target.closest('[data-ds-cart-photo]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    // Click the dimmed backdrop (the overlay itself, not its card) to close.
    var overlay = e.target.closest('[data-ds-cart-photo-lightbox]');
    if (overlay && isOpen(overlay) && e.target === overlay) close(overlay);
  });

  document.addEventListener('keydown', function (e) {
    var overlay = openOverlayEl();
    if (overlay) {
      if (e.key === 'Escape') { close(overlay); return; }
      if (e.key === 'Tab') { trapTab(e, overlay); return; }
      return;
    }
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var trigger = e.target.closest && e.target.closest('[data-ds-cart-photo]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
      }
    }
  });

  // Portal up front so the first open never flashes trapped under a sibling row.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistAll, { once: true });
  } else {
    hoistAll();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-photo-lightbox" failed to initialise:', sfError);
}
})();

/* cart-popover.js */
(function () {
try {
/* cart-popover — keeps the header mini-cart honest after an AJAX cart change.
 * Pure restamp from the ds:cart:updated payload (the full cart, already fetched
 * by buy-buttons.js / cart-lines.js): no network of its own, the same contract
 * cart-summary.js has for the Order Summary.
 *
 * Open/close is NOT here. Hovering the anchor is what opens the panel and CSS
 * does that natively — src/cart-popover.css. This file only rewrites contents,
 * so without it the popover still shows what Liquid rendered on page load.
 *
 * Lines are rebuilt from the two <template>s the snippet ships, so the restamped
 * markup is the same markup Liquid renders. An add-on is nested under the product
 * it rides with, never listed on its own (Cross-sell Bundle spec §3.3).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CART_POPOVER = '[data-ds-cart-popover]';

function cartPopoverMoney(root, cents) {
  var format = (root.getAttribute('data-ds-cart-popover-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
}

// Same test as cart-count.js: an add-on is a child line, not a piece of its own.
function cartPopoverIsAddon(item) {
  if (!item) return false;
  var properties = item.properties;
  return Boolean(item.parent_relationship || (properties && properties._bundle_role === 'addon'));
}

function cartPopoverImage(item) {
  var src = (item && item.properties && item.properties['_customily-preview']) || '';
  if (!src) src = (item && (item.image || item.featured_image)) || '';
  if (src && src.url) src = src.url;
  return src || '';
}

function cartPopoverSet(root, selector, text) {
  var el = root.querySelector(selector);
  if (el) el.textContent = text;
}

function cartPopoverToggle(el, on) {
  if (!el) return;
  el.hidden = !on;
}

function cartPopoverFillImage(node, selector, src, alt) {
  var image = node.querySelector(selector);
  if (!image) return;
  if (src) {
    image.src = src;
    image.alt = alt || '';
    image.removeAttribute('hidden');
  } else {
    image.setAttribute('hidden', '');
  }
}

function cartPopoverFillText(node, selector, text, hideWhenBlank) {
  var el = node.querySelector(selector);
  if (!el) return;
  el.textContent = text || '';
  if (!hideWhenBlank) return;
  if (text) el.removeAttribute('hidden');
  else el.setAttribute('hidden', '');
}

function cartPopoverAddonNode(root, addon) {
  var template = root.querySelector('[data-ds-cart-popover-addon-template]');
  if (!template || !template.content.firstElementChild) return null;
  var node = template.content.firstElementChild.cloneNode(true);
  var title = addon.product_title || addon.title || '';
  cartPopoverFillImage(node, '[data-ds-cart-addon-image]', cartPopoverImage(addon), '');
  cartPopoverFillText(node, '[data-ds-cart-addon-title]', title, false);
  // "Default Title" is what Shopify sends for a product with no real options.
  var variant = addon.variant_title && addon.variant_title !== 'Default Title' ? addon.variant_title : '';
  cartPopoverFillText(node, '[data-ds-cart-addon-variant]', variant, true);
  cartPopoverFillText(node, '[data-ds-cart-addon-price]', cartPopoverMoney(root, addon.final_line_price), false);
  return node;
}

function cartPopoverLineNode(root, item, addons) {
  var template = root.querySelector('[data-ds-cart-popover-line-template]');
  if (!template || !template.content.firstElementChild) return null;
  var node = template.content.firstElementChild.cloneNode(true);
  var title = item.product_title || item.title || '';

  cartPopoverFillImage(node, '[data-ds-cart-popover-line-image]', cartPopoverImage(item), title);
  var titleEl = node.querySelector('[data-ds-cart-popover-line-title]');
  if (titleEl) {
    titleEl.textContent = title;
    if (item.url && titleEl.tagName === 'A') titleEl.setAttribute('href', item.url);
  }
  var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
  cartPopoverFillText(node, '[data-ds-cart-popover-line-variant]', variant, true);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-quantity]', String(Number(item.quantity) || 1), false);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-price]', cartPopoverMoney(root, item.final_price), false);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-total]', cartPopoverMoney(root, item.final_line_price), false);

  var list = node.querySelector('[data-ds-cart-popover-line-addons]');
  if (list) {
    list.textContent = '';
    addons.forEach(function (addon) {
      var row = cartPopoverAddonNode(root, addon);
      if (row) list.appendChild(row);
    });
    cartPopoverToggle(list, addons.length > 0);
  }
  return node;
}

// The add-ons of one main line: they share its _bundle_group, which is the only
// grouping this cart uses (the Cart AJAX API cannot set a parent_id).
function cartPopoverAddonsOf(items, item) {
  var group = item.properties && item.properties._bundle_group;
  if (!group) return [];
  return items.filter(function (candidate) {
    return (
      cartPopoverIsAddon(candidate) &&
      candidate.properties &&
      candidate.properties._bundle_group === group
    );
  });
}

function cartPopoverApply(root, cart) {
  var items = Array.isArray(cart.items) ? cart.items : [];
  var mains = items.filter(function (item) {
    return !cartPopoverIsAddon(item);
  });

  var list = root.querySelector('[data-ds-cart-popover-lines]');
  if (list) {
    list.textContent = '';
    mains.forEach(function (item) {
      var node = cartPopoverLineNode(root, item, cartPopoverAddonsOf(items, item));
      if (node) list.appendChild(node);
    });
    cartPopoverToggle(list, mains.length > 0);
  }

  var count = mains.reduce(function (total, item) {
    return total + (Number(item.quantity) || 0);
  }, 0);
  cartPopoverSet(root, '[data-ds-cart-popover-count]', '(' + count + ')');

  cartPopoverToggle(root.querySelector('[data-ds-cart-popover-empty]'), mains.length === 0);
  cartPopoverToggle(root.querySelector('[data-ds-cart-popover-footer]'), mains.length > 0);

  cartPopoverSet(root, '[data-ds-cart-popover-subtotal]', cartPopoverMoney(root, cart.items_subtotal_price));
  cartPopoverSet(root, '[data-ds-cart-popover-total]', cartPopoverMoney(root, cart.total_price));

  var discountCents = Number(cart.total_discount || 0);
  cartPopoverToggle(root.querySelector('[data-ds-cart-popover-discount-row]'), discountCents > 0);
  if (discountCents > 0) {
    cartPopoverSet(root, '[data-ds-cart-popover-discount]', '-' + cartPopoverMoney(root, discountCents));
  }
}

function cartPopoverBusy(root, busy) {
  if (!root) return;
  var pending = Number(root.getAttribute('data-ds-cart-popover-pending') || 0);
  pending = Math.max(0, pending + (busy ? 1 : -1));
  root.setAttribute('data-ds-cart-popover-pending', String(pending));
  busy = pending > 0;
  root.setAttribute('aria-busy', busy ? 'true' : 'false');
  root.querySelectorAll('[data-ds-cart-popover-subtotal], [data-ds-cart-popover-total]').forEach(function (el) {
    el.hidden = busy;
  });
  root.querySelectorAll('[data-ds-cart-popover-loading]').forEach(function (el) {
    el.hidden = !busy;
  });
  var pendingEl = root.querySelector('[data-ds-cart-popover-pending]');
  if (pendingEl) pendingEl.hidden = !busy;
  if (busy) {
    ['[data-ds-cart-popover-empty]', '[data-ds-cart-popover-lines]', '[data-ds-cart-popover-footer]']
      .forEach(function (selector) {
        var el = root.querySelector(selector);
        if (el) el.hidden = true;
      });
  }
}

if (!document.__dsCartPopoverBound) {
  document.__dsCartPopoverBound = true;

  document.addEventListener('ds:cart:updated', function (event) {
    var cart = event.detail;
    if (!cart || !Array.isArray(cart.items)) return;
    document.querySelectorAll(CART_POPOVER).forEach(function (root) {
      cartPopoverApply(root, cart);
    });
  });

  document.addEventListener('ds:cart:updating', function (event) {
    document.querySelectorAll(CART_POPOVER).forEach(function (root) {
      cartPopoverBusy(root, !!(event.detail && event.detail.busy));
    });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-popover" failed to initialise:', sfError);
}
})();

/* cart-summary.js */
(function () {
try {
/* cart-summary — keeps the Order Summary honest after a quantity change. Pure
 * restamp from the /cart/change.js response cart-lines.js already fetched: no
 * network of its own.
 *
 * It moves Subtotal, Discount and Estimated Total (plus the mobile sticky bar
 * total/saving) to the numbers the server
 * returned, toggling the Discount and "You're saving" rows when a saving appears
 * or clears. Shipping and Tax stay estimate copy — Shopify only knows them at
 * checkout — so they are never rewritten. A summary without the *-cents anchors
 * (a bare render, Storybook) is left exactly as drawn.
 *
 * Listens for ds:cart:updated (detail = the full cart). Binds data-ds-* only.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */
var CART_SUMMARY = '[data-ds-cart-summary]';

function cartSummaryMoney(root, cents) {
  var format = (root.getAttribute('data-ds-cart-summary-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
}

function cartSummarySet(root, selector, text) {
  var el = root.querySelector(selector);
  if (el) el.textContent = text;
}

function cartSummaryCount(root, count) {
  cartSummarySet(root, '[data-ds-cart-summary-count-value]', String(count));
  var word = root.querySelector('[data-ds-cart-summary-items-word]');
  if (word) {
    word.textContent = count === 1 ? word.getAttribute('data-one') : word.getAttribute('data-other');
  }
}

function cartSummaryToggle(el, on) {
  if (!el) return;
  el.hidden = !on;
  el.style.display = on ? '' : 'none';
}

function cartSummaryApply(root, cart) {
  if (!root || !cart) return;

  if (Array.isArray(cart.items)) {
    var count = cart.items.reduce(function (total, item) {
      var properties = item && item.properties;
      var addon = item && (item.parent_relationship || (properties && properties._bundle_role === 'addon'));
      return addon ? total : total + (Number(item && item.quantity) || 0);
    }, 0);
    root.setAttribute('data-ds-cart-summary-count', String(count));
    cartSummaryCount(root, count);
  }

  if (typeof cart.items_subtotal_price === 'number') {
    root.setAttribute('data-ds-cart-summary-subtotal-cents', String(cart.items_subtotal_price));
    cartSummarySet(root, '[data-ds-cart-summary-subtotal]', cartSummaryMoney(root, cart.items_subtotal_price));
  }
  if (typeof cart.total_price === 'number') {
    root.setAttribute('data-ds-cart-summary-total-cents', String(cart.total_price));
    cartSummarySet(root, '[data-ds-cart-summary-total]', cartSummaryMoney(root, cart.total_price));
  }

  var discountCents = Number(cart.total_discount || 0);
  var discountRow = root.querySelector('[data-ds-cart-summary-discount-row]');
  if (discountRow) {
    cartSummaryToggle(discountRow, discountCents > 0);
    if (discountCents > 0) {
      cartSummarySet(root, '[data-ds-cart-summary-discount]', '-' + cartSummaryMoney(root, discountCents));
    }
  }

  // Original minus charged: compare-at plus discounts, the whole saving.
  var savingCents = Number(cart.original_total_price || 0) - Number(cart.total_price || 0);
  var savingRow = root.querySelector('[data-ds-cart-summary-saving]');
  if (savingRow) {
    cartSummaryToggle(savingRow, savingCents > 0);
    if (savingCents > 0) {
      cartSummarySet(root, '[data-ds-cart-summary-saving-amount]', cartSummaryMoney(root, savingCents));
    }
  }
}


/* Sticky checkout bar total/saving sit OUTSIDE [data-ds-cart-summary] (on
 * [data-ds-cart-checkout-sticky]), so cartSummaryApply never reaches them.
 * Mirror total + saving here from the same cart payload. */
function cartSummaryApplyStickyBar(cart) {
  if (!cart) return;
  var bars = document.querySelectorAll('[data-ds-cart-checkout-sticky]');
  if (!bars.length) return;
  var formatRoot =
    document.querySelector(CART_SUMMARY + '[data-ds-cart-summary-money]') ||
    document.querySelector(CART_SUMMARY);
  if (!formatRoot) return;

  var totalText =
    typeof cart.total_price === 'number' ? cartSummaryMoney(formatRoot, cart.total_price) : '';
  var savingCents = Number(cart.original_total_price || 0) - Number(cart.total_price || 0);

  bars.forEach(function (bar) {
    if (totalText) {
      var totalEl = bar.querySelector('[data-ds-cart-summary-total]');
      if (totalEl) totalEl.textContent = totalText;
    }
    var savingRow = bar.querySelector('[data-ds-cart-summary-saving]');
    if (!savingRow) return;
    cartSummaryToggle(savingRow, savingCents > 0);
    if (savingCents > 0) {
      var amt = bar.querySelector('[data-ds-cart-summary-saving-amount]');
      if (amt) amt.textContent = cartSummaryMoney(formatRoot, savingCents);
    }
  });
}

function cartSummaryBusy(root, busy) {
  if (!root) return;
  var pending = Number(root.getAttribute('data-ds-cart-summary-pending') || 0);
  pending = Math.max(0, pending + (busy ? 1 : -1));
  root.setAttribute('data-ds-cart-summary-pending', String(pending));
  busy = pending > 0;
  root.setAttribute('aria-busy', busy ? 'true' : 'false');
  root.querySelectorAll('[data-ds-cart-summary-subtotal], [data-ds-cart-summary-total]').forEach(function (el) {
    el.hidden = busy;
  });
  root.querySelectorAll('[data-ds-cart-summary-loading]').forEach(function (el) {
    el.hidden = !busy;
  });
  if (busy) {
    root.querySelectorAll('[data-ds-cart-summary-discount-row], [data-ds-cart-summary-saving]').forEach(function (el) {
      el.hidden = true;
      el.style.display = 'none';
    });
  }
}

if (!document.__dsCartSummaryBound) {
  document.__dsCartSummaryBound = true;

  document.addEventListener('ds:cart:updated', function (event) {
    var cart = event.detail;
    if (!cart || !Array.isArray(cart.items)) return;
    document.querySelectorAll(CART_SUMMARY).forEach(function (root) {
      cartSummaryApply(root, cart);
    });
    cartSummaryApplyStickyBar(cart);
  });

  document.addEventListener('ds:cart:updating', function (event) {
    document.querySelectorAll(CART_SUMMARY).forEach(function (root) {
      cartSummaryBusy(root, !!(event.detail && event.detail.busy));
    });
  });

  document.addEventListener('ds:cart:optimistic-count', function (event) {
    var delta = Number(event.detail && event.detail.delta) || 0;
    if (!delta) return;
    document.querySelectorAll(CART_SUMMARY).forEach(function (root) {
      var count = Math.max(0, Number(root.getAttribute('data-ds-cart-summary-count') || 0) + delta);
      root.setAttribute('data-ds-cart-summary-count', String(count));
      cartSummaryCount(root, count);
    });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-summary" failed to initialise:', sfError);
}
})();

/* checkbox.js */
(function () {
try {
/* checkbox — apply the mixed (indeterminate) state, which is a DOM property
 * with no HTML attribute. Binds [data-ds-checkbox-indeterminate] (see
 * snippets/ds-checkbox.liquid). A MutationObserver re-applies it to checkboxes
 * added after load (Theme Editor section re-render, async mounts).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function applyIndeterminate(scope) {
  scope.querySelectorAll('[data-ds-checkbox-indeterminate]').forEach(function (input) {
    input.indeterminate = true;
  });
}

if (!document.__dsCheckboxBound) {
  document.__dsCheckboxBound = true;
  var start = function () {
    applyIndeterminate(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) applyIndeterminate(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "checkbox" failed to initialise:', sfError);
}
})();

/* checkout-loading.js */
(function () {
try {
/* checkout-loading — the Checkout button's busy state, from click to navigation.
 *
 * The handover to Shopify is silent on a slow connection: nothing on screen
 * changes until the checkout document arrives, so the buyer clicks again. This
 * appends a spinner absolute to the right edge so the label stays centred,
 * sets aria-busy and swallows further clicks — whether the control is the cart
 * form's submit (name="checkout"), the ATC modal's link, or the cart popover's.
 *
 * `disabled` is deliberately NOT set: on the cart page the control is the form's
 * submitter and carries name="checkout", which a disabled button drops — and
 * cart-lines.js re-submits through it (requestSubmit(target)) after flushing a
 * deferred removal. Pointer-events + a click guard block the double-submit
 * without touching what gets posted.
 *
 * The state normally ends with the page going away, and is restored on the
 * paths where it cannot: a cart error, bfcache restore, and a safety timeout
 * for the handovers that quietly never happen.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */
var CHECKOUT_LOADING = '[data-ds-cart-checkout], [data-ds-cart-popover-checkout], [name="checkout"]';

// Match the button's own icon size. The start icon, when there is one, states
// it outright through its `sf-h-icon-*` class; without one there is nothing on
// the button that names its icon step, so fall back to md (20px), what
// ds-button draws everywhere except its s step.
function checkoutLoadingIconSize(el) {
  var icon = el.querySelector(':scope > svg[data-ds-icon]');
  var match = icon && /(?:^|\s)sf-h-icon-([a-z]+)(?:\s|$)/.exec(icon.getAttribute('class') || '');
  return match ? match[1] : 'md';
}

function checkoutLoadingIcon(el) {
  var size = checkoutLoadingIconSize(el);
  var span = document.createElement('span');
  // Absolute to the right edge so the Checkout label stays centred.
  span.className = 'sf-absolute sf-right-3 sf-animate-spin sf-inline-flex';
  span.setAttribute('data-ds-checkout-loading-spinner', '');
  span.innerHTML =
    '<svg class="sf-h-icon-' + size + ' sf-w-icon-' + size + ' sf-shrink-0" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"' +
    ' stroke-linejoin="round" aria-hidden="true" focusable="false" data-ds-icon="spinner">' +
    '<path d="M12 3a9 9 0 1 0 9 9" /></svg>';
  return span;
}

// Nothing here is certain to navigate: a click may be cancelled downstream, or
// the cart may answer without a toast. The timer is the last resort that hands
// the button back rather than leaving it busy forever.
var CHECKOUT_LOADING_TIMEOUT = 15000;

function checkoutLoadingArmTimeout(el) {
  clearTimeout(el.__dsCheckoutLoadingTimer);
  el.__dsCheckoutLoadingTimer = setTimeout(function () {
    checkoutLoadingStop(el);
  }, CHECKOUT_LOADING_TIMEOUT);
}

function checkoutLoadingStart(el) {
  if (!el || el.hasAttribute('data-ds-checkout-loading')) return;
  el.setAttribute('data-ds-checkout-loading', '');
  el.setAttribute('aria-busy', 'true');
  el.classList.add('sf-pointer-events-none', 'sf-relative');
  // Absolute spinner at the right edge. Dim the label; hide any existing end
  // icon so only the spinner shows.
  var label = el.querySelector(':scope > span');
  if (label) label.classList.add('sf-opacity-70');
  var icon = el.querySelector(':scope > svg[data-ds-icon]');
  if (icon) icon.setAttribute('hidden', '');
  el.appendChild(checkoutLoadingIcon(el));
  checkoutLoadingArmTimeout(el);
}

function checkoutLoadingStop(el) {
  if (!el || !el.hasAttribute('data-ds-checkout-loading')) return;
  clearTimeout(el.__dsCheckoutLoadingTimer);
  el.__dsCheckoutLoadingTimer = null;
  el.removeAttribute('data-ds-checkout-loading');
  el.setAttribute('aria-busy', 'false');
  el.classList.remove('sf-pointer-events-none', 'sf-relative');
  var spinner = el.querySelector('[data-ds-checkout-loading-spinner]');
  if (spinner && spinner.parentNode) spinner.parentNode.removeChild(spinner);
  var label = el.querySelector(':scope > span.sf-opacity-70');
  if (label) label.classList.remove('sf-opacity-70');
  var icon = el.querySelector(':scope > svg[data-ds-icon]');
  if (icon) icon.removeAttribute('hidden');
}

function checkoutLoadingStopAll() {
  document.querySelectorAll('[data-ds-checkout-loading]').forEach(checkoutLoadingStop);
}

if (!document.__dsCheckoutLoadingBound) {
  document.__dsCheckoutLoadingBound = true;

  // Some storefronts run a search/analytics app (Searchanise was the one caught)
  // that binds a delegated click on the cart form's Checkout button to record a
  // conversion: it preventDefaults the buyer's first click, fires its beacon, then
  // re-fires the click synthetically — and a synthetic click never submits the
  // form, so the handover silently never happens and the buyer has to click a
  // second time (the app also stamps the button, so the second click gets through).
  // Beat it in the CAPTURE phase, which always runs before a delegated bubble
  // handler: on the first real click, start the busy state and submit the cart
  // form ourselves, then stop the event so the app can't swallow it. Scoped to the
  // form's name="checkout" submit; the popover/modal checkout links are plain
  // navigations and fall through to the handler below.
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('[name="checkout"]') : null;
    if (!el) return;
    var form = el.form || (el.closest && el.closest('form'));
    if (!form) return;
    if (el.hasAttribute('data-ds-checkout-loading')) {
      event.preventDefault();
      return;
    }
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // Ours is the only submission — cancel the native one so the form is not
    // posted twice, and stop the app's bubble handler from ever seeing the click.
    event.preventDefault();
    event.stopPropagation();
    checkoutLoadingStart(el);
    if (form.requestSubmit) form.requestSubmit(el);
    else form.submit();
  }, true);

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest(CHECKOUT_LOADING) : null;
    if (!el) return;
    // Already handed over — this click must not post the cart form again.
    if (el.hasAttribute('data-ds-checkout-loading')) {
      event.preventDefault();
      return;
    }
    // Neither of these hands over to checkout: a cancelled click goes nowhere,
    // and a middle/modified click opens a tab while this page stays put.
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    checkoutLoadingStart(el);
  });

  document.addEventListener('ds:cart:error', checkoutLoadingStopAll);
  // A failed commit reports itself only through the toast on one path, and
  // nothing else raises one while a checkout is in flight.
  document.addEventListener('ds:toast', checkoutLoadingStopAll);

  // Back from checkout: bfcache restores the DOM it was frozen with.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) checkoutLoadingStopAll();
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "checkout-loading" failed to initialise:', sfError);
}
})();

/* collapsible.js */
(function () {
try {
/* collapsible — clamp long content with a Show more / Show less toggle.
 * Binds [data-ds-collapsible] and data-ds-collapsible-{viewport,toggle}
 * (see snippets/ds-collapsible.liquid). The snippet ships fully expanded with
 * the toggle hidden; on init we measure the viewport against its clamp height
 * and, only when it overflows, collapse it and reveal the toggle. Content that
 * already fits loses the toggle entirely. Without this JS the content stays
 * visible in full — nothing hides behind a control that cannot open.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function bindCollapsible(el) {
  if (el.dataset.dsCollapsibleBound) return;
  var viewport = el.querySelector('[data-ds-collapsible-viewport]');
  var toggle = el.querySelector('[data-ds-collapsible-toggle]');
  if (!viewport || !toggle) return;
  el.dataset.dsCollapsibleBound = '1';

  // Measure against the clamp: collapse, read whether content is taller than
  // the capped viewport, then keep it collapsed (with the toggle) only if so.
  el.setAttribute('data-collapsed', 'true');
  var overflows = viewport.scrollHeight - viewport.clientHeight > 1;
  if (!overflows) {
    el.removeAttribute('data-collapsed');
    return;
  }
  toggle.hidden = false;
  toggle.setAttribute('aria-expanded', 'false');
}

function initCollapsibles(scope) {
  (scope || document).querySelectorAll('[data-ds-collapsible]').forEach(bindCollapsible);
}

function animateCollapsible(el, viewport, collapsed) {
  var version = (el.__dsCollapsibleMotion || 0) + 1;
  el.__dsCollapsibleMotion = version;

  if (viewport.__dsCollapsibleEnd) {
    viewport.removeEventListener('transitionend', viewport.__dsCollapsibleEnd);
  }

  // Start from the height that is actually painted. This also makes a second
  // click during a running transition reverse smoothly from its current point.
  var from = viewport.getBoundingClientRect().height;
  var clamp = parseFloat(getComputedStyle(viewport).getPropertyValue('--collapse-max-height'));
  var to = collapsed ? Math.min(viewport.scrollHeight, clamp) : viewport.scrollHeight;

  viewport.style.maxHeight = from + 'px';
  el.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
  // Commit the start length before scheduling the destination length. A
  // transition cannot interpolate to/from `none`, which was the original snap.
  void viewport.offsetHeight;

  var finish = function (event) {
    if (event.target !== viewport || event.propertyName !== 'max-height') return;
    if (el.__dsCollapsibleMotion !== version) return;
    viewport.style.maxHeight = '';
    viewport.removeEventListener('transitionend', finish);
    viewport.__dsCollapsibleEnd = null;
  };
  viewport.__dsCollapsibleEnd = finish;
  viewport.addEventListener('transitionend', finish);

  requestAnimationFrame(function () {
    if (el.__dsCollapsibleMotion !== version) return;
    viewport.style.maxHeight = to + 'px';
  });
}

function restoreCollapsibleItemPosition(el) {
  var target = el.closest('[data-ds-accordion]') || el;
  var rect = target.getBoundingClientRect();
  if (rect.top >= 0) return;

  var top = rect.top + window.scrollY;
  // The viewport height is already animating. A simultaneous smooth scroll
  // creates a second, competing motion and can chase a moving layout target.
  // Reposition immediately so the height transition remains the only motion.
  window.scrollTo({
    top: Math.max(0, Math.round(top)),
    behavior: 'auto',
  });
}

if (!document.__dsCollapsibleBound) {
  document.__dsCollapsibleBound = true;

  var run = function () { initCollapsibles(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  // Theme Editor section re-render and any async-swapped section (e.g. the PDP).
  document.addEventListener('shopify:section:load', run);

  // Content injected after load (Storybook mount, lazy sections): re-scan on the
  // next frame. bindCollapsible is guarded per element, so re-runs are cheap.
  if (typeof MutationObserver !== 'undefined') {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-ds-collapsible-toggle]');
    if (!toggle) return;
    var el = toggle.closest('[data-ds-collapsible]');
    if (!el) return;
    var collapsed = el.getAttribute('data-collapsed') === 'true';
    animateCollapsible(el, el.querySelector('[data-ds-collapsible-viewport]'), !collapsed);
    if (!collapsed) restoreCollapsibleItemPosition(el);
    toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    var next = collapsed ? toggle.getAttribute('data-label-less') : toggle.getAttribute('data-label-more');
    if (next) toggle.textContent = next;
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "collapsible" failed to initialise:', sfError);
}
})();

/* confirm-modal.js */
(function () {
try {
/* confirm-modal — holds a destructive action until the buyer says yes.
 *
 * cart-lines.js fires a cancelable ds:cart:remove-request before it touches the
 * cart; this cancels it, fills the dialog from the line that asked, and answers
 * with ds:cart:remove-confirm when the buyer confirms. Nothing else in core
 * knows about the dialog, so a page without one removes straight away.
 *
 * Open/closed is [aria-hidden]; src/confirm-modal.css carries the motion. Focus
 * is trapped while open and returned to whatever opened it.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CONFIRM_MODAL = '[data-ds-confirm-modal]';
var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

var confirmModalReturn = null;
var confirmModalKey = '';
var confirmModalScroll = '';

function confirmModalEl() {
  return document.querySelector(CONFIRM_MODAL);
}

function confirmModalFill(root, line, addon) {
  var source = addon || line;
  var set = function (hook, value) {
    var el = root.querySelector(hook);
    if (el && value !== null && value !== undefined) el.textContent = value;
  };
  var title = source.querySelector('[data-ds-cart-item-title], [data-ds-cart-addon-line-title]');
  set('[data-ds-confirm-modal-product]', title ? title.textContent.trim() : '');

  // The variant line is the options list, joined between its items — joining the
  // wrapper's text instead puts the separator inside each option.
  var options = addon
    ? [addon.querySelector('[data-ds-cart-addon-line-title] + p')]
    : [].slice.call(line.querySelectorAll('[data-ds-cart-item-title] + div > *'));
  set('[data-ds-confirm-modal-variant]', options
    .filter(Boolean)
    .map(function (el) { return el.textContent.trim(); })
    .filter(Boolean)
    .join(' · '));

  var price = source.querySelector('[data-ds-price-amount], [data-ds-cart-addon-line-amount]');
  var amount = root.querySelector('[data-ds-confirm-modal-price] [data-ds-price-amount]');
  if (amount && price) amount.textContent = price.textContent.trim();

  var from = source.querySelector('img');
  var into = root.querySelector('[data-ds-confirm-modal-image]');
  if (into && from && from.getAttribute('src')) {
    into.src = from.getAttribute('src');
    into.alt = from.getAttribute('alt') || '';
    into.removeAttribute('hidden');
  } else if (into) {
    into.setAttribute('hidden', '');
  }
}

function confirmModalClose(root) {
  if (!root || root.getAttribute('aria-hidden') === 'true') return;
  root.setAttribute('aria-hidden', 'true');
  root.removeAttribute('data-ds-confirm-modal-key');
  // Put back whatever was there: another dialog (ds-cart-added) may still be
  // open and holding its own lock.
  document.body.style.overflow = confirmModalScroll;
  confirmModalKey = '';
  if (confirmModalReturn && confirmModalReturn.focus) confirmModalReturn.focus();
  confirmModalReturn = null;
}

function confirmModalOpen(root, detail) {
  confirmModalKey = detail.key || '';
  root.setAttribute('data-ds-confirm-modal-key', confirmModalKey);
  if (detail.root) confirmModalFill(root, detail.root, detail.addon);

  confirmModalReturn = document.activeElement;
  confirmModalScroll = document.body.style.overflow;
  root.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  // Focus the safe action, after paint so the sheet is on screen first.
  window.requestAnimationFrame(function () {
    var keep = root.querySelector('[data-ds-confirm-modal-cancel]');
    if (keep) keep.focus();
  });
}

function confirmModalTrap(root, event) {
  var items = [].slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
    return el.offsetParent !== null;
  });
  if (!items.length) return;
  var first = items[0];
  var last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

if (!document.__dsConfirmModalBound) {
  document.__dsConfirmModalBound = true;

  document.addEventListener('ds:cart:remove-request', function (event) {
    var root = confirmModalEl();
    if (!root) return;
    event.preventDefault();
    confirmModalOpen(root, event.detail || {});
  });

  document.addEventListener('click', function (event) {
    var root = confirmModalEl();
    if (!root || root.getAttribute('aria-hidden') !== 'false') return;
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-ds-confirm-modal-confirm]')) {
      var key = confirmModalKey;
      confirmModalClose(root);
      document.dispatchEvent(new CustomEvent('ds:cart:remove-confirm', { detail: { key: key } }));
      return;
    }
    if (target.closest('[data-ds-confirm-modal-cancel]') || target.closest('[data-ds-confirm-modal-close]')) {
      confirmModalClose(root);
      return;
    }
    // The scrim is the root itself; a click inside the card must not close it.
    if (target === root) confirmModalClose(root);
  });

  document.addEventListener('keydown', function (event) {
    var root = confirmModalEl();
    if (!root || root.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') {
      confirmModalClose(root);
    } else if (event.key === 'Tab') {
      confirmModalTrap(root, event);
    }
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "confirm-modal" failed to initialise:', sfError);
}
})();

/* customer-reviews.js */
(function () {
try {
/* customer-reviews — fills the homepage band from Judge.me's featured carousel.
 *
 * Why this exists at all: the band's aggregate has always been real (Judge.me
 * writes the shop average and count into shop metafields), but the CARDS were
 * hand-typed section blocks. There is no JSON to read and no tokenless endpoint
 * for a whole store — `reviews_for_widget` 404s the moment you drop
 * `product_id` — so their markup is the feed.
 *
 * TWO feeds, read in this order:
 *
 *   `.jdgm-rev`          — the all-reviews page (all_reviews_0 + all_reviews_1).
 *                          The SAME markup the PDP widget uses, so the same
 *                          attributes: data-verified-buyer, data-score,
 *                          data-product-title, data-product-url. Preferred,
 *                          because an attribute survives a restyle where a
 *                          class does not.
 *   `.jdgm-carousel-item` — the featured carousel. Every field is a class with
 *                          no attribute twin and the rating has no data-score
 *                          at all, so this is only the fallback.
 *
 * `store_summary_widget_data` has no `reviews` array, which is what the first
 * pass looked for and why it was written off. It does have `photo_gallery`: ten
 * entries carrying reviewer_name, body_html, verified_buyer, location and
 * cf_answers. Those are reviews, in JSON, at shop scope — the thing this file
 * exists because it could not find. Whether they also carry the photo and the
 * product is the open question; if they do, this parser becomes Liquid and the
 * markup feeds drop to fallbacks.
 *
 * Nothing is force-filled: a card is built only from the parts that parsed, and
 * a feed that yields nothing leaves the merchant's curated cards alone.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var ROOT = '[data-ds-customer-reviews]';

function text(node, selector) {
  var found = node.querySelector(selector);
  return found ? found.textContent.trim() : '';
}

/* One `.jdgm-rev` to a plain object. Everything but the body and the author
 * comes off an attribute, which is why this feed is preferred. */
function parseReview(el) {
  var body = text(el, '.jdgm-rev__body');
  if (!body) return null;

  var rating = el.querySelector('.jdgm-rev__rating');
  var pic = el.querySelector('.jdgm-rev__pic-link img');

  return {
    body: body,
    author: text(el, '.jdgm-rev__author'),
    product: el.getAttribute('data-product-title') || '',
    href: el.getAttribute('data-product-url') || '',
    image: pic ? pic.getAttribute('data-src') || pic.getAttribute('src') || '' : '',
    rating: rating ? parseInt(rating.getAttribute('data-score'), 10) || 5 : 5,
    verified: el.getAttribute('data-verified-buyer') === 'true',
  };
}

/* One `.jdgm-carousel-item` to a plain object, or null when it carries no
 * review body — the carousel pads itself with product-only tiles. */
function parseItem(el) {
  var body = text(el, '.jdgm-carousel-item__review-body');
  if (!body) return null;

  var link = el.querySelector('a.jdgm-carousel-item__product, .jdgm-carousel-item__product a, a.jdgm-carousel-item__full-review-link');

  /* The carousel's rating carries NO `data-score` — unlike the review widget's,
   * which does. It states the score in `aria-label` ("5 stars") over a run of
   * `.jdgm-star.jdgm--on` spans. Counting the lit stars is the reading that
   * cannot be broken by a locale change; the label is the fallback. Reading
   * data-score here (which is what shipped first) silently made every card five
   * stars, and a wall of fives is exactly the thing a shopper stops believing. */
  var ratingEl = el.querySelector('.jdgm-carousel-item__review-rating');
  var rating = 5;
  if (ratingEl) {
    var lit = ratingEl.querySelectorAll('.jdgm-star.jdgm--on').length;
    if (lit > 0) {
      rating = lit;
    } else {
      var label = parseInt(ratingEl.getAttribute('aria-label'), 10);
      if (label > 0) rating = label;
    }
  }

  /* `jdgm-carousel-item__product-image` is the class on the <img> ITSELF, not on
   * a wrapper around one. Its `alt` is the product title, which is the only
   * place the title appears when the carousel's theme drops the product line. */
  var image = el.querySelector('img.jdgm-carousel-item__product-image, .jdgm-carousel-item__image-wrapper img');

  return {
    body: body,
    author: text(el, '.jdgm-carousel-item__reviewer-name'),
    product: text(el, '.jdgm-carousel-item__product-title') || (image ? image.getAttribute('alt') || '' : ''),
    href: link ? link.getAttribute('href') || '' : '',
    // Judge.me lazy-loads, so the real URL is usually on data-src.
    image: image ? image.getAttribute('data-src') || image.getAttribute('src') || '' : '',
    rating: rating,
    verified: true,
  };
}

/* ds-rating stacks a filled star over a track star per slot and reveals the
 * overlay with a width utility, so re-pointing it is a class swap — no second
 * star implementation here. Same routine the PDP band uses. */
function setStars(container, score) {
  var halves = Math.max(0, Math.min(10, Math.round(score * 2)));
  container.setAttribute('data-ds-rating-value', String(score));
  container.querySelectorAll('[role="img"] > span').forEach(function (slot, index) {
    var overlay = slot.querySelector('span');
    if (!overlay) return;
    var filled = (index + 1) * 2;
    overlay.classList.remove('sf-w-full', 'sf-w-1/2', 'sf-hidden');
    if (halves >= filled) overlay.classList.add('sf-w-full');
    else if (halves === filled - 1) overlay.classList.add('sf-w-1/2');
    else overlay.classList.add('sf-hidden');
  });
}

function fillCard(node, review) {
  var quote = node.querySelector('blockquote');
  if (quote) quote.textContent = '“' + review.body + '”';

  var author = node.querySelector('cite');
  if (author) {
    if (!review.author) author.remove();
    else author.textContent = review.author;
  }

  var image = node.querySelector('img');
  if (image && review.image) {
    image.setAttribute('src', review.image);
    image.removeAttribute('srcset');
    image.setAttribute('alt', '');
  }

  var stars = node.querySelector('[data-ds-rating]');
  if (stars) setStars(stars, review.rating);

  /* ds-review-card ships the verified mark on by default; an unverified review must not
   * claim otherwise. */
  var badge = node.querySelector('[data-ds-review-card-verified]');
  if (badge && review.verified === false) badge.remove();

  return node;
}

function setup(root) {
  var source = root.querySelector('[data-ds-customer-reviews-source]');
  var template = root.querySelector('[data-ds-customer-reviews-template]');
  var track = root.querySelector('[data-ds-customer-reviews-track]');
  if (!source || !template || !track) return;

  var reviews = [];
  source.querySelectorAll('.jdgm-rev').forEach(function (el) {
    var review = parseReview(el);
    if (review) reviews.push(review);
  });
  if (!reviews.length) {
    source.querySelectorAll('.jdgm-carousel-item').forEach(function (el) {
      var review = parseItem(el);
      if (review) reviews.push(review);
    });
  }

  /* Nothing parsable: leave the merchant's curated cards alone. The homepage
   * having four hand-picked quotes is a better failure than an empty band. */
  if (!reviews.length) return;

  /* Figma's card leads with a photo, and the all-reviews feed carries one only
   * where the shopper uploaded it. Photo-bearing reviews go first so the band
   * looks like the design whenever the store has enough of them; the rest fill
   * in behind, drawing ds-image's empty frame rather than being dropped. */
  reviews.sort(function (a, b) {
    return (b.image ? 1 : 0) - (a.image ? 1 : 0);
  });

  var limit = parseInt(root.getAttribute('data-ds-customer-reviews-limit'), 10) || 8;

  // Four cards fit the desktop viewport; extras stay available in the scroller.
  track.innerHTML = '';
  reviews.slice(0, limit).forEach(function (review) {
    var node = template.content.firstElementChild.cloneNode(true);
    track.appendChild(fillCard(node, review));
  });
}

function init(scope) {
  (scope || document).querySelectorAll(ROOT).forEach(function (root) {
    if (root.dataset.dsBound) return;
    root.dataset.dsBound = '1';
    setup(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  init();
}

document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "customer-reviews" failed to initialise:', sfError);
}
})();

/* delivery-breakdown.js */
(function () {
try {
/* delivery-breakdown — opens the "Delivery breakdown" dialog from the PDP's
 * "Order today and get it by" line ([data-ds-delivery-breakdown-open]).
 *
 * Every number in the dialog is server-rendered by ds-delivery-info, so this
 * only flips [aria-hidden] (src/delivery-breakdown.css carries the motion),
 * traps Tab and returns focus.
 *
 * NOT a singleton: each card renders its own dialog, because each holds its own
 * numbers. ds-product-delivery has no block limit, so a trigger resolves the
 * dialog inside ITS card and only falls back to the first in the document —
 * `document.querySelector` alone would open the first card's ETA from the
 * second card's line.
 *
 * Progressive enhancement: without this the trigger is inert and the dialog
 * stays hidden — the ETA is already printed on the card.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var DB_ROOT = '[data-ds-delivery-breakdown]';
var DB_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

var dbReturn = null;
var dbScroll = '';

// The dialog a trigger belongs to: its own card first, the page's first one as
// the fallback for a caller that mounts the dialog outside the card.
function dbFor(trigger) {
  var card = trigger && trigger.closest && trigger.closest('[data-ds-delivery-info]');
  return (card && card.querySelector(DB_ROOT)) || document.querySelector(DB_ROOT);
}

// The one currently open — there can only be one, since opening locks the page.
function dbOpenEl() {
  var list = document.querySelectorAll(DB_ROOT);
  for (var i = 0; i < list.length; i++) {
    if (list[i].getAttribute('aria-hidden') === 'false') return list[i];
  }
  return null;
}

function dbOpen(root, trigger) {
  dbReturn = trigger || document.activeElement;
  dbScroll = document.body.style.overflow;
  root.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  window.requestAnimationFrame(function () {
    var close = root.querySelector('[data-ds-delivery-breakdown-close]');
    if (close) close.focus();
  });
}

function dbClose(root) {
  if (!root || root.getAttribute('aria-hidden') === 'true') return;
  root.setAttribute('aria-hidden', 'true');
  // Put back whatever was there: another dialog may still hold its own lock.
  document.body.style.overflow = dbScroll;
  if (dbReturn && dbReturn.focus) dbReturn.focus();
  dbReturn = null;
}

function dbTrap(root, event) {
  var items = [].slice.call(root.querySelectorAll(DB_FOCUSABLE)).filter(function (el) {
    return el.offsetParent !== null;
  });
  if (!items.length) return;
  var first = items[0];
  var last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  } else if (!root.contains(document.activeElement)) {
    event.preventDefault();
    first.focus();
  }
}

if (!document.__dsDeliveryBreakdownBound) {
  document.__dsDeliveryBreakdownBound = true;

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var trigger = event.target.closest('[data-ds-delivery-breakdown-open]');
    if (trigger) {
      var target = dbFor(trigger);
      if (!target) return;
      event.preventDefault();
      dbOpen(target, trigger);
      return;
    }

    var root = dbOpenEl();
    if (!root) return;
    // The scrim is the root itself; a click inside the card must not close it.
    if (event.target.closest('[data-ds-delivery-breakdown-close]') || event.target === root) {
      dbClose(root);
    }
  });

  document.addEventListener('keydown', function (event) {
    var root = dbOpenEl();
    if (!root) return;
    if (event.key === 'Escape') dbClose(root);
    else if (event.key === 'Tab') dbTrap(root, event);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "delivery-breakdown" failed to initialise:', sfError);
}
})();

/* gallery.js */
(function () {
try {
/* gallery — product gallery carousel: a NATIVE scroll-snap viewer plus prev/next
 * chevrons, thumbnail select, counter, and inline-video play/pause. Binds
 * [data-ds-gallery] and its data-ds-gallery-* children (see
 * snippets/ds-gallery.liquid).
 *
 * The viewer is a horizontal scroll-snap container — one slide per viewport,
 * exactly like ds-hero-slider. The finger-swipe on a phone is therefore the
 * BROWSER'S OWN native scroll (momentum, snap and all), which stays smooth even
 * inside a throttled in-app webview (Facebook/Instagram) where a hand-wired
 * JS transform-drag janks. This script only ADDS the enhancements on top of
 * that zero-JS baseline: it reads the active slide back from the scroll
 * position, moves the selection when a chevron or thumbnail is pressed (via
 * scrollTo, so swipe and click share ONE scroll position instead of fighting a
 * transform), restages the thumbnail ring + counter, and plays/pauses the
 * inline video. Progressive enhancement: without this script the first image +
 * all thumbs still render and the viewer still swipes; only the counter,
 * thumbnail ring and video autoplay are off.
 *
 * The thumbnail strip is a ds-thumbnail-rail (snippets/ds-thumbnail-rail.liquid),
 * whose tiles are ds-thumbnail atoms. This script is the shipped driver for that
 * rail when it sits inside a gallery: it moves the selection, restages the tile
 * ring, centres the selected tile, and swaps the counter. In Storybook
 * runtime/media-behaviour.ts drives the rail; the native swipe needs no JS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export — the build wraps
 * this file in an IIFE and concatenates it into dist/sf-core.js.
 */

// The two class sets ds-thumbnail toggles for `selected`. MUST match
// selected_ring / live in snippets/ds-thumbnail.liquid — the snippet is the
// source of truth and server-renders the active tile; this only restages it when
// the selection changes. runtime/media-behaviour.ts mirrors the same sets;
// update all three together.
var TILE_SELECTED = ['sf-border-secondary'];
var TILE_IDLE = ['hover:sf-border-strong', 'hover:sf-shadow-2', 'focus-visible:sf-outline', 'focus-visible:sf-outline-focus', 'focus-visible:sf-outline-offset-focus'];

// The rail's SCROLL CONTAINER, which is not always the element carrying the
// [data-ds-thumbnail-rail] hook. In ds-gallery that hook sits on a positioning
// wrapper (lg:relative lg:w-gallery-rail, overflow visible) and the element that
// actually scrolls is the ds-thumbnail-rail inside it — scrolling the wrapper is
// a no-op, and its flex-direction is `row` even where the real strip is a column,
// so the axis comes out wrong too. The rail snippet always stamps its own
// orientation, so that attribute is what identifies the scroller; the hand-written
// rail in ds-cart-photo-lightbox carries both on one element and still matches.
function galleryRail(root) {
  return root.querySelector('[data-ds-thumbnail-rail-orientation]') ||
    root.querySelector('[data-ds-thumbnail-rail]');
}

// Centre the selected tile inside the rail. The rail hides its scrollbar
// (matching the live storefronts), so a tile past the fold has no affordance
// otherwise. Scrolls the RAIL only, never an ancestor, so a gallery sitting in a
// sticky column doesn't drag the page. Clamped by scrollTo, so the first/last
// tile simply rests against its end.
function centerRailTile(rail, tile) {
  var railBox = rail.getBoundingClientRect();
  var tileBox = tile.getBoundingClientRect();
  // Read the computed direction, not the orientation attribute: the responsive
  // rail is a row on mobile and a column from lg, so the scroll axis flips.
  var vertical = getComputedStyle(rail).flexDirection.indexOf('column') === 0;
  var offset = vertical
    ? tileBox.top - railBox.top - (railBox.height - tileBox.height) / 2
    : tileBox.left - railBox.left - (railBox.width - tileBox.width) / 2;
  // Honour a user who asked the OS for less motion; the jump still happens.
  var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var target = vertical ? { top: rail.scrollTop + offset } : { left: rail.scrollLeft + offset };
  target.behavior = smooth ? 'smooth' : 'auto';
  rail.scrollTo(target);
}

// The active slide read back from the viewer's OWN scroll position — correct
// after a native swipe that stopped between two snap points as much as after our
// own scrollTo. Rounding picks the nearest snap point.
function galleryIndexFromScroll(track) {
  var w = track.clientWidth || 1;
  return Math.round(track.scrollLeft / w);
}

// The neighbours are lazy (only the active slide renders eager), so the FIRST
// swipe to each image would otherwise fetch+decode mid-scroll and stutter.
// Warming the two adjacent slides the moment the active one changes keeps the
// next swipe instant. Per the HTML spec, flipping an <img>'s loading from lazy
// to eager starts the fetch immediately, even while the slide is off-screen.
function preloadGalleryNeighbors(root, idx) {
  var track = root.querySelector('[data-ds-gallery-track]');
  if (!track) return;
  [idx - 1, idx + 1].forEach(function (target) {
    var img = track.querySelector('img[data-ds-gallery-slide][data-ds-gallery-index="' + target + '"]');
    if (img && img.loading === 'lazy') img.loading = 'eager';
  });
}

// Silence a slide's video. Called for the slide being LEFT (and for every slide
// when the lightbox closes), never for one that was not playing — an iframe
// reload is not free, and a never-visited embed must not be touched.
// A Shopify-hosted video is a real <video>, so pause() is enough. An
// external_video is a third-party iframe we cannot control without its JS API
// (YouTube ignores postMessage without enablejsapi), so reassigning src is the
// portable stop: it drops the player back to its poster.
function stopGalleryMedia(slide) {
  if (!slide) return;
  if (typeof slide.pause === 'function') {
    slide.pause();
    return;
  }
  var frame = slide.querySelector('iframe');
  if (frame) frame.src = frame.src;
}

// Landing on a video slide starts it, so the shopper sees motion instead of a
// still they have to press. Only the INLINE preview, which is the muted looping
// one: the lightbox player is unmuted-capable and has controls, and a browser
// blocks unprompted audio anyway, so starting that one would just be refused.
// play() rejects on its own for a codec or policy the browser dislikes — the
// poster stays, which is the honest fallback.
function playGalleryMedia(slide) {
  if (!slide || !slide.muted || typeof slide.play !== 'function') return;
  var played = slide.play();
  if (played && typeof played.catch === 'function') played.catch(function () {});
}

// The <video> for the slide that is currently active (null when the active slide
// is an image or an external embed).
function activeGalleryVideo(root) {
  var idx = Number(root.dataset.dsGalleryActive || 0);
  return root.querySelector('video[data-ds-gallery-video][data-ds-gallery-index="' + idx + '"]');
}

// Play the active video only while the gallery is actually on-screen, pause it
// otherwise. This is the "scroll to the video and it plays" behaviour: on the
// PDP the gallery scrolls in and out of view as the shopper reads, and a muted
// clip must not burn cycles behind the fold. Routed through here from BOTH a
// slide change (syncGalleryUI) and a scroll (the observer below), so the two
// share one play/pause decision. `__dsVisible` is undefined until the observer
// first reports — and stays so where IntersectionObserver is missing — which we
// read as visible, degrading to the plain "play on active slide" baseline.
function updateGalleryPlayback(root) {
  var video = activeGalleryVideo(root);
  if (!video) return;
  var hidden = galleryVisibility && root.__dsVisible === false;
  if (hidden) {
    video.pause();
  } else {
    playGalleryMedia(video);
  }
}

// One observer for every gallery on the page: it flips each root's visibility
// flag and re-evaluates playback. 0.5 = start once half the gallery is in view,
// which on mobile means the shopper has actually scrolled the media into frame.
var galleryVisibility = typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.__dsVisible = entry.isIntersecting;
        updateGalleryPlayback(entry.target);
      });
    }, { threshold: 0.5 })
  : null;

// Watch a gallery for scroll-in/out. Idempotent — a re-render (Theme Editor) or
// a second initGalleries pass must not stack duplicate observations.
function observeGallery(root) {
  if (!galleryVisibility || root.__dsObserved) return;
  root.__dsObserved = true;
  galleryVisibility.observe(root);
}

// Sync every derived bit of UI to `idx` WITHOUT scrolling. The scroll position
// is the source of truth, so this is called FROM the scroll listener as the
// track travels (native swipe or our own scrollTo alike) and once on init.
function syncGalleryUI(root, idx, centerSelected) {
  var count = Number(root.dataset.dsGalleryCount || 0);
  if (!count) return;
  idx = Math.max(0, Math.min(count - 1, idx));
  var prev = Number(root.dataset.dsGalleryActive || 0);
  if (prev !== idx) {
    stopGalleryMedia(root.querySelector('[data-ds-gallery-video][data-ds-gallery-index="' + prev + '"]'));
  }
  root.dataset.dsGalleryActive = String(idx);
  // Play/pause the new active slide's video by whether the gallery is in view.
  updateGalleryPlayback(root);
  // Warm the slides on either side so the next swipe doesn't decode mid-scroll.
  preloadGalleryNeighbors(root, idx);

  var railWrap = root.querySelector('[data-ds-thumbnail-rail]');
  if (railWrap) {
    // `data-ds-thumbnail-rail` sits on a plain wrapper (ds-gallery.liquid); the
    // element that actually overflows/scrolls is the ds-thumbnail-rail snippet
    // root inside it (it carries the orientation attribute). Centre THAT one —
    // scrolling the non-overflowing wrapper is a no-op, so the active tile never
    // came into view.
    var rail = railWrap.querySelector('[data-ds-thumbnail-rail-orientation]') || railWrap;
    rail.setAttribute('data-ds-thumbnail-rail-active', String(idx));
    rail.querySelectorAll('[data-ds-thumbnail-rail-item]').forEach(function (item) {
      var control = item.querySelector('[data-ds-thumbnail]');
      if (!control) return;
      var isActive = Number(item.getAttribute('data-ds-thumbnail-rail-index')) === idx;
      // Toggle the ring atomically: strip both sets, re-add the right one.
      TILE_SELECTED.forEach(function (c) { control.classList.remove(c); });
      TILE_IDLE.forEach(function (c) { control.classList.remove(c); });
      (isActive ? TILE_SELECTED : TILE_IDLE).forEach(function (c) { control.classList.add(c); });
      control.setAttribute('aria-pressed', String(isActive));
      if (isActive && centerSelected !== false) centerRailTile(rail, control);
    });
  }

  var cur = root.querySelector('[data-ds-gallery-counter-current]');
  if (cur) cur.textContent = String(idx + 1);
  updateGalleryButtons(root);
}

function updateGalleryButtons(root) {
  var count = Number(root.dataset.dsGalleryCount || 0);
  var idx = Number(root.dataset.dsGalleryActive || 0);
  var prev = root.querySelector('[data-ds-gallery-prev]');
  var next = root.querySelector('[data-ds-gallery-next]');
  if (prev) prev.disabled = count <= 1 || idx <= 0;
  if (next) next.disabled = count <= 1 || idx >= count - 1;
}

// Scroll the viewer to slide `idx`. `instant` (and reduced-motion) override the
// track's CSS scroll-behavior: smooth for a jump the shopper shouldn't watch
// travel — opening the lightbox on the slide they swiped to, or the first paint.
function scrollGalleryTo(root, idx, instant) {
  var track = root.querySelector('[data-ds-gallery-track]');
  if (!track) return;
  var count = Number(root.dataset.dsGalleryCount || 0);
  var clamped = Math.max(0, Math.min(Math.max(0, count - 1), idx));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var left = clamped * (track.clientWidth || 1);
  if (instant || reduce) {
    // A real, single-frame jump — used to keep the inline gallery and its
    // full-screen twin on the same slide when the lightbox opens/closes (and on
    // first paint). scrollTo({behavior:'auto'}) is spec-instant, but Safari and
    // in-app WebViews (Facebook/Instagram) still ANIMATE it on a track that is
    // scroll-snap + scroll-behavior:smooth — that stray glide is the "slide" the
    // paired gallery showed. Forcing scroll-behavior:auto inline (inline wins over
    // the sf-scroll-smooth class) and writing scrollLeft lands it with no motion
    // in every engine; restore the previous inline value next frame so ordinary
    // swipes and chevron moves stay smooth.
    var previousBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    requestAnimationFrame(function () {
      track.style.scrollBehavior = previousBehavior;
    });
    return;
  }
  track.scrollTo({ left: left, behavior: 'smooth' });
}

// Programmatic move (chevron, thumbnail, ds:gallery:set). Scrolls the viewer;
// the scroll listener restages the UI as the track travels. An `instant` jump
// may not fire a scroll event (already at target), so sync the UI directly too.
function setGalleryActive(root, next, centerSelected, instant) {
  var count = Number(root.dataset.dsGalleryCount || 0);
  if (!count) return;
  var idx = Math.max(0, Math.min(count - 1, next));
  scrollGalleryTo(root, idx, instant);
  if (instant) syncGalleryUI(root, idx, centerSelected);
}

// Restage the UI from the live scroll position, at most once per frame — a swipe
// fires scroll far more often than the active slide actually changes.
function bindGalleryScroll(root) {
  if (root.__dsGalleryScrollBound) return;
  var track = root.querySelector('[data-ds-gallery-track]');
  if (!track) return;
  root.__dsGalleryScrollBound = true;
  var queued = false;
  track.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var idx = galleryIndexFromScroll(track);
      if (idx !== Number(root.dataset.dsGalleryActive || 0)) syncGalleryUI(root, idx);
    });
  }, { passive: true });
}

function initGalleries() {
  document.querySelectorAll('[data-ds-gallery]').forEach(function (root) {
    observeGallery(root);
    bindGalleryScroll(root);
    var idx = Number(root.dataset.dsGalleryActive || 0);
    // Place the scroll at the server-rendered active slide with no animation,
    // then sync the derived UI. rAF: the track's clientWidth is 0 until layout.
    requestAnimationFrame(function () {
      scrollGalleryTo(root, idx, true);
      syncGalleryUI(root, idx, false);
    });
  });
}

if (!document.__dsGalleryBound) {
  document.__dsGalleryBound = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries, { once: true });
  } else {
    initGalleries();
  }
  // The Theme Editor re-renders a section into a fresh subtree; re-run so the new
  // gallery gets its scroll listener bound and its position set. Idempotent:
  // existing galleries just re-assert the slide they already show.
  document.addEventListener('shopify:section:load', initGalleries);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-ds-gallery]');
    if (!root) return;
    var current = Number(root.dataset.dsGalleryActive || 0);

    if (t.closest('[data-ds-gallery-prev]')) { setGalleryActive(root, current - 1); return; }
    if (t.closest('[data-ds-gallery-next]')) { setGalleryActive(root, current + 1); return; }

    var item = t.closest('[data-ds-thumbnail-rail-item]');
    if (item) {
      var idx = Number(item.getAttribute('data-ds-thumbnail-rail-index'));
      if (!Number.isNaN(idx)) setGalleryActive(root, idx);
    }
  });

  // Programmatic jump. media-lightbox.js dispatches this to keep the inline
  // gallery and its full-screen twin on the same image; a variant switch could
  // use it too. Delegated on document so galleries mounted later still respond.
  document.addEventListener('ds:gallery:set', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-ds-gallery]');
    if (!root) return;
    var idx = Number(e.detail && e.detail.index);
    // `instant` skips the slide animation — the open/close sync is a jump to a
    // known slide, not a swipe the shopper should watch travel.
    var instant = !!(e.detail && e.detail.instant);
    if (!Number.isNaN(idx)) setGalleryActive(root, idx, false, instant);
  });

  // Stop everything playing in a gallery. media-lightbox.js dispatches this when
  // the modal closes — otherwise a video keeps playing (audible) behind a modal
  // that is only [aria-hidden], still painted and never unmounted.
  document.addEventListener('ds:gallery:stop', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-ds-gallery]');
    if (!root) return;
    root.querySelectorAll('[data-ds-gallery-video]').forEach(stopGalleryMedia);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "gallery" failed to initialise:', sfError);
}
})();

/* header-nav.js */
(function () {
try {
/* header-nav — adds Amazon-style menu aim to desktop mega menus and controls
 * the mobile hamburger drawer with its single-open accordion branches.
 * Delegated listeners keep it Theme-Editor-safe and work for async Storybook
 * mounts. No import/export: the build wraps this file in an IIFE.
 */

(function () {
  if (document.__dsHeaderNavBound) return;
  document.__dsHeaderNavBound = true;

  var DESKTOP_QUERY = '(min-width: 1024px) and (hover: hover) and (pointer: fine)';
  var SAFE_TRIANGLE_TIMEOUT = 500;
  var CLOSE_DELAY = 120;
  var navState = new WeakMap();

  // This marker lets CSS retain group-hover as a no-JS fallback while handing
  // fine-pointer hover ownership to this behavior when it is available.
  document.documentElement.setAttribute('data-ds-header-menu-aim', '');

  function desktopPointer(event) {
    return event.pointerType === 'mouse' && window.matchMedia(DESKTOP_QUERY).matches;
  }

  function stateFor(nav) {
    var state = navState.get(nav);
    if (!state) {
      state = {
        active: null,
        pending: null,
        triangle: null,
        lastPoint: null,
        closeTimer: 0,
        aimTimer: 0,
      };
      navState.set(nav, state);
    }
    return state;
  }

  function menuFor(item) {
    return item && item.querySelector(':scope > [data-ds-header-mega-menu]');
  }

  function setDesktopItem(item, open) {
    if (!item) return;
    item.toggleAttribute('data-ds-menu-open', open);
    var trigger = item.querySelector(':scope > [data-ds-header-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function cancelTimers(state) {
    window.clearTimeout(state.closeTimer);
    window.clearTimeout(state.aimTimer);
    state.closeTimer = 0;
    state.aimTimer = 0;
  }

  function activateDesktopItem(nav, item) {
    var state = stateFor(nav);
    cancelTimers(state);
    if (state.active !== item) setDesktopItem(state.active, false);
    state.active = menuFor(item) ? item : null;
    state.pending = null;
    state.triangle = null;
    state.lastPoint = null;
    nav.removeAttribute('data-ds-menu-aiming');
    setDesktopItem(state.active, true);
  }

  function closeDesktopNav(nav) {
    var state = stateFor(nav);
    cancelTimers(state);
    setDesktopItem(state.active, false);
    state.active = null;
    state.pending = null;
    state.triangle = null;
    state.lastPoint = null;
    nav.removeAttribute('data-ds-menu-aiming');
  }

  function pointInTriangle(point, a, b, c) {
    function sign(p1, p2, p3) {
      return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
    }
    var d1 = sign(point, a, b);
    var d2 = sign(point, b, c);
    var d3 = sign(point, c, a);
    var hasNegative = d1 < 0 || d2 < 0 || d3 < 0;
    var hasPositive = d1 > 0 || d2 > 0 || d3 > 0;
    return !(hasNegative && hasPositive);
  }

  function armSafeTriangle(nav, event) {
    var state = stateFor(nav);
    var menu = menuFor(state.active);
    if (!menu) return;
    var bounds = menu.getBoundingClientRect();
    var edgeY = bounds.top + 8;
    var apex = state.lastPoint || { x: event.clientX, y: event.clientY };
    state.triangle = {
      startedAt: Date.now(),
      apex: { x: apex.x, y: apex.y },
      left: { x: bounds.left - 12, y: edgeY },
      right: { x: bounds.right + 12, y: edgeY },
    };
  }

  function insideSafeTriangle(state, event) {
    var triangle = state.triangle;
    if (!triangle || Date.now() - triangle.startedAt > SAFE_TRIANGLE_TIMEOUT) return false;
    return pointInTriangle(
      { x: event.clientX, y: event.clientY },
      triangle.apex,
      triangle.left,
      triangle.right,
    );
  }

  function deferToSafeTriangle(nav, item) {
    var state = stateFor(nav);
    cancelTimers(state);
    state.pending = item;
    nav.setAttribute('data-ds-menu-aiming', '');
    state.aimTimer = window.setTimeout(function () {
      activateDesktopItem(nav, state.pending);
    }, SAFE_TRIANGLE_TIMEOUT);
  }

  function scheduleDesktopClose(nav) {
    var state = stateFor(nav);
    window.clearTimeout(state.closeTimer);
    state.closeTimer = window.setTimeout(function () {
      var activeMenu = menuFor(state.active);
      if (state.active && !state.active.matches(':hover') && (!activeMenu || !activeMenu.matches(':hover'))) {
        closeDesktopNav(nav);
      }
    }, CLOSE_DELAY);
  }

  document.addEventListener('pointerover', function (event) {
    if (!desktopPointer(event) || !event.target.closest) return;
    var item = event.target.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (!nav || (event.relatedTarget && item.contains(event.relatedTarget))) return;

    var state = stateFor(nav);
    window.clearTimeout(state.closeTimer);
    state.closeTimer = 0;

    if (state.active === item) return;
    if (state.active && insideSafeTriangle(state, event)) {
      deferToSafeTriangle(nav, item);
      return;
    }
    activateDesktopItem(nav, item);
    stateFor(nav).lastPoint = { x: event.clientX, y: event.clientY };
  });

  document.addEventListener('pointerout', function (event) {
    if (!desktopPointer(event) || !event.target.closest) return;
    var item = event.target.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (!nav || stateFor(nav).active !== item) return;
    if (event.relatedTarget && item.contains(event.relatedTarget)) return;
    armSafeTriangle(nav, event);
    scheduleDesktopClose(nav);
  });

  document.addEventListener('pointermove', function (event) {
    if (!desktopPointer(event) || !event.target.closest) return;
    var nav = event.target.closest('[data-ds-header-nav]');
    if (!nav) return;
    var state = stateFor(nav);
    if (!state.pending) {
      var activeItem = event.target.closest('[data-ds-header-nav-item]');
      if (activeItem && activeItem === state.active) {
        state.lastPoint = { x: event.clientX, y: event.clientY };
      }
      return;
    }
    if (insideSafeTriangle(state, event)) return;

    var hoveredItem = event.target.closest('[data-ds-header-nav-item]');
    if (hoveredItem && hoveredItem.closest('[data-ds-header-nav]') === nav) {
      activateDesktopItem(nav, hoveredItem);
    } else {
      closeDesktopNav(nav);
    }
  });

  // Keep aria-expanded aligned with the keyboard path.
  document.addEventListener('focusin', function (event) {
    if (!event.target.closest || !window.matchMedia('(min-width: 1024px)').matches) return;
    var item = event.target.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (nav && menuFor(item)) activateDesktopItem(nav, item);
  });

  document.addEventListener('focusout', function (event) {
    if (!event.target.closest) return;
    var nav = event.target.closest('[data-ds-header-nav]');
    if (!nav || (event.relatedTarget && nav.contains(event.relatedTarget))) return;
    window.setTimeout(function () {
      if (!nav.contains(document.activeElement) && !nav.matches(':hover')) closeDesktopNav(nav);
    }, 0);
  });

  function parts(trigger) {
    var header = trigger && trigger.closest('[data-ds-header]');
    var menu = header && header.querySelector('[data-ds-header-mobile-menu]');
    return { header: header, menu: menu };
  }

  function sizeDrawer(menu) {
    if (!menu) return;
    var header = menu.closest('[data-ds-header]');
    var top = header ? header.getBoundingClientRect().bottom : menu.getBoundingClientRect().top;
    top = Math.max(0, Math.min(window.innerHeight, top));
    menu.style.setProperty('--ds-header-mobile-menu-top', top + 'px');
    menu.style.setProperty('--ds-header-mobile-menu-max-height', Math.max(0, window.innerHeight - top) + 'px');
  }

  function syncPageScrollLock() {
    var hasOpenDrawer = document.querySelector(
      '[data-ds-header-mobile-menu][aria-hidden="false"]',
    );
    document.documentElement.toggleAttribute('data-ds-header-nav-scroll-lock', Boolean(hasOpenDrawer));
  }

  function setDrawer(trigger, open) {
    var found = parts(trigger);
    if (!found.menu) return;
    trigger.setAttribute('aria-controls', found.menu.id);
    if (open) sizeDrawer(found.menu);
    found.menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    trigger.setAttribute(
      'aria-label',
      open ? trigger.getAttribute('data-label-close') : trigger.getAttribute('data-label-open'),
    );
    var iconOpen = trigger.querySelector('[data-ds-header-menu-icon-open]');
    var iconClose = trigger.querySelector('[data-ds-header-menu-icon-close]');
    if (iconOpen) iconOpen.classList.toggle('sf-hidden', open);
    if (iconClose) iconClose.classList.toggle('sf-hidden', !open);
    syncPageScrollLock();
  }

  function setBranch(item, open) {
    var toggle = item.querySelector('[data-ds-mobile-menu-toggle]');
    var panel = item.querySelector('[data-ds-mobile-menu-panel]');
    var label = item.querySelector('[data-ds-mobile-menu-label]');
    var icon = item.querySelector('[data-ds-mobile-menu-icon]');
    var plus = item.querySelector('[data-ds-mobile-menu-plus]');
    var minus = item.querySelector('[data-ds-mobile-menu-minus]');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.classList.toggle('sf-bg-badge-brand', open);
    toggle.classList.toggle('sf-bg-surface', !open);
    toggle.classList.toggle('hover:sf-bg-surface-hover', !open);
    if (label) {
      label.classList.toggle('sf-text-action-primary-strong', open);
      label.classList.toggle('sf-text-primary', !open);
    }
    if (icon) {
      icon.classList.toggle('sf-text-action-primary-strong', open);
      icon.classList.toggle('sf-text-primary', !open);
    }
    if (plus) plus.classList.toggle('sf-hidden', open);
    if (minus) minus.classList.toggle('sf-hidden', !open);

    // Animate height instead of snapping display, so opening one branch and
    // closing another (single-open accordion) doesn't jump the layout.
    if (open) {
      panel.style.maxHeight = 'none';
      var h = panel.scrollHeight;
      panel.style.maxHeight = '0px';
      requestAnimationFrame(function () { panel.style.maxHeight = h + 'px'; });
      panel.addEventListener('transitionend', function onEnd() {
        panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', onEnd);
      });
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.maxHeight = '0px'; });
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var menuTrigger = event.target.closest('[data-ds-header-menu-button]');
    if (menuTrigger) {
      event.preventDefault();
      setDrawer(menuTrigger, menuTrigger.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var branchToggle = event.target.closest('[data-ds-mobile-menu-toggle]');
    if (!branchToggle) return;
    event.preventDefault();
    var item = branchToggle.closest('[data-ds-mobile-menu-item]');
    var drawer = branchToggle.closest('[data-ds-header-mobile-menu]');
    if (!item || !drawer) return;
    var willOpen = branchToggle.getAttribute('aria-expanded') !== 'true';
    // The single-open accordion collapses whichever sibling is open. Capture it
    // before closing so we can predict how far this heading will shift.
    var closingPanel = null;
    if (willOpen) {
      var openSibling = drawer.querySelector('[data-ds-mobile-menu-toggle][aria-expanded="true"]');
      openSibling = openSibling && openSibling.closest('[data-ds-mobile-menu-item]');
      if (openSibling && openSibling !== item) closingPanel = openSibling.querySelector('[data-ds-mobile-menu-panel]');
    }
    drawer.querySelectorAll('[data-ds-mobile-menu-item]').forEach(function (candidate) {
      if (candidate !== item) setBranch(candidate, false);
    });
    setBranch(item, willOpen);
    // Long panels can push the just-opened heading off-screen; pin it to the top
    // of the drawer's own scroll area (not scrollIntoView — the drawer is
    // overflow:hidden, and browsers scroll that ancestor too, corrupting layout).
    var scroller = drawer.querySelector('[data-ds-header-mobile-menu-scroll]');
    if (willOpen && scroller) {
      var openPanel = item.querySelector('[data-ds-mobile-menu-panel]');
      // Predict the settled scroll target and reposition there immediately.
      // The panels already animate max-height; smooth-scrolling at the same
      // time creates a competing animation against a layout that is moving.
      // The heading only shifts by the height of a sibling collapsing ABOVE it;
      // its own panel opens below the heading and never moves it. max-height:0
      // does not hide a panel from scrollHeight, so the open/close heights are
      // readable up front, before any transition runs.
      var toggleTop = branchToggle.getBoundingClientRect().top
        - scroller.getBoundingClientRect().top + scroller.scrollTop;
      var closingH = closingPanel ? closingPanel.scrollHeight : 0;
      var above = closingPanel
        && !(branchToggle.compareDocumentPosition(closingPanel) & Node.DOCUMENT_POSITION_FOLLOWING);
      var finalTop = toggleTop - (above ? closingH : 0);
      var finalContent = scroller.scrollHeight - closingH + (openPanel ? openPanel.scrollHeight : 0);
      var finalMax = finalContent - scroller.clientHeight;
      scroller.style.paddingBottom = '';
      if (finalMax > 0) {
        // Reserve just enough trailing space that even the last, short branch
        // can bring its heading all the way to the top.
        var pad = Math.ceil(finalTop - finalMax);
        if (pad > 0) scroller.style.paddingBottom = pad + 'px';
        scroller.scrollTo({ top: Math.max(0, finalTop), behavior: 'auto' });
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
      setDrawer(trigger, false);
      trigger.focus();
    });
  });

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!document.documentElement.hasAttribute('data-ds-header-nav-scroll-lock')) return;
      if (event.target.closest && event.target.closest('[data-ds-header-mobile-menu]')) return;
      if (event.target.closest && event.target.closest('[data-ds-region-modal][aria-hidden="false"]')) return;
      event.preventDefault();
    },
    { passive: false },
  );

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1024) {
      document.querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
        setDrawer(trigger, false);
      });
      return;
    }
    document.querySelectorAll('[data-ds-header-nav]').forEach(closeDesktopNav);
    document.querySelectorAll('[data-ds-header-mobile-menu][aria-hidden="false"]').forEach(sizeDrawer);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "header-nav" failed to initialise:', sfError);
}
})();

/* header-search.js */
(function () {
try {
/* header-search — below lg, focusing the header search pill expands it to the
 * full row: the brand cluster and the utility actions give way and a Cancel
 * control appears (Figma 2477:10415 / 7209:5419). One attribute on the row
 * carries the state; the CSS in the markup does the rest, so with no JS the
 * field is simply an inline search box that still submits.
 * Delegated listeners keep it Theme-Editor-safe. No import/export.
 */

(function () {
  if (document.__dsHeaderSearchBound) return;
  document.__dsHeaderSearchBound = true;

  var MOBILE = '(max-width: 1023px)';

  function rowFor(el) {
    return el && el.closest ? el.closest('[data-ds-header-main-row] > div') : null;
  }

  function setOpen(row, open) {
    if (!row) return;
    row.toggleAttribute('data-ds-search-open', open);
  }

  function syncPlaceholder(form) {
    var field = form && form.querySelector ? form.querySelector('input') : null;
    if (!field) return;
    var next = window.matchMedia(MOBILE).matches
      ? form.getAttribute('data-placeholder-mobile')
      : form.getAttribute('data-placeholder-desktop');
    if (next) field.setAttribute('placeholder', next);
  }

  function syncPlaceholders() {
    document.querySelectorAll('[data-ds-header-search]').forEach(syncPlaceholder);
  }

  syncPlaceholders();
  document.addEventListener('shopify:section:load', syncPlaceholders);

  document.addEventListener('focusin', function (event) {
    if (!event.target.closest || !window.matchMedia(MOBILE).matches) return;
    if (!event.target.closest('[data-ds-header-search]')) return;
    // The expanded row hides the hamburger, and the drawer has no other close
    // control — leaving both open would trap a touch user behind a scroll lock.
    document.querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
      trigger.click();
    });
    setOpen(rowFor(event.target), true);
  });

  // Dismissing the keyboard by tapping the page blurs the field without a
  // Cancel click; without this the row stays expanded and the utility actions
  // (account, cart) remain hidden with no way back. Deferred by a task so a
  // Cancel click, which blurs the field first, still lands on its own handler.
  document.addEventListener('focusout', function (event) {
    if (!event.target.closest || !event.target.closest('[data-ds-header-search]')) return;
    var row = rowFor(event.target);
    window.setTimeout(function () {
      if (row && !row.contains(document.activeElement)) setOpen(row, false);
    }, 0);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var cancel = event.target.closest('[data-ds-header-search-cancel]');
    if (!cancel) return;
    event.preventDefault();
    var row = rowFor(cancel);
    var field = row && row.querySelector('[data-ds-header-search] input');
    if (field) {
      field.value = '';
      field.blur();
    }
    setOpen(row, false);
  });

  // The search button must never run an empty query: tapping it with a blank
  // field focuses the field instead of navigating to a bare /search — and below
  // lg that focus also expands the collapsed pill (via focusin). Universal, so it
  // holds in the collapsed pill, the expanded row, and the desktop bar alike.
  // Handled on the click (not the submit event) because a predictive-search app
  // can swallow the submit in the capture phase; cancelling the button's click
  // stops the form from ever submitting. A real query is left untouched, and
  // with no JS the form still posts normally.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var submit = event.target.closest('[data-ds-header-search] button[type="submit"]');
    if (!submit) return;
    var field = submit.closest('[data-ds-header-search]').querySelector('input');
    if (field && field.value.trim() !== '') return;
    event.preventDefault();
    if (field) {
      field.focus();
      // Forward the tap to the field itself so a predictive-search app that opens
      // its panel on the input's click (not just focus) still opens — same as
      // tapping the field directly. Safe: clicking an input submits nothing, and
      // this click's target is the input, so the guard above skips it.
      field.click();
    }
  });

  // Enter in an empty field would submit past the click guard above; block it so
  // a blank query never runs from the keyboard either.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.closest) return;
    if (!event.target.closest('[data-ds-header-search]')) return;
    if (event.target.value != null && event.target.value.trim() === '') {
      event.preventDefault();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !event.target.closest) return;
    if (!event.target.closest('[data-ds-header-search]')) return;
    var row = rowFor(event.target);
    if (event.target.blur) event.target.blur();
    setOpen(row, false);
  });

  // Above lg the row is never in the expanded state — the pill always sits
  // between the brand and the utility actions.
  window.addEventListener('resize', function () {
    syncPlaceholders();
    if (window.matchMedia(MOBILE).matches) return;
    document.querySelectorAll('[data-ds-search-open]').forEach(function (row) {
      setOpen(row, false);
    });
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "header-search" failed to initialise:', sfError);
}
})();

/* hero-slider.js */
(function () {
try {
/* hero-slider — homepage hero carousel: arrows, dots, autoplay.
 *
 * Autoplay does not start with the section: it arms after `load` plus a grace
 * window, or on the shopper's first touch, whichever comes first — advancing
 * while the page still loads competes with it and moves the banner out from
 * under someone who has not read it yet. See arm() for the reasoning, and for
 * the LCP claim this is NOT.
 *
 * The track is a scroll-snap container (snippets/ds-hero-slider.liquid), so
 * swipe already works with no JS and the first slide is always visible. This
 * only adds the controls: scrollTo the neighbouring slide, restage the dots
 * from the observed scroll position, advance on a timer when the section asks
 * for autoplay, and loop in both directions through a clone at each end (see
 * the clone block in bindHero).
 *
 * Driving the native scroll position (rather than a transform) means the
 * enhanced and baseline states never disagree — a swipe and an arrow click end
 * up in the same place, and the dots follow either one.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var HERO = '[data-ds-hero-slider]';

function bindHero(root) {
  if (root.dataset.dsHeroBound) return;
  root.dataset.dsHeroBound = '1';

  var track = root.querySelector('[data-ds-hero-track]');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  if (!track || slides.length < 2) {
    // One slide: the arrows would be dead controls, so remove the whole row.
    var controls = root.querySelector('[data-ds-hero-controls]');
    if (controls) controls.remove();
    return;
  }

  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ds-hero-dot]'));
  var interval = Number(root.dataset.dsHeroInterval || 0);
  var timer = null;
  var staged = -1;
  var armed = false;

  // Seamless loop in BOTH directions, the same construction product-rail uses:
  // the track reads [clone of last][reals][clone of first] and rests one slide
  // in. Leaving either end lands on a slide that is pixel-identical to the one
  // the shopper expects, and once that scroll has come to rest the offset is
  // teleported to the real twin — so a wrap never sweeps the whole run, which
  // reads as a reset rather than a loop.
  //
  // Both clones are made by JS and never by Liquid: the no-JS baseline must
  // paint the real first slide at offset 0, and it is the page's LCP element.
  var count = slides.length;
  var lastReal = count; // offset index of the last real slide
  var firstReal = 1; // offset index of the first real slide

  function makeClone(slide) {
    var clone = slide.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-ds-hero-clone', '');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    clone.querySelectorAll('img').forEach(function (img) {
      // A clone rests off-screen; inheriting the first slide's eager/high
      // priority would make it compete with the real LCP image.
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
    });
    return clone;
  }

  track.appendChild(makeClone(slides[0]));
  track.insertBefore(makeClone(slides[count - 1]), slides[0]);
  // Prepending shifts the reals one slide right while the browser keeps
  // scrollLeft at 0 — which is now the leading clone. Correct it in the SAME
  // task, before a paint can show the last slide as the hero.
  track.scrollTo({ left: track.clientWidth, behavior: 'instant' });

  function offsetIndex() {
    var width = track.clientWidth;
    return width ? Math.round(track.scrollLeft / width) : firstReal;
  }

  function activeIndex() {
    // Nearest slide to the current scroll offset — correct after a swipe that
    // stopped between two snap points as well as after our own scrollTo. The
    // modulo folds each clone onto its real twin, so the dots read the slide
    // the shopper is actually looking at.
    return ((offsetIndex() - firstReal) % count + count) % count;
  }

  function goTo(offset) {
    // Takes an OFFSET index, so a caller can aim at a clone (0 or count + 1)
    // deliberately; anything else is clamped into the real run.
    var target = offset < 0 || offset > count + 1
      ? ((offset % count) + count) % count + firstReal
      : offset;
    track.scrollTo({
      left: target * track.clientWidth,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  // Swap a clone for its real twin once the track has come to REST on it.
  // Never on a scroll frame: a smooth scroll still in flight RESUMES towards
  // its old target after the offset is rewritten (measured — the track parked
  // itself between two slides), so this only runs on `scrollend`, or on a short
  // idle debounce where that event does not exist. The 2px tolerance absorbs a
  // fractional clientWidth (an odd viewport).
  //
  // `behavior: 'instant'`, not 'auto' and not a scrollLeft write: the track
  // carries CSS scroll-behavior: smooth (sf-scroll-smooth), which BOTH of those
  // honour — the jump animated the whole run, i.e. exactly the sweep the clones
  // exist to avoid. 'instant' is the only value that overrides it.
  function recycle() {
    var width = track.clientWidth;
    if (!width) return;
    var at = track.scrollLeft;
    var jump = null;
    if (Math.abs(at) <= 2) jump = lastReal;
    else if (Math.abs(at - (count + 1) * width) <= 2) jump = firstReal;
    if (jump === null) return;
    track.scrollTo({ left: jump * width, behavior: 'instant' });
    restage();
  }

  function restage() {
    var active = activeIndex();
    // A swipe fires scroll every frame while the index changes only at snap
    // points, so without this the whole subtree's attributes were rewritten ~60
    // times a second and each write invalidated the layout the next frame read.
    if (active === staged) return;
    staged = active;
    slides.forEach(function (slide, i) {
      // Off-screen slides stay in the a11y tree only as much as a carousel
      // should: hidden from AT, and their links out of the tab order. Neither
      // clone is in `slides`, so both stay hidden for good.
      slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
    });
    dots.forEach(function (dot, i) {
      var on = i === active;
      dot.setAttribute('aria-selected', on ? 'true' : 'false');
      var pip = dot.querySelector('[data-ds-hero-dot-pip]');
      // The pip's two sizes live in src/hero.css, selected off this attribute.
      // JS binds data-ds-* only: duplicating the class lists here meant a token
      // change in the snippet left the JS toggling dead classes.
      if (pip) pip.setAttribute('data-ds-hero-dot-pip', on ? 'on' : 'off');
    });
  }

  function schedule() {
    window.clearInterval(timer);
    if (!armed || !interval) return;
    timer = window.setInterval(function () {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      // Straight onto the next OFFSET, clone included: recycle() swaps it for
      // the real twin once the scroll has settled.
      goTo(offsetIndex() + 1);
    }, Math.max(2000, interval));
  }

  // Autoplay does not start with the section, because advancing while the page
  // is still loading costs the shopper twice: the timer competes for the main
  // thread with everything still parsing, it pulls the next slide's lazy
  // picture into a network that is still fetching what is on screen, and it
  // moves the banner out from under someone who has not finished reading the
  // first one.
  //
  // NOT an LCP fix, though it was written believing it was. Measured: a
  // three-slide hero at a 2s interval over 12s reports ONE candidate, at
  // 256ms, and never another — LCP only records a candidate that is LARGER
  // than the standing one, and every slide paints at the same size. See
  // check-hero.mjs, which pins that measurement so the claim cannot come back.
  var AUTOPLAY_GRACE_MS = 4000;

  function arm() {
    if (armed) return;
    armed = true;
    schedule();
  }

  function armAfterLoad() {
    window.setTimeout(arm, AUTOPLAY_GRACE_MS);
  }

  // A shopper who reaches for the carousel has finished waiting for the page,
  // so their first touch arms it too rather than making them sit out the grace.
  ['pointerdown', 'keydown'].forEach(function (name) {
    root.addEventListener(name, arm, { passive: true, once: true });
  });

  if (document.readyState === 'complete') armAfterLoad();
  else window.addEventListener('load', armAfterLoad, { once: true });

  var prev = root.querySelector('[data-ds-hero-prev]');
  var next = root.querySelector('[data-ds-hero-next]');
  if (prev) prev.addEventListener('click', function () { goTo(offsetIndex() - 1); schedule(); });
  if (next) next.addEventListener('click', function () { goTo(offsetIndex() + 1); schedule(); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i + firstReal); schedule(); });
  });

  // Throttle to one restage per frame: scroll fires far more often than the
  // dots can meaningfully change.
  var queued = false;
  var hasScrollEnd = 'onscrollend' in window;
  var idle = null;
  track.addEventListener('scroll', function () {
    if (!hasScrollEnd) {
      window.clearTimeout(idle);
      idle = window.setTimeout(recycle, 150);
    }
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; restage(); });
  }, { passive: true });
  if (hasScrollEnd) track.addEventListener('scrollend', recycle);

  // Autoplay must not run away while the shopper is reading or tabbing through.
  root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
  root.addEventListener('mouseleave', schedule);
  root.addEventListener('focusin', function () { window.clearInterval(timer); });
  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget)) schedule();
  });

  // Neither hover nor focus exists on a touch device, so without the two gates
  // below autoplay kept scrolling the largest element on the page after the
  // shopper had left it behind, and a backgrounded tab woke up mid-burst.
  var onScreen = true;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) window.clearInterval(timer);
    else if (onScreen) schedule();
  });

  if (typeof IntersectionObserver !== 'undefined') {
    new IntersectionObserver(function (entries) {
      onScreen = entries[entries.length - 1].isIntersecting;
      if (onScreen) schedule();
      else window.clearInterval(timer);
    }).observe(root);
  }

  restage();
  schedule();
}

function initHeroSliders(scope) {
  if (!scope) return;
  if (scope.matches && scope.matches(HERO)) bindHero(scope);
  if (scope.querySelectorAll) scope.querySelectorAll(HERO).forEach(bindHero);
}

if (!document.__dsHeroSliderBound) {
  document.__dsHeroSliderBound = true;
  var startHeroSliders = function () { initHeroSliders(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHeroSliders, { once: true });
  } else {
    startHeroSliders();
  }
  // Shopify Theme Editor re-renders a section into a fresh DOM subtree.
  document.addEventListener('shopify:section:load', startHeroSliders);

  // Sections injected after load (async section rendering, Storybook mount):
  // re-scan on the next frame, then stop. Watching the whole document forever
  // meant every unrelated mutation on the storefront — cart drawer, apps — woke
  // this up to re-query for a slider count that is fixed once the section is in.
  // The Theme Editor is covered by shopify:section:load above.
  if (typeof MutationObserver !== 'undefined') {
    var rescanQueued = false;
    var observer = new MutationObserver(function () {
      if (rescanQueued) return;
      rescanQueued = true;
      requestAnimationFrame(function () {
        rescanQueued = false;
        startHeroSliders();
        if (document.querySelector(HERO)) observer.disconnect();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "hero-slider" failed to initialise:', sfError);
}
})();

/* image-fallback.js */
(function () {
try {
/* image-fallback — a ds-image <img> that fails to load retries twice with
 * backoff (a composited preview can 404 briefly while it finishes generating
 * server-side, e.g. cart "Save as new" — CART-60). Its data-ds-image-loading
 * spinner covers the frame until load succeeds or retries are exhausted, then
 * the <img> hides itself so the tinted frame shows instead of a broken icon.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsImageFallbackBound) {
  document.__dsImageFallbackBound = true;
  var MAX_RETRIES = 2;

  function hideSpinner(img) {
    var wrap = img.closest('[data-ds-image]');
    var spinner = wrap && wrap.querySelector('[data-ds-image-loading]');
    if (spinner) spinner.hidden = true;
  }

  // This script is deferred, so a cached image can finish loading — firing its
  // one-time 'load' event — before the listener below is even attached, leaving
  // the spinner stuck over a photo that's already there.
  document.querySelectorAll('[data-ds-image] img').forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) hideSpinner(img);
  });

  document.addEventListener(
    'load',
    function (e) {
      if (e.target instanceof HTMLImageElement) hideSpinner(e.target);
    },
    true,
  );

  document.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!(img instanceof HTMLImageElement) || !img.src || img.hidden) return;
      if (!img.closest('[data-ds-image]')) return;
      var retries = Number(img.dataset.dsImageRetries || 0);
      if (retries >= MAX_RETRIES) {
        img.hidden = true;
        hideSpinner(img);
        return;
      }
      img.dataset.dsImageRetries = String(retries + 1);
      var src = img.src;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      setTimeout(function () {
        img.src = src + sep + '_retry=' + Date.now();
      }, 800 * (retries + 1));
    },
    true,
  );
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "image-fallback" failed to initialise:', sfError);
}
})();

/* image-lightbox.js */
(function () {
try {
/* image-lightbox — a shared single-image zoom. Any element with
 * [data-ds-image-zoom] and a data-ds-image-zoom-src opens the ds-image-lightbox
 * dialog showing that one image full size (add-on / cross-sell thumbnails today).
 * One dialog serves the whole page; the clicked element's src/alt are injected on
 * open.
 *
 * It owns only the dialog: open/close, portal to <body> (so a sticky/transformed
 * ancestor never traps its z-index — same reason as media-lightbox.js), scroll
 * lock, focus trap + restore. Progressive enhancement: without this script the
 * thumbnails are plain images, nothing breaks.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsImageLightboxBound) return;
  document.__dsImageLightboxBound = true;

  var lastTrigger = null;

  function getModal() {
    // A fixed overlay must live at the root to stack above everything; it is
    // authored inside the add-on block, which can sit in a stacking context.
    var all = document.querySelectorAll('[data-ds-image-lightbox]');
    for (var i = 1; i < all.length; i++) {
      all[i].parentNode && all[i].parentNode.removeChild(all[i]); // drop duplicates
    }
    var modal = all[0] || null;
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
    return modal;
  }

  function isOpen(modal) {
    return !!modal && modal.getAttribute('aria-hidden') === 'false';
  }

  function open(trigger) {
    var modal = getModal();
    if (!modal) return;
    var src = trigger.getAttribute('data-ds-image-zoom-src');
    if (!src) return;

    var alt = trigger.getAttribute('data-ds-image-zoom-alt') || '';
    var img = modal.querySelector('[data-ds-image-lightbox-img]');
    if (img) {
      img.setAttribute('src', src);
      img.setAttribute('alt', alt);
    }

    // Heading: cart preview keeps "Preview"; else an explicit title, else alt.
    var titleEl = modal.querySelector('[data-ds-image-lightbox-title]');
    if (titleEl && !modal.hasAttribute('data-ds-image-lightbox-cart')) {
      var title = trigger.getAttribute('data-ds-image-zoom-title') || alt;
      if (title) titleEl.textContent = title;
    }

    lastTrigger = trigger;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    var close = modal.querySelector('[data-ds-image-lightbox-close]');
    if (close) window.requestAnimationFrame(function () { close.focus(); });
  }

  function close() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    var img = modal.querySelector('[data-ds-image-lightbox-img]');
    if (img) img.removeAttribute('src'); // don't keep the last image decoded/visible
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function trapTab(e, modal) {
    var dialog = modal.querySelector('[data-ds-image-lightbox-dialog]') || modal;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-ds-image-lightbox-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var trigger = e.target.closest('[data-ds-image-zoom]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    var modal = getModal();
    if (isOpen(modal) && e.target === modal) close();
  });

  // Keyboard-open for the non-button triggers (an <img role="button" tabindex=0>).
  document.addEventListener('keydown', function (e) {
    var modal = getModal();
    if (isOpen(modal)) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') { trapTab(e, modal); return; }
    }
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var trigger = e.target.closest && e.target.closest('[data-ds-image-zoom]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
      }
    }
  });

  // Portal up front so the first open never flashes trapped under a sticky column.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', getModal, { once: true });
  } else {
    getModal();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "image-lightbox" failed to initialise:', sfError);
}
})();

/* input-counter.js */
(function () {
try {
/* input-counter — live "N/max" character count for a maxlength text field.
 * Binds [data-ds-input] with an [data-ds-input-counter] readout and a field
 * carrying maxlength (see snippets/ds-input.liquid). Progressive enhancement:
 * the field enforces maxlength natively; the readout just stays at its initial
 * server-rendered value without JS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function syncInputCounter(input) {
  var wrap = input.closest('[data-ds-input]');
  var counter = wrap && wrap.querySelector('[data-ds-input-counter]');
  var max = input.getAttribute('maxlength');
  if (!counter || !max) return;
  counter.textContent = input.value.length + '/' + max;
}

if (!document.__dsInputCounterBound) {
  document.__dsInputCounterBound = true;
  document.addEventListener('input', function (e) {
    var field = e.target;
    if (field instanceof HTMLInputElement && field.matches('[data-ds-input] input[maxlength]')) {
      syncInputCounter(field);
    }
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "input-counter" failed to initialise:', sfError);
}
})();

/* jump.js */
(function () {
try {
/* jump — scroll to the element a control names in [data-ds-jump].
 *
 * The value is a CSS selector, not an id, because the target is usually another
 * section whose id is generated by Shopify (the reviews band is
 * `ds-product-reviews-<section.id>-band`), so the caller can only name its hook.
 * A target inside a closed ds-accordion is opened first — scrolling to content
 * of zero height lands nowhere.
 *
 * Progressive enhancement: without this the control is inert, which is exactly
 * what the row was before it became a control.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsJumpBound) {
  document.__dsJumpBound = true;

  document.addEventListener('click', function (e) {
    var control = e.target.closest && e.target.closest('[data-ds-jump]');
    if (!control) return;
    var target = document.querySelector(control.getAttribute('data-ds-jump') || '');
    if (!target) return;
    e.preventDefault();

    var panel = target.closest('[data-ds-accordion-content]');
    if (panel) {
      var trigger = panel.parentNode.querySelector('[data-ds-accordion-trigger]');
      if (trigger && trigger.getAttribute('aria-expanded') === 'false') trigger.click();
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "jump" failed to initialise:', sfError);
}
})();

/* media-lightbox.js */
(function () {
try {
/* media-lightbox — opens the full-screen product image viewer (ds-media-lightbox)
 * from the gallery's main image or its ds-media-zoom trigger, and closes it
 * again. Rebuilds the "click the image → see it big in a modal" UX the PDP was
 * missing (T2147), modelled on the live wanderprints.com behaviour.
 *
 * It owns only the dialog: open/close, body scroll-lock, focus (trap + restore)
 * and keeping the modal on the same image as the inline gallery. The viewer
 * itself — track, chevrons, counter — is a plain ds-gallery in `bare` mode, so
 * behaviors/gallery.js drives it. The two galleries are paired by id: the inline
 * root carries data-ds-gallery-zoom="<id>" and the overlay is #<id>. Index is
 * synced both ways with the `ds:gallery:set` event gallery.js listens for.
 *
 * Open/closed is one attribute, [aria-hidden]; src/media-lightbox.css carries the
 * fade off it so a display utility never cuts the transition. Progressive
 * enhancement: without this script the gallery still swaps images inline, the
 * modal just never opens.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsMediaLightboxBound) return;
  document.__dsMediaLightboxBound = true;

  var lastTrigger = null;

  function isOpen(overlay) {
    return !!overlay && overlay.getAttribute('aria-hidden') === 'false';
  }

  // Portal the overlay to <body>. It is authored inside ds-gallery, which on the
  // PDP sits in a `position: sticky` column — and sticky creates its own stacking
  // context, trapping the overlay's z-index below the buy-box column that paints
  // after it (the variant pills would show over the modal). A fixed overlay must
  // live at the root to stack above everything. Also drops any stale twin a
  // section re-render (Theme Editor) may have left with the same id.
  function hoist(overlay) {
    if (!overlay) return overlay;
    if (overlay.id) {
      document.querySelectorAll('[data-ds-media-lightbox]').forEach(function (el) {
        if (el !== overlay && el.id === overlay.id && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    }
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    return overlay;
  }

  function hoistAll() {
    document.querySelectorAll('[data-ds-media-lightbox]').forEach(hoist);
  }

  function openOverlayEl() {
    var list = document.querySelectorAll('[data-ds-media-lightbox]');
    for (var i = 0; i < list.length; i++) {
      if (isOpen(list[i])) return list[i];
    }
    return null;
  }

  // The active-slide <video> of a gallery root — the inline preview or the
  // modal's own copy. null when the active slide is an image or an iframe embed.
  function activeVideo(galleryRoot) {
    if (!galleryRoot) return null;
    var idx = Number(galleryRoot.dataset.dsGalleryActive || 0);
    return galleryRoot.querySelector(
      'video[data-ds-gallery-video][data-ds-gallery-index="' + idx + '"]',
    );
  }

  // Continue a clip on the OTHER element at the position it was left. The inline
  // preview and the modal are two <video>s pointing at the same media, so this is
  // what "don't reload, keep playing" means across the boundary: seek to `time`
  // and, if it was rolling, resume. `preload="none"` leaves readyState 0 with no
  // seekable range yet — setting currentTime then is stored as the default start
  // position, and the loadedmetadata re-seek covers browsers that drop it, so the
  // element opens at `time` instead of flashing frame 0. Range requests + the
  // HTTP cache mean the bytes come back without a fresh full download.
  function resumeVideoAt(video, time, play) {
    if (!video) return;
    var seek = function () {
      try {
        if (Math.abs((video.currentTime || 0) - time) > 0.25) video.currentTime = time;
      } catch (e) {}
    };
    seek();
    if (video.readyState < 1) video.addEventListener('loadedmetadata', seek, { once: true });
    if (play) {
      var played = video.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
    }
  }

  function openFor(root, opener) {
    if (!root) return;
    var id = root.getAttribute('data-ds-gallery-zoom');
    var overlay = id ? hoist(document.getElementById(id)) : null;
    if (!overlay) return;

    lastTrigger = opener || root.querySelector('[data-ds-media-zoom-trigger]') || null;

    // Snapshot the inline preview BEFORE stopping it, so the modal picks the clip
    // up where the shopper left it instead of restarting at 0.
    var fromVideo = activeVideo(root);
    var snapshot = fromVideo
      ? { time: fromVideo.currentTime || 0, playing: !fromVideo.paused }
      : null;

    // Whatever the inline gallery was playing must not keep playing under the
    // modal — the shopper has moved to the big viewer.
    root.dispatchEvent(new CustomEvent('ds:gallery:stop', { bubbles: true }));
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    // Start the modal on whatever image the inline gallery is showing.
    var inner = overlay.querySelector('[data-ds-gallery]');
    if (inner) {
      inner.dispatchEvent(
        new CustomEvent('ds:gallery:set', {
          bubbles: true,
          // instant: the modal must open already ON this slide, never slide to it.
          detail: { index: Number(root.dataset.dsGalleryActive || 0), instant: true },
        }),
      );
      // Hand the position to the modal's own player. A preview that was rolling
      // continues MUTED (the modal's controls are where the shopper unmutes), so
      // there is neither a jump back to frame 0 nor surprise audio. The click is
      // a user gesture, so even the play() call is allowed.
      var toVideo = activeVideo(inner);
      if (toVideo && snapshot) {
        if (snapshot.playing) toVideo.muted = true;
        resumeVideoAt(toVideo, snapshot.time, snapshot.playing);
      }
    }

    // The image opens at fit; wire the slide-change reset and clear any zoom the
    // last open left on this overlay's images.
    ensureZoomObserver(overlay);
    resetZoom(overlay);

    var closeBtn = overlay.querySelector('[data-ds-media-zoom-close]');
    if (closeBtn) window.requestAnimationFrame(function () { closeBtn.focus(); });
  }

  function closeOverlay(overlay) {
    if (!overlay) return;

    // Leave the inline gallery on the image the shopper stepped to in the modal.
    var inner = overlay.querySelector('[data-ds-gallery]');
    var outer = overlay.id
      ? document.querySelector('[data-ds-gallery-zoom="' + overlay.id + '"]')
      : null;

    // Snapshot the modal player before it is stopped, to carry the position back
    // to the inline preview — closing must continue the clip, not rewind it to
    // where it stood when the modal opened.
    var fromVideo = inner ? activeVideo(inner) : null;
    var snapshot = fromVideo
      ? { time: fromVideo.currentTime || 0, playing: !fromVideo.paused }
      : null;

    if (inner && outer) {
      outer.dispatchEvent(
        new CustomEvent('ds:gallery:set', {
          bubbles: true,
          // instant: the inline gallery behind the modal jumps to match, so it is
          // not caught mid-slide when the overlay fades away.
          detail: { index: Number(inner.dataset.dsGalleryActive || 0), instant: true },
        }),
      );
      // ds:gallery:set already had gallery.js play or pause the inline preview by
      // whether the gallery is on screen; only correct its position and let that
      // visibility decision stand (never unmute — the inline stays a muted
      // preview, so `!toVideo.paused` here is that decision, not the modal's).
      var toVideo = activeVideo(outer);
      if (toVideo && snapshot) resumeVideoAt(toVideo, snapshot.time, !toVideo.paused);
    }
    // The overlay is only [aria-hidden] — still in the DOM and still painted —
    // so a video left playing keeps its audio going over the page. gallery.js
    // owns the media, so ask it to stop rather than reaching into the slides.
    if (inner) inner.dispatchEvent(new CustomEvent('ds:gallery:stop', { bubbles: true }));

    // Drop any zoom so the next open starts at fit, and abandon a gesture that was
    // still mid-flight when the modal was dismissed.
    resetZoom(overlay);
    clearZoomGesture();

    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  // Tab must cycle inside the dialog while open; the page behind is still painted
  // ([aria-hidden] only), so focus would otherwise walk out of the viewer.
  function trapTab(e, overlay) {
    var dialog = overlay.querySelector('[data-ds-media-lightbox-dialog]') || overlay;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  // ─── Zoom (pinch / drag on mobile, wheel + double-click + drag on desktop) ───
  // The modal is where a shopper inspects the mockup up close, so its active image
  // gets a hand-driven zoom. The zoom lives entirely on the active
  // <img data-ds-gallery-main> as a `translate3d(...) scale(...)` transform — it is
  // layered ON TOP of the track's own translateX (which owns slide position), so
  // the two never fight: the track slides, the image zooms within its frame (the
  // viewer's overflow-hidden clips the magnified image).
  //
  // gallery.js already binds a one-finger swipe on the same viewer to change
  // slides. So zoom must defer to swipe at scale 1 (a plain drag still flips the
  // image) and TAKE OVER once zoomed or on a two-finger pinch. It does that from
  // the capture phase on `document`: a capture listener runs before gallery's
  // bubble listener on the viewer, so calling stopPropagation there keeps the
  // swipe from ever seeing the gesture — but only when the gesture is ours.
  var ZOOM_MAX = 3;
  var zPointers = {}; // pointerId -> {x,y}  (live touches over the viewer)
  var zImg = null; // image the current gesture drives
  var zMode = null; // 'pan' | 'pinch' | null
  var zLast = { x: 0, y: 0 }; // last single-pointer position (pan)
  var zLastDist = 0; // last two-finger distance (pinch)
  var zLastMid = { x: 0, y: 0 }; // last two-finger midpoint (pinch)

  function zState(img) {
    return img.__dsZoom || (img.__dsZoom = { scale: 1, tx: 0, ty: 0 });
  }

  // The active image of the bare gallery inside an overlay (null when the active
  // slide is a video — zoom is images only, so gallery.js keeps the swipe there).
  function activeZoomImg(viewer) {
    var root = viewer && viewer.closest('[data-ds-gallery]');
    if (!root) return null;
    var idx = Number(root.dataset.dsGalleryActive || 0);
    var img = root.querySelector(
      'img[data-ds-gallery-main][data-ds-gallery-index="' + idx + '"]',
    );
    if (img) return img;
    // Storybook / placeholder path: a single main image carries no index.
    var mains = root.querySelectorAll('img[data-ds-gallery-main]');
    return mains.length === 1 ? mains[0] : null;
  }

  // Keep the magnified image from panning past its own edges: at scale s the image
  // box is s× the viewer, so it may travel at most (s-1)·half in each axis before a
  // gutter would show. Snaps back to centred at scale 1.
  function clampZoom(img) {
    var z = zState(img);
    if (z.scale <= 1) {
      z.scale = 1;
      z.tx = 0;
      z.ty = 0;
      return;
    }
    var v = img.closest('[data-ds-gallery-viewer]');
    var w = (v ? v.clientWidth : img.clientWidth) || 1;
    var h = (v ? v.clientHeight : img.clientHeight) || 1;
    var maxX = ((z.scale - 1) * w) / 2;
    var maxY = ((z.scale - 1) * h) / 2;
    z.tx = Math.max(-maxX, Math.min(maxX, z.tx));
    z.ty = Math.max(-maxY, Math.min(maxY, z.ty));
  }

  function applyZoom(img, animate) {
    var z = zState(img);
    var viewer = img.closest('[data-ds-gallery-viewer]');
    img.style.transition = animate
      ? 'transform var(--duration-base) var(--ease-standard)'
      : 'none';
    img.style.transformOrigin = 'center center';
    img.style.transform =
      'translate3d(' + z.tx + 'px,' + z.ty + 'px,0) scale(' + z.scale + ')';
    img.style.cursor = z.scale > 1 ? 'grab' : 'zoom-in';
    img.style.willChange = z.scale > 1 ? 'transform' : 'auto';
    if (z.scale > 1) img.setAttribute('data-ds-zoomed', 'true');
    else img.removeAttribute('data-ds-zoomed');
    // Own the touches only while zoomed; at scale 1 hand pan-y back so gallery.js
    // keeps its one-finger swipe (and vertical page gestures) working.
    if (viewer) viewer.style.touchAction = z.scale > 1 ? 'none' : 'pan-y';
  }

  // Focal point of a client coord expressed as an offset from the viewer centre —
  // the space the transform's translate lives in.
  function focal(img, clientX, clientY) {
    var v = img.closest('[data-ds-gallery-viewer]') || img;
    var r = v.getBoundingClientRect();
    return { x: clientX - (r.left + r.width / 2), y: clientY - (r.top + r.height / 2) };
  }

  // Scale toward a fixed focal point: solve t1 so the screen point under the
  // cursor/pinch-centre stays put across the scale change (t1 = F − (s1/s0)(F − t0)).
  function zoomToward(img, newScale, fx, fy) {
    var z = zState(img);
    newScale = Math.max(1, Math.min(ZOOM_MAX, newScale));
    var s0 = z.scale || 1;
    z.tx = fx - (newScale / s0) * (fx - z.tx);
    z.ty = fy - (newScale / s0) * (fy - z.ty);
    z.scale = newScale;
    clampZoom(img);
  }

  // Return every zoomed image in scope to its resting (unzoomed, centred) state.
  // Called on open, close, and any slide change so a fresh slide never inherits
  // the previous one's zoom.
  function resetZoom(scope) {
    (scope || document)
      .querySelectorAll('img[data-ds-gallery-main]')
      .forEach(function (img) {
        if (!img.__dsZoom) return;
        img.__dsZoom = { scale: 1, tx: 0, ty: 0 };
        applyZoom(img, false);
      });
  }

  function clearZoomGesture() {
    zMode = null;
    zImg = null;
    zPointers = {};
  }

  // Settle the end of a gesture: snap a barely-zoomed image back to 1 (so a tiny
  // pinch does not leave it stuck at 1.01) and animate the last frame.
  function finishZoomGesture() {
    if (zImg) {
      var z = zState(zImg);
      if (z.scale <= 1.02) {
        z.scale = 1;
        z.tx = 0;
        z.ty = 0;
      }
      clampZoom(zImg);
      applyZoom(zImg, true);
    }
    clearZoomGesture();
  }

  function twoPoints() {
    var ks = Object.keys(zPointers);
    return [zPointers[ks[0]], zPointers[ks[1]]];
  }
  function ptDist(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }
  function ptMid(a, b) {
    return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
  }

  // Reset the active image whenever the modal slides to a different one — covers
  // chevrons, the open-time index sync, and any programmatic ds:gallery:set.
  function ensureZoomObserver(overlay) {
    var root = overlay.querySelector('[data-ds-gallery]');
    if (!root || root.__dsZoomObserved || typeof MutationObserver === 'undefined') return;
    root.__dsZoomObserved = true;
    // Only a REAL index change resets — the pinch-start snap rewrites the
    // attribute to its current value, and that must not clear a zoom in flight.
    var last = root.dataset.dsGalleryActive;
    new MutationObserver(function () {
      var now = root.dataset.dsGalleryActive;
      if (now === last) return;
      last = now;
      resetZoom(overlay);
    }).observe(root, { attributes: true, attributeFilter: ['data-ds-gallery-active'] });
  }

  // pointerdown — decide who owns the gesture. Two fingers → pinch; one finger on
  // an already-zoomed image → pan; otherwise leave it for gallery.js's swipe.
  document.addEventListener(
    'pointerdown',
    function (e) {
      var overlay = e.target.closest && e.target.closest('[data-ds-media-lightbox]');
      if (!overlay || !isOpen(overlay)) return;
      // Never hijack the chevrons / close / any control.
      if (e.target.closest('button, a, [data-ds-gallery-prev], [data-ds-gallery-next]')) return;
      if (e.button != null && e.button > 0) return;
      var viewer = e.target.closest('[data-ds-gallery-viewer]');
      if (!viewer) return;
      var img = activeZoomImg(viewer);
      if (!img) return; // video slide → gallery.js

      zPointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(zPointers);

      if (ids.length >= 2) {
        // Pinch: a first finger may already have started a gallery drag — snap the
        // track back to the current slide so the pinch starts from a clean frame.
        var root = viewer.closest('[data-ds-gallery]');
        if (root) {
          root.dispatchEvent(
            new CustomEvent('ds:gallery:set', {
              bubbles: true,
              detail: { index: Number(root.dataset.dsGalleryActive || 0), instant: true },
            }),
          );
        }
        zImg = img;
        zMode = 'pinch';
        var p = twoPoints();
        zLastDist = ptDist(p[0], p[1]);
        zLastMid = ptMid(p[0], p[1]);
        img.style.transition = 'none';
        try { viewer.setPointerCapture(e.pointerId); } catch (err) {}
        e.stopPropagation();
        e.preventDefault();
      } else if (zState(img).scale > 1) {
        zImg = img;
        zMode = 'pan';
        zLast = { x: e.clientX, y: e.clientY };
        img.style.transition = 'none';
        img.style.cursor = 'grabbing';
        try { viewer.setPointerCapture(e.pointerId); } catch (err) {}
        e.stopPropagation();
        e.preventDefault();
      } else {
        // Scale 1, single pointer: this is a swipe — gallery.js owns it.
        zMode = null;
      }
    },
    true,
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!zMode || !zImg || !(e.pointerId in zPointers)) return;
      zPointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      e.stopPropagation();
      e.preventDefault();

      var z = zState(zImg);
      if (zMode === 'pinch') {
        if (Object.keys(zPointers).length < 2) return;
        var p = twoPoints();
        var d = ptDist(p[0], p[1]);
        var m = ptMid(p[0], p[1]);
        var v = zImg.closest('[data-ds-gallery-viewer]');
        var r = v.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;
        var fx = m.x - cx;
        var fy = m.y - cy;
        // Follow the midpoint (two-finger drag)…
        z.tx += fx - (zLastMid.x - cx);
        z.ty += fy - (zLastMid.y - cy);
        // …then scale about that same midpoint.
        var s0 = z.scale || 1;
        var s1 = Math.max(1, Math.min(ZOOM_MAX, s0 * (d / (zLastDist || d))));
        z.tx = fx - (s1 / s0) * (fx - z.tx);
        z.ty = fy - (s1 / s0) * (fy - z.ty);
        z.scale = s1;
        clampZoom(zImg);
        applyZoom(zImg, false);
        zLastDist = d;
        zLastMid = m;
      } else if (zMode === 'pan') {
        z.tx += e.clientX - zLast.x;
        z.ty += e.clientY - zLast.y;
        zLast = { x: e.clientX, y: e.clientY };
        clampZoom(zImg);
        applyZoom(zImg, false);
      }
    },
    true,
  );

  function zoomPointerEnd(e) {
    if (!(e.pointerId in zPointers)) return;
    delete zPointers[e.pointerId];
    if (zMode) e.stopPropagation();
    var ids = Object.keys(zPointers);
    if (zMode === 'pinch' && ids.length === 1) {
      // Second finger lifted mid-pinch: keep dragging with the one that remains.
      if (zState(zImg).scale > 1) {
        zMode = 'pan';
        zLast = zPointers[ids[0]];
      } else {
        finishZoomGesture();
      }
    } else if (zMode === 'pan' && ids.length >= 1) {
      zLast = zPointers[ids[0]];
    } else if (ids.length === 0) {
      finishZoomGesture();
    }
  }
  document.addEventListener('pointerup', zoomPointerEnd, true);
  document.addEventListener('pointercancel', zoomPointerEnd, true);

  // Desktop wheel — zoom toward the cursor. The modal already locks page scroll,
  // so the wheel is free to mean "zoom".
  document.addEventListener(
    'wheel',
    function (e) {
      var overlay = e.target.closest && e.target.closest('[data-ds-media-lightbox]');
      if (!overlay || !isOpen(overlay)) return;
      var viewer = e.target.closest('[data-ds-gallery-viewer]');
      if (!viewer) return;
      var img = activeZoomImg(viewer);
      if (!img) return;
      e.preventDefault();
      var f = focal(img, e.clientX, e.clientY);
      zoomToward(img, zState(img).scale * Math.exp(-e.deltaY * 0.0015), f.x, f.y);
      applyZoom(img, false);
    },
    { passive: false },
  );

  // Desktop double-click — toggle between fit and 2×, zooming toward the cursor.
  document.addEventListener('dblclick', function (e) {
    var overlay = e.target.closest && e.target.closest('[data-ds-media-lightbox]');
    if (!overlay || !isOpen(overlay)) return;
    var viewer = e.target.closest('[data-ds-gallery-viewer]');
    if (!viewer) return;
    var img = activeZoomImg(viewer);
    if (!img) return;
    e.preventDefault();
    var z = zState(img);
    if (z.scale > 1) {
      z.scale = 1;
      z.tx = 0;
      z.ty = 0;
      applyZoom(img, true);
    } else {
      var f = focal(img, e.clientX, e.clientY);
      zoomToward(img, 2, f.x, f.y);
      applyZoom(img, true);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Close: the X control inside the overlay.
    var closeBtn = t.closest('[data-ds-media-lightbox-close]');
    if (closeBtn) {
      e.preventDefault();
      closeOverlay(closeBtn.closest('[data-ds-media-lightbox]'));
      return;
    }

    // Open: the explicit zoom trigger button over the image.
    var trigger = t.closest('[data-ds-media-zoom-trigger]');
    if (trigger) {
      e.preventDefault();
      openFor(trigger.closest('[data-ds-gallery]'), trigger);
      return;
    }

    // Close: clicking the dimmed backdrop (the overlay itself, not its card).
    var overlay = t.closest('[data-ds-media-lightbox]');
    if (overlay && isOpen(overlay) && t === overlay) {
      closeOverlay(overlay);
      return;
    }

    // Open: ONLY a real gallery slide opens the zoom — never the whole viewer.
    // Personalization apps (Customily) drop an interactive <canvas> over the main
    // image; keying on [data-ds-gallery-main] means a click on that canvas (or any
    // app overlay sitting above the image) is not ours to catch, so it never
    // hijacks into an empty modal. The explicit zoom button above still works.
    // The inline video preview carries the same marker on purpose: it has no
    // controls, so a click on it is the same "see it big" gesture as on an image,
    // and the modal is where that video gets its real player.
    var mainImg = t.closest('[data-ds-gallery-main]');
    if (mainImg) {
      var imgRoot = mainImg.closest('[data-ds-gallery]');
      // Only the inline gallery is zoomable (it carries data-ds-gallery-zoom); the
      // bare gallery inside the modal has none, so its own images never re-open it.
      if (imgRoot && imgRoot.getAttribute('data-ds-gallery-zoom')) openFor(imgRoot, null);
    }
  });

  document.addEventListener('keydown', function (e) {
    var overlay = openOverlayEl();
    if (!overlay) return;
    if (e.key === 'Escape') {
      closeOverlay(overlay);
      return;
    }
    if (e.key === 'Tab') trapTab(e, overlay);
  });

  // Portal overlays out of their sticky/stacking-context columns up front, so the
  // first open never flashes trapped-under-the-buy-box.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistAll, { once: true });
  } else {
    hoistAll();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "media-lightbox" failed to initialise:', sfError);
}
})();

/* number-input.js */
(function () {
try {
/* number-input — stepper +/- buttons around a native <input type=number>.
 * Binds [data-ds-number-input] and data-ds-number-input-{decrease,increase}
 * (see snippets/ds-number-input.liquid). The native field stays the value
 * store; buttons dispatch input/change on it so theme code listens on the field.
 * Progressive enhancement: the field is usable by keyboard without JS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var NUMBER = '[data-ds-number-input]';
var DECREASE = '[data-ds-number-input-decrease]';
var INCREASE = '[data-ds-number-input-increase]';
// Settle time before a stepper click commits its 'change' — the event other
// behaviors (e.g. cart-lines.js) treat as "fire the network request". Without
// this, holding + fires one fetch per click instead of one per burst.
var CHANGE_SETTLE = 400;

function numBound(input, attr, fallback) {
  var raw = input.getAttribute(attr);
  if (raw === null || raw === '') return fallback;
  var value = Number(raw);
  return Number.isNaN(value) ? fallback : value;
}

function numCurrent(input, min) {
  var value = Number(input.value);
  if (!Number.isNaN(value)) return value;
  return min === -Infinity ? 0 : min;
}

function numSync(root) {
  var input = root.querySelector('input[type="number"]');
  if (!input) return;
  var min = numBound(input, 'min', -Infinity);
  var max = numBound(input, 'max', Infinity);
  var value = numCurrent(input, min);
  var decrease = root.querySelector(DECREASE);
  var increase = root.querySelector(INCREASE);
  if (decrease) decrease.disabled = input.disabled || value <= min;
  if (increase) increase.disabled = input.disabled || value >= max;
}

function numStep(root, direction) {
  var input = root.querySelector('input[type="number"]');
  if (!input || input.disabled) return;
  var min = numBound(input, 'min', -Infinity);
  var max = numBound(input, 'max', Infinity);
  var size = numBound(input, 'step', 1) || 1;
  var value = numCurrent(input, min);
  var next = Math.min(max, Math.max(min, value + direction * size));
  if (next === value) return;
  input.value = String(next);
  input.dispatchEvent(new Event('input', { bubbles: true }));
  numSync(root);
  if (input.__dsChangeTimer) window.clearTimeout(input.__dsChangeTimer);
  input.__dsChangeTimer = window.setTimeout(function () {
    input.__dsChangeTimer = 0;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, CHANGE_SETTLE);
}

// A typed value bypasses numStep's own clamp entirely, and PDP add-to-cart forms
// carry novalidate (so the browser's own min/max check never runs) — so -1 or a
// blank field would otherwise reach /cart/add.js untouched. Runs on the capture
// phase so it lands before any other 'change' listener (cart-lines.js, form
// submit) reads the field, regardless of script load order.
// ponytail: no upper bound when the field carries no `max` (PDP/cart never set
// one today) — inventory-based caps would be invented business logic. Add a
// `max` in ds-number-input.liquid callers once inventory limits are wired.
function numClamp(input) {
  var min = numBound(input, 'min', -Infinity);
  var max = numBound(input, 'max', Infinity);
  var value = Number(input.value);
  if (!Number.isFinite(value)) value = min === -Infinity ? 0 : min;
  var clamped = Math.min(max, Math.max(min, value));
  if (String(clamped) !== input.value) input.value = String(clamped);
}

if (!document.__dsNumberInputBound) {
  document.__dsNumberInputBound = true;

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var button = target.closest(DECREASE + ',' + INCREASE);
    if (!button || button.disabled) return;
    var root = button.closest(NUMBER);
    if (root) numStep(root, button.matches(INCREASE) ? 1 : -1);
  });

  document.addEventListener('input', function (e) {
    var field = e.target;
    if (field instanceof HTMLInputElement && field.matches(NUMBER + ' input[type="number"]')) {
      var root = field.closest(NUMBER);
      if (root) numSync(root);
    }
  });

  document.addEventListener('change', function (e) {
    var field = e.target;
    if (field instanceof HTMLInputElement && field.matches(NUMBER + ' input[type="number"]')) {
      numClamp(field);
      var root = field.closest(NUMBER);
      if (root) numSync(root);
    }
  }, true);
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "number-input" failed to initialise:', sfError);
}
})();

/* product-rail.js */
(function () {
try {
/* product-rail — category/product bands' finite carousel: arrows and swipe.
 *
 * Binds EVERY rail, not just the always-scrolling one. The other shape wraps
 * into a grid from md but still scrolls below it, and arrows follow the
 * scrolling rather than the shape — so the same file drives both and simply
 * asks, at each width, whether this track scrolls at all.
 *
 * The track is already a native horizontal scroller (snippets/ds-product-rail
 * .liquid), so swipe works with no JS and every tile is reachable by keyboard
 * before this file runs. This adds the two things the markup cannot express:
 * the arrows scroll by a whole number of tiles, and the buttons disable at the
 * real start/end of the row.
 *
 * How far one click travels is the section's call, and it differs by end — the
 * mobile track shows fewer tiles, so the desktop jump would overshoot the whole
 * viewport. Both counts arrive as attributes and the breakpoint is read from
 * `--breakpoint-md` rather than typed here, so a token change moves the JS with
 * the CSS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var RAIL = '[data-ds-product-rail]';

function desktopQuery() {
  var token = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('--breakpoint-md')
    .trim();
  return '(min-width: ' + (token || '768px') + ')';
}

function bindRail(root) {
  if (root.dataset.dsRailBound) return;
  root.dataset.dsRailBound = '1';

  var track = root.querySelector('[data-ds-product-rail-track]');
  var nav = root.querySelector('[data-ds-carousel-nav]');
  if (!track) return;

  var reals = Array.prototype.slice.call(track.children);
  if (!reals.length) {
    if (nav) nav.remove();
    return;
  }

  // Read once: a section cannot change its own settings without the Theme
  // Editor re-rendering the whole subtree, which re-binds from scratch.
  var stepDesktop = Math.max(1, Number(root.dataset.dsRailStep) || 1);
  var stepMobile = Math.max(1, Number(root.dataset.dsRailStepMobile) || 1);
  var wide = window.matchMedia(desktopQuery());
  var prev = root.querySelector('[data-ds-carousel-nav-prev]');
  var next = root.querySelector('[data-ds-carousel-nav-next]');

  function tilesPerClick() {
    return Math.max(1, wide.matches ? stepDesktop : stepMobile);
  }

  function step() {
    // One tile plus one gutter, measured rather than assumed: the tile width is
    // the `auto-cols-rail-*` calc off the per-view count and the gutter changes
    // at md, so any number hardcoded here would be wrong at one end or the
    // other.
    var first = reals[0];
    var box = first.getBoundingClientRect().width;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return box + gap;
  }

  function scrollable() {
    // Asked of the layout, not of the summed tile widths. A wrapped grid's
    // tiles add up far wider than the track while the track itself does not
    // scroll at all — summing them reported overflow on a grid.
    return track.scrollWidth > track.clientWidth + 1;
  }

  function updateNav() {
    if (!nav) return;
    var canScroll = scrollable();
    nav.hidden = !canScroll;
    var atStart = !canScroll || track.scrollLeft <= 1;
    var atEnd = !canScroll || track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function restage() {
    track.scrollLeft = Math.min(track.scrollLeft, Math.max(0, track.scrollWidth - track.clientWidth));
    updateNav();
  }

  function scrollBy(direction) {
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var target = Math.max(0, Math.min(max,
      track.scrollLeft + direction * step() * tilesPerClick()));
    // A smooth scroll reports its first scroll event on a later frame. Update
    // from the clamped destination immediately so Prev becomes usable as soon
    // as Next is pressed instead of looking stuck during the animation.
    if (prev) prev.disabled = target <= 1;
    if (next) next.disabled = target >= max - 1;
    track.scrollTo({
      left: target,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
  if (next) next.addEventListener('click', function () { scrollBy(1); });

  var scrollQueued = false;
  track.addEventListener('scroll', function () {
    if (scrollQueued) return;
    scrollQueued = true;
    window.requestAnimationFrame(function () {
      scrollQueued = false;
      updateNav();
    });
  }, { passive: true });

  // The per-view count is a media query, so a width change moves both the tile
  // width and the gutter — every number above has to be re-measured.
  // Width only. restage() clamps the scroll position, so running it on every
  // observed box change — a tile's image settling, a label wrapping — would
  // yank the row back to the start mid-browse.
  var lastWidth = 0;
  function onResize() {
    var width = track.clientWidth;
    if (width === lastWidth) return;
    lastWidth = width;
    restage();
  }

  if (typeof ResizeObserver !== 'undefined') {
    var queued = false;
    new ResizeObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; onResize(); });
    }).observe(track);
  } else {
    window.addEventListener('resize', onResize);
  }

  lastWidth = track.clientWidth;
  restage();
}

function initRails(scope) {
  if (!scope) return;
  if (scope.matches && scope.matches(RAIL)) bindRail(scope);
  if (scope.querySelectorAll) scope.querySelectorAll(RAIL).forEach(bindRail);
}

if (!document.__dsProductRailBound) {
  document.__dsProductRailBound = true;
  var startRails = function () { initRails(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRails, { once: true });
  } else {
    startRails();
  }
  document.addEventListener('shopify:section:load', startRails);

  if (typeof MutationObserver !== 'undefined') {
    var rescanQueued = false;
    var observer = new MutationObserver(function () {
      if (rescanQueued) return;
      rescanQueued = true;
      requestAnimationFrame(function () {
        rescanQueued = false;
        startRails();
        if (document.querySelector(RAIL)) observer.disconnect();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-rail" failed to initialise:', sfError);
}
})();

/* product-reviews.js */
(function () {
try {
/* product-reviews — turns Judge.me's widget markup into this theme's review list.
 *
 * Why parse HTML at all. Judge.me publishes no JSON a storefront can read: the
 * `judgeme.review_widget_data` metafield does not exist, the cache server and
 * `api.judge.me/api/v1/widgets/*` answer with pre-rendered HTML, and the one
 * real JSON endpoint needs a private token that cannot ship in a theme. What IS
 * open is `api.judge.me/reviews/reviews_for_widget` — no token at all — and it
 * returns `{"html": …}`. So HTML is the only feed, and reading it is the price
 * of not standing up an App Proxy.
 *
 * What makes that safe enough. Judge.me stamps the review's actual data onto
 * attributes — data-review-id, data-verified-buyer, data-score, and a <time>
 * with a real datetime — and those change far less often than class names. The
 * parser reads attributes first and falls back to a class only for the body,
 * the author and the reply, where there is nothing else. If a page yields no
 * parsable reviews, the original widget is left visible and this file does
 * nothing: the failure mode is Judge.me's own design, never an empty column.
 *
 * Filtering is done here rather than upstream because the endpoint cannot do
 * it. `filter_rating`, `sort_by` and `sort_dir` are the only levers it has —
 * there is no "with photo" and no "verified only", which the design asks for.
 * One `per_page=100` request brings the whole set back (27 of 35 on the probed
 * product; the rest are ratings with no body, which Judge.me does not render),
 * so every chip, the sort and the pagination run over data already in hand and
 * cost no further requests.
 *
 * Page 1 needs no request at all: it is already in the DOM, because the section
 * renders the widget metafield server-side, so reviews paint with the rest of
 * the page. The rest is fetched once, immediately after — not lazily on first
 * interaction, because the chip counts, the sort and the page count are all
 * claims about the WHOLE set. "With photo (1)" computed over the five reviews
 * that happened to be in page 1 is not a smaller truth, it is a wrong number.
 * So those three controls stay hidden until the full set lands, and the list
 * shows page 1 in the meantime.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var ROOT = '[data-ds-product-reviews]';
/* Five was read off the Figma frame, and it turns out to be the merchant's own
 * setting rather than a coincidence: `shop.metafields.judgeme.settings` carries
 * jdgmSettings, which opens `{"pagination":5,…}`. So this page size is what a
 * shopper already sees in Judge.me's widget, and the two do not disagree.
 * Left as a literal on purpose — that metafield is a 39KB <script> tag, and
 * regexing a number out of it in Liquid to arrive back at 5 buys nothing. If a
 * merchant ever changes it there, change it here. */
var PER_PAGE = 5;
var API = 'https://api.judge.me/reviews/reviews_for_widget';

/* The ceiling for ONE request. Judge.me promises nothing about timing, and a
 * page that hangs forever leaves a permanent skeleton and two locked controls —
 * the shopper cannot get out. On timeout we abort and release the controls: an
 * empty page is at least one you can ask for again. */
var PAGE_TIMEOUT = 8000;

/* ── Parsing ──────────────────────────────────────────────────────────────── */

function text(node, selector) {
  var found = node.querySelector(selector);
  return found ? found.textContent.trim() : '';
}

/* One `.jdgm-rev` element to a plain object. Returns null for anything that
 * carries no body — Judge.me emits placeholder rows we have no design for. */
function parseReview(el) {
  var body = text(el, '.jdgm-rev__body');
  if (!body) return null;

  var title = text(el, '.jdgm-rev__title');
  var rating = el.querySelector('.jdgm-rev__rating');
  var time = el.querySelector('.jdgm-rev__timestamp');
  var reply = text(el, '.jdgm-rev__reply');

  var photos = [];
  el.querySelectorAll('.jdgm-rev__pic-link').forEach(function (link) {
    var img = link.querySelector('img');
    // Judge.me lazy-loads its own thumbnails, so the real URL sits in data-src
    // on the <img> while the anchor holds the full-size one.
    var src = (img && (img.getAttribute('data-src') || img.getAttribute('src'))) || link.getAttribute('href');
    if (src) photos.push({ src: src, full: link.getAttribute('href') || src });
  });

  return {
    id: el.getAttribute('data-review-id') || '',
    helpful: parseInt(el.getAttribute('data-thumb-up-count'), 10) || 0,
    author: text(el, '.jdgm-rev__author'),
    /* The variant the review was left on, which Judge.me only carries when the
     * merchant configured it as a custom question — `.jdgm-rev__custom-form` is
     * present but EMPTY on this store. So this is '' far more often than not,
     * and the filter panel's VARIANT group stays hidden on that evidence rather
     * than drawing an empty fieldset. */
    variant: text(el, '.jdgm-rev__variant') || text(el, '.jdgm-rev__custom-form'),
    // Shown only by the lightbox — the reviews list's Figma frame hides it.
    title: title,
    verified: el.getAttribute('data-verified-buyer') === 'true',
    rating: rating ? parseInt(rating.getAttribute('data-score'), 10) || 0 : 0,
    dateIso: time ? time.getAttribute('datetime') || '' : '',
    body: body,
    photos: photos,
    reply: reply,
  };
}

function parseAll(root) {
  var out = [];
  root.querySelectorAll('.jdgm-rev').forEach(function (el) {
    var review = parseReview(el);
    if (review) out.push(review);
  });
  return out;
}

/* The published aggregate, read off the widget metafield the section already
 * parked in the source node. Judge.me stamps its DISPLAYED numbers onto the
 * `.jdgm-rev-widg` root (data-average-rating / data-number-of-reviews) and the
 * per-star frequencies onto `.jdgm-histogram__row` (data-rating + data-
 * frequency). These are the same values the Liquid now seeds the summary with;
 * re-reading them here keeps the rail correct after a theme-editor re-render and
 * self-heals if the server seed ever parsed the markup wrong. Returns null when
 * the widget markup carries no aggregate, so the server render is left alone. */
function readAggregate(source) {
  var widg = source.querySelector('.jdgm-rev-widg');
  if (!widg) return null;
  var avgAttr = widg.getAttribute('data-average-rating');
  var cntAttr = widg.getAttribute('data-number-of-reviews');
  if (avgAttr == null && cntAttr == null) return null;

  var dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  source.querySelectorAll('.jdgm-histogram__row').forEach(function (row) {
    var stars = parseInt(row.getAttribute('data-rating'), 10);
    if (dist[stars] === undefined) return;
    dist[stars] = parseInt(row.getAttribute('data-frequency'), 10) || 0;
  });

  return {
    /* Drop the trailing zero: Judge.me writes `data-average-rating='3.90'`, but
     * "3.90" is a storage detail rather than how it reads. 4.93 still gives
     * 4.93. */
    averageText: avgAttr != null && !isNaN(parseFloat(avgAttr)) ? String(parseFloat(avgAttr)) : null,
    averageValue: avgAttr != null ? parseFloat(avgAttr) : null,
    count: cntAttr != null ? parseInt(cntAttr, 10) || 0 : null,
    dist: dist,
  };
}

/* Write that aggregate into the summary rail: the big score, the star row, the
 * "Based on N reviews" line and the five distribution bars. Idempotent, so it
 * runs whether the Liquid seed was already right (the common case) or stale. */
function applyAggregate(root, agg) {
  if (!agg) return;

  /* A number the merchant typed in the theme editor is the final word — the
   * section stamps it on the root, and the widget metafield may not overwrite
   * it. */
  if (agg.averageText != null && !root.hasAttribute('data-ds-reviews-score-pinned')) {
    var scoreEl = root.querySelector('[data-ds-reviews-score]');
    if (scoreEl) scoreEl.textContent = agg.averageText;
  }

  if (agg.averageValue != null && !isNaN(agg.averageValue)) {
    var stars = root.querySelector('[data-ds-reviews-stars] [data-ds-rating]');
    if (stars) setStars(stars, agg.averageValue);
  }

  if (agg.count != null && !root.hasAttribute('data-ds-reviews-count-pinned')) {
    // Swap only the number, leaving the localized wording ("Based on …", "Basé
    // sur …") untouched — the count is the one thing that moved.
    var summaryEl = root.querySelector('[data-ds-reviews-summary]');
    if (summaryEl && /\d/.test(summaryEl.textContent)) {
      summaryEl.textContent = summaryEl.textContent.replace(/\d[\d.,]*/, String(agg.count));
    }
  }

  var order = [5, 4, 3, 2, 1];
  var peak = Math.max(agg.dist[5], agg.dist[4], agg.dist[3], agg.dist[2], agg.dist[1], 0);
  // No histogram in the widget markup (peak 0) means we have no published
  // distribution — leave whatever the server rendered rather than zeroing every
  // bar. A genuinely review-less product shows the empty card, not bars, anyway.
  var bars = peak > 0 ? root.querySelector('[data-ds-rating-bars]') : null;
  if (bars) {
    bars.querySelectorAll('[data-ds-rating-bar-row]').forEach(function (row, index) {
      var freq = agg.dist[order[index]] || 0;
      // Percent of the peak row, matching ds-rating-bars' own scaling. Set as an
      // inline width so it wins over the attribute-keyed rules in rating-bars.css
      // without needing a class for every possible percentage.
      var fill = row.querySelector('[data-ds-rating-bar-fill]');
      if (fill) fill.style.width = (peak > 0 ? Math.round((freq * 100) / peak) : 0) + '%';
      var spans = row.querySelectorAll(':scope > span');
      var count = spans[spans.length - 1];
      if (count) count.textContent = String(freq);
    });
  }
}

/* Judge.me renders its timestamps client-side, so the DOM text is usually
 * empty and only the ISO attribute is trustworthy. Relative wording is built
 * here from that, in the page's own language. */
function relativeDate(iso) {
  if (!iso) return '';
  var then = Date.parse(iso);
  if (isNaN(then)) return '';
  var days = Math.round((Date.now() - then) / 86400000);
  var lang = document.documentElement.lang || 'en';
  if (typeof Intl === 'undefined' || !Intl.RelativeTimeFormat) {
    return new Date(then).toLocaleDateString(lang);
  }
  var rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
  if (days < 7) return rtf.format(-days, 'day');
  if (days < 35) return rtf.format(-Math.round(days / 7), 'week');
  if (days < 365) return rtf.format(-Math.round(days / 30), 'month');
  return rtf.format(-Math.round(days / 365), 'year');
}

/* ── Rendering ────────────────────────────────────────────────────────────── */

/* Fill one cloned ds-review-item. Every optional node is REMOVED rather than
 * hidden when its data is missing, so the article's flex gaps close up the way
 * they would have if Liquid had never rendered it. */
function fillReview(node, review, photoTemplate) {
  // photoTemplate here is the REVIEW tile (76 -> 140), not the strip's (84).
  var author = node.querySelector('[data-ds-review-author]');
  if (author) author.textContent = review.author;


  /* Removed, not blanked: an empty <p> still takes a flex gap, and no review on
   * this store carries a title today. */
  var title = node.querySelector('[data-ds-review-title]');
  if (title) {
    if (!review.title) title.remove();
    else title.textContent = review.title;
  }

  var body = node.querySelector('[data-ds-review-body]');
  if (body) body.textContent = review.body;

  var date = node.querySelector('[data-ds-review-date]');
  if (date) {
    date.setAttribute('datetime', review.dateIso);
    date.textContent = relativeDate(review.dateIso);
  }

  var stars = node.querySelector('[data-ds-rating]');
  if (stars) setStars(stars, review.rating);

  var verified = node.querySelector('[data-ds-review-verified]');
  if (verified && !review.verified) verified.remove();

  var photos = node.querySelector('[data-ds-review-photos]');
  if (photos) {
    if (!review.photos.length) {
      photos.remove();
    } else {
      photos.innerHTML = '';
      review.photos.forEach(function (photo) {
        var tile = photoTemplate.content.firstElementChild.cloneNode(true);
        var img = tile.querySelector('img');
        if (img) {
          img.setAttribute('src', photo.src);
          img.removeAttribute('srcset');
          img.setAttribute('alt', '');
        }
        // The lightbox walks the whole product's strip, not just this review's,
        // so a body photo opens at its position in that flat list.
        tile.setAttribute('data-ds-reviews-photo-src', photo.src);
        photos.appendChild(tile);
      });
    }
  }

  var reply = node.querySelector('[data-ds-review-reply]');
  if (reply) {
    if (!review.reply) {
      reply.remove();
    } else {
      var replyBody = reply.querySelector('[data-ds-review-reply-body]');
      if (replyBody) replyBody.textContent = review.reply;
    }
  }
  return node;
}

/* ds-rating draws five stacked star pairs and reveals the overlay with a width
 * utility. Re-pointing it at another score means toggling those same classes —
 * no new markup, no second star implementation here. */
function setStars(container, score) {
  var halves = Math.max(0, Math.min(10, Math.round(score * 2)));
  container.setAttribute('data-ds-rating-value', String(score));
  // Each slot is `<span class="sf-relative">{svg}{overlay?}</span>`; the overlay
  // is the only child <span>, and it exists on every slot because the template
  // renders ds-rating at its default 5.
  container.querySelectorAll('[role="img"] > span').forEach(function (slot, index) {
    var overlay = slot.querySelector('span');
    if (!overlay) return;
    var filled = (index + 1) * 2;
    overlay.classList.remove('sf-w-full', 'sf-w-1/2', 'sf-hidden');
    if (halves >= filled) overlay.classList.add('sf-w-full');
    else if (halves === filled - 1) overlay.classList.add('sf-w-1/2');
    else overlay.classList.add('sf-hidden');
  });
}

/* ── One band ─────────────────────────────────────────────────────────────── */

function setup(root) {
  var source = root.querySelector('[data-ds-reviews-source]');
  var list = root.querySelector('[data-ds-reviews-list]');
  var template = root.querySelector('[data-ds-review-template]');
  var photoTemplate = root.querySelector('[data-ds-reviews-photo-template]');
  var reviewPhotoTemplate = root.querySelector('[data-ds-review-photo-template]');
  var morePhotoTemplate = root.querySelector('[data-ds-reviews-photo-more-template]');
  var pageTemplate = root.querySelector('[data-ds-reviews-page-template]');
  var ellipsisTemplate = root.querySelector('[data-ds-reviews-ellipsis-template]');
  if (!source || !list || !template) return;
  if (!photoTemplate || !morePhotoTemplate || !pageTemplate || !ellipsisTemplate) return;
  if (!reviewPhotoTemplate) return;

  // Reconcile the summary rail with the widget metafield's published numbers
  // first — this is independent of the list below, so it also corrects a
  // rating-only product where parseAll finds nothing to render.
  var aggregate = readAggregate(source);
  applyAggregate(root, aggregate);

  var all = parseAll(source);
  // Nothing parsable: fall back to Judge.me's own widget and stand down. The
  // source now ships hidden (the Liquid `sf-hidden`, to kill the first-paint
  // flash), so un-hide it here — otherwise a widget our parser can't read would
  // leave a blank column instead of Judge.me's working one.
  if (!all.length) {
    source.classList.remove('sf-hidden');
    return;
  }

  var state = { sort: '', rating: 0, photo: false, verified: false, variants: [], page: 1, shown: PER_PAGE, complete: false };
  // Every photo on the product, flattened, each remembering the review it came
  // from — the lightbox steps through this rather than through the reviews.
  var strip = [];

  source.classList.add('sf-hidden');

  /* The CONTIGUOUS prefix from page 1 of the current query. Used by mobile
   * (which appends) and by the photo filter; desktop reads `rowsForPage`
   * directly.
   *
   * Contiguous, not "every page loaded": desktop fetches per click, so the cache
   * can be {1, 5, 6}. Concatenating all three puts page 5's first review at
   * index 6 — mobile's `state.shown` and `appendMore` (next page = length + 1)
   * both count by position, so a sparse cache yields rows in the wrong place and
   * asks for the wrong page. Cutting at the first gap is enough to keep both
   * honest. */
  function loadedRows() {
    syncQuery();
    var out = [];
    for (var n = 1; pages[n]; n += 1) out = out.concat(pages[n]);
    return out;
  }

  /* The set the LOCAL filters run on. Judge.me has no parameter that filters by
   * photo — all of them were probed (`with_pictures`, `has_pictures`,
   * `pictures_only`, `filter_pictures`, `media`, `only_pictures`: `total_count`
   * never moved) — so "which reviews have photos" can only be answered by
   * reading reviews.
   *
   * The source is the reviews `loadStrip` ALREADY fetched, not whichever pages
   * the shopper happened to click through. It costs no extra request and is wide
   * enough to still have a pager. The shop sets
   * `default_sort_method = pictures-first`, so reviews with photos sit in one
   * block at the front — the first 20 are the densest stretch of photos a single
   * request can reach.
   *
   * The remaining limit, stated plainly: a review with photos beyond that block
   * is out of this filter's reach. Reaching it means reading every review, which
   * is sequential pagination. */
  function photoPool() {
    /* The same source as `stripVisible`, and they may not diverge. The old
     * version fell back to `loadedRows()` when `loadStrip` failed while the strip
     * still drew from `all` — so the shopper could click a photo the filter could
     * not reach: forcing `loadStrip` to fail with 7 photo reviews gave a list of
     * 5 rows, NO pager, and "See this review" on the seventh tile silently did
     * nothing. The filter's set must be exactly the strip's, never smaller. */
    return stripRows && stripRows.length ? stripRows : all;
  }

  /* A review's position in an array, matched on Judge.me's `id`, falling back to
   * object identity only when the review carries no id. */
  function indexOfReview(rows, wanted) {
    if (!wanted) return -1;
    if (!wanted.id) return rows.indexOf(wanted);
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i] === wanted || rows[i].id === wanted.id) return i;
    }
    return -1;
  }

  /* The strip's set with the active filters applied. The underlying request
   * carries no filter parameters, so rating/verified/variant have to be applied
   * locally — the same thing `visible()` does when it runs on this set. */
  function stripVisible() {
    return (stripRows || all).filter(function (review) {
      if (!review.photos.length) return false;
      if (state.rating && review.rating !== state.rating) return false;
      if (state.verified && !review.verified) return false;
      if (state.variants.length && state.variants.indexOf(review.variant || '') === -1) return false;
      return true;
    });
  }

  function visible() {
    /* Turning on the photo filter swaps the source: from the list (which the
     * server already filtered by sort/rating/verified) to the strip's set (one
     * request carrying NO filter parameters). So on that swap, rating and
     * verified must be applied LOCALLY — otherwise they vanish in silence:
     * "Verified buyer + With photos" measured exactly the same 20 reviews as
     * "With photos" alone, meaning the verified tick did nothing. Filtering those
     * 20 is exact, not an approximation. */
    var onPool = state.photo;
    if (onPool) return sortPool(photoPool().filter(keep));
    return loadedRows().filter(keep);

    function keep(review) {
      if (state.photo && !review.photos.length) return false;
      if (onPool && state.verified && !review.verified) return false;
      if (onPool && state.rating && review.rating !== state.rating) return false;
      if (state.variants.length && state.variants.indexOf(review.variant || '') === -1) return false;
      return true;
    }
  }

  /* Sort LOCALLY, and only for the strip's set.
   *
   * That set arrives from a request carrying no `sort_by` (deliberately — it is
   * the only way to ask for the shop's pictures-first order), so without a local
   * sort, changing the sort while "With photos" is on is a click that does
   * nothing: the trigger reads "Lowest rating" while the list sits still. The set
   * is 20 reviews already in memory, so sorting it is exact rather than
   * approximate.
   *
   * "Pictures first" keeps the server's order — that IS pictures-first. */
  function sortPool(rows) {
    var parts = String(currentSort() || '').split('|');
    var key = parts[0];
    var dir = parts[1] === 'asc' ? 1 : -1;
    if (!key || key === 'pictures') return rows;
    return rows.slice().sort(function (a, b) {
      if (key === 'rating') return (a.rating - b.rating) * dir;
      if (key === 'helpful') {
        var votes = (a.helpful - b.helpful) * dir;
        if (votes) return votes;
        return Date.parse(b.dateIso || 0) - Date.parse(a.dateIso || 0);
      }
      return (Date.parse(a.dateIso || 0) - Date.parse(b.dateIso || 0)) * dir;
    });
  }

  /* Desktop paginates, mobile appends — Figma 3445:26357 vs 2787:6734. The
   * breakpoint is read from the token rather than typed here, so a change to
   * --breakpoint-md moves the JS with the CSS. */
  function isDesktop() {
    var token = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md').trim();
    var px = parseInt(token, 10) || 768;
    return window.matchMedia('(min-width: ' + px + 'px)').matches;
  }

  /* The real list and the skeleton trade places. `aria-busy` goes on the real
   * list rather than the skeleton: the skeleton is aria-hidden, so to a screen
   * reader the thing that is busy IS the list. */
  function setBusy(on) {
    var skeleton = root.querySelector('[data-ds-reviews-skeleton]');
    list.setAttribute('aria-busy', on ? 'true' : 'false');

    /* Lock Sort and Filter while waiting. They run on the loaded set, so using
     * them before the data is in returns an answer that is true-of-what-arrived
     * and then changes itself when the rest lands — measured: the same "With
     * photos" box read "Show 5 reviews" and became "Show 16 reviews" with the
     * shopper touching nothing. Better unusable for a few seconds than an answer
     * that will move. */
    ['filter', 'sort'].forEach(function (key) {
      var trigger = root.querySelector('[data-ds-reviews-toggle="' + key + '"]');
      if (trigger) trigger.disabled = on;
    });

    if (!skeleton) return;
    skeleton.classList.toggle('sf-hidden', !on);
    list.classList.toggle('sf-hidden', on);
  }

  function renderList() {
    var desktop = isDesktop();
    /* Photo mode runs on what is already loaded (photos sit in one block at the
     * front under `pictures_first`), so it slices the flat array. Otherwise
     * desktop reads EXACTLY the matching API page — one page, one request, no
     * accumulation. */
    var totalPages = state.photo
      ? Math.max(1, Math.ceil(visible().length / PER_PAGE))
      : pageCount();
    if (state.page > totalPages) state.page = totalPages;
    var slice = desktop
      ? (state.photo
          ? visible().slice((state.page - 1) * PER_PAGE, state.page * PER_PAGE)
          : rowsForPage(state.page))
      : visible().slice(0, state.shown);

    list.innerHTML = '';
    slice.forEach(function (review) {
      var node = template.content.firstElementChild.cloneNode(true);
      list.appendChild(fillReview(node, review, reviewPhotoTemplate));
    });

    /* "No reviews match" is a CONCLUSION, so it must stay quiet while the list
     * is waiting on the API — there is nothing to conclude yet — and equally
     * quiet when the request just failed: "could not ask" and "asked, and there
     * are none" are two different statements. */
    var empty = root.querySelector('[data-ds-reviews-empty]');
    if (empty) {
      var busy = list.getAttribute('aria-busy') === 'true';
      empty.classList.toggle('sf-hidden', slice.length > 0 || busy || !!failed[state.page]);
    }

    renderPagination(totalPages);

    syncMore();
  }

  /* The mobile "Load more" pill only ever grows the list, so it appends rather
   * than going through renderList's clear-and-rebuild — that would replay the
   * fade-in on every row already on screen, not just the new ones. The new
   * nodes go in with data-ds-review-enter set (review-list.css's opacity 0 /
   * translateY state), then a forced reflow before it is cleared so the
   * browser commits that starting frame first — without it, the add and the
   * remove would coalesce into one paint and the transition would never run.
   * Not requestAnimationFrame: rAF is paused while the tab is backgrounded,
   * which would strand the row invisible until the shopper returns to it. */
  /* Mobile appends. Each press adds exactly one page, which is exactly one
   * request — `per_page=5` matches this button's step, so nothing has to be
   * gathered. */
  function appendMore() {
    var need = state.shown + PER_PAGE;
    var have = visible().length;
    if (have < need && !state.photo) {
      var next = Math.floor(state.shown / PER_PAGE) + 1;
      var token = ++ticket;
      setMoreBusy(true);
      return fetchUiPage(next).then(function () {
        setMoreBusy(false);
        if (token !== ticket) return;
        appendSlice();
      });
    }
    return appendSlice();
  }

  function appendSlice() {
    var rows = visible();
    var slice = rows.slice(state.shown, state.shown + PER_PAGE);
    /* Advance by exactly the rows just added. Adding a hard PER_PAGE moves the
     * cursor even on a press that appended nothing, and from then on the button
     * skips real reviews. */
    state.shown += slice.length;

    var added = slice.map(function (review) {
      var node = template.content.firstElementChild.cloneNode(true);
      fillReview(node, review, reviewPhotoTemplate);
      node.setAttribute('data-ds-review-enter', '');
      list.appendChild(node);
      return node;
    });

    if (added.length) added[0].offsetHeight; // eslint-disable-line no-unused-expressions
    added.forEach(function (node) { node.removeAttribute('data-ds-review-enter'); });

    syncMore();
  }

  /* The load-more button while the network is out: swap to the spinner variant
   * Liquid already rendered. Both variants are real ds-buttons, so no class is
   * hand-written here, and the busy one carries `sf-pointer-events-none` so a
   * second press cannot get through. */
  function setMoreBusy(on) {
    var idle = root.querySelector('[data-ds-reviews-more-idle]');
    var busy = root.querySelector('[data-ds-reviews-more-busy]');
    if (!idle || !busy) return;

    /* Swapping the button must CARRY FOCUS with it. The button just pressed is
     * the one about to be `display:none`, so without this focus falls to
     * `<body>`: a keyboard shopper's second Enter does nothing and Tab restarts
     * from the top of the page. The old version set `button.disabled = true`, so
     * focus stayed — swapping two nodes means doing that work by hand.
     *
     * Only move focus when it is actually inside this pair; a shopper who
     * pressed and then went elsewhere is left alone. */
    var from = on ? idle : busy;
    var to = on ? busy : idle;
    var carry = from.contains(document.activeElement);

    idle.classList.toggle('sf-hidden', on);
    busy.classList.toggle('sf-hidden', !on);

    if (!carry) return;
    var target = to.querySelector('button');
    if (target && typeof target.focus === 'function') target.focus();
  }

  /* Whether the "Load more" pill stays or goes — one rule shared by `renderList`
   * and `appendSlice`.
   *
   * The yardstick is the query's TOTAL, not the row count in memory. Measured
   * against what is loaded, `state.shown` after the first press always equals
   * exactly the rows just fetched, so the pill hides itself on that first press
   * with 415 reviews still behind it — the reported "load more on mobile
   * disappears after one click".
   *
   * The photo filter is a genuine exception: it runs locally on the strip's set,
   * so that set is the whole of what the filter has. */
  function syncMore() {
    var pill = root.querySelector('[data-ds-reviews-more]');
    if (!pill) return;
    var total;
    if (state.photo) {
      total = visible().length;
    } else {
      total = pagesTotal || all.length;
      /* Once the real bottom is known, use the real bottom rather than the number
       * the server claims. `total_count` can exceed what the endpoint will serve
       * (measured: claims 210, serves 192). Measured only against 210, the pill
       * is still showing at review 192 while the next press lands on a page
       * already loaded — a button that lives forever and adds nothing.
       *
       * The yardstick is the ROWS loaded contiguously, not
       * `lastKnownPage * PER_PAGE`: the bottom page is usually shorter than a
       * full one (the 6-review fixture ends with a page of 1), so multiplying
       * overshoots in exactly the place this is meant to fix. */
      if (lastKnownPage && pages[lastKnownPage]) total = Math.min(total, loadedRows().length);
    }
    pill.classList.toggle('sf-hidden', isDesktop() || state.shown >= total);
  }

  /* Which page numbers to draw. Figma's `1 2 3 … 10` is the first-page case of
   * one rule: the run always shows page 1, the current page with a neighbour
   * either side, and the last page — and near the start that collapses to the
   * first three. Everything else becomes a gap marker. Without this a product
   * with 35 reviews would draw seven buttons, and one with 300 would draw
   * sixty. */
  function pageRun(pages) {
    /* A window of THREE numbers, and it only slides when the shopper clicks the
     * number at its EDGE — the one next to the ellipsis. Clicking the middle
     * number leaves the window where it is, because the next page is already
     * sitting there and no room needs making.
     *
     *   1 2 3 … 86   click 2 (middle) → 1 2 3 … 86   window holds
     *                click 3 (edge)   → 2 3 4 … 86   slides one step
     *                click 4 (edge)   → 3 4 5 … 86
     *
     * Symmetric in both directions: clicking the LEFT edge slides it back, so
     * walking backwards also always leaves a number to click rather than sending
     * the shopper hunting for the Prev arrow.
     *
     * That is why the window carries STATE — `runStart` remembers where it
     * stands instead of being recomputed from `state.page`. Derived purely from
     * the current page, the current page either always leads (sliding on every
     * click, including middle ones) or always centres (never showing an edge).
     * Neither is this.
     *
     * A long jump — straight to the last page, or a filter change that returns to
     * page 1 — makes the window follow rather than crawl there one step at a
     * time. */
    var cur = state.page;
    var maxStart = Math.max(1, pages - 2);
    if (runStart > maxStart) runStart = maxStart;

    if (cur < runStart) runStart = cur;
    else if (cur > runStart + 2) runStart = cur - 2;
    else if (cur === runStart + 2) runStart = cur - 1;
    else if (cur === runStart && cur > 1) runStart = cur - 1;

    runStart = Math.max(1, Math.min(runStart, maxStart));

    var run = [];
    for (var n = runStart; n <= Math.min(runStart + 2, pages); n += 1) run.push(n);
    var last = run[run.length - 1];
    if (last < pages) {
      if (pages - last > 1) run.push(null); // gap marker
      run.push(pages);
    }
    return run;
  }

  /* Every interaction goes through here: fetch the page that is wanted, then
   * draw. A response whose ticket is stale is dropped — on two quick clicks, the
   * first result arriving late would paint over the page the shopper is actually
   * looking at. */
  function show(uiPage) {
    state.page = Math.max(1, uiPage);
    if (state.photo || rowsForPage(state.page).length) {
      setBusy(false);
      renderList();
      renderFilterTrigger();
      renderApply();
      return Promise.resolve();
    }
    var token = ++ticket;
    setBusy(true);
    return fetchUiPage(state.page).then(function () {
      if (token !== ticket) return;
      /* An empty page means we went past the bottom. `per_page=5` returns empty
       * in exactly the right place, so `lastKnownPage` already knows — just fall
       * back to it. */
      if (!rowsForPage(state.page).length && lastKnownPage) state.page = Math.min(state.page, lastKnownPage);
      setBusy(false);
      renderList();
      renderFilterTrigger();
      renderApply();
    });
  }

  function renderPagination(pages) {
    var nav = root.querySelector('[data-ds-reviews-pagination]');
    var slot = root.querySelector('[data-ds-reviews-pages]');
    if (!nav || !slot) return;
    var show = pages >= 2 && isDesktop();
    nav.classList.toggle('sf-hidden', !show);
    nav.classList.toggle('sf-flex', show);
    slot.innerHTML = '';
    if (!show) return;

    pageRun(pages).forEach(function (page) {
      if (page === null) {
        slot.appendChild(ellipsisTemplate.content.firstElementChild.cloneNode(true));
        return;
      }
      var button = pageTemplate.content.firstElementChild.cloneNode(true);
      button.textContent = String(page);
      button.setAttribute('data-page', String(page));
      if (page === state.page) button.setAttribute('aria-current', 'page');
      slot.appendChild(button);
    });

    setArrow('[data-ds-reviews-prev]', state.page <= 1);
    setArrow('[data-ds-reviews-next]', state.page >= pages);
  }

  function setArrow(selector, disabled) {
    var control = root.querySelector(selector + ' button, ' + selector + ' a');
    if (control) control.disabled = disabled;
  }

  function renderPhotoStrip() {
    var block = root.querySelector('[data-ds-reviews-photos]');
    var track = root.querySelector('[data-ds-reviews-photos-track]');
    if (!block || !track) return;

    /* The strip MUST follow the active filter. It used to show every photo
     * regardless, so filtering to 1★ and then clicking a 5★ photo was routine —
     * and "See this review" would then hunt for a review outside the filtered
     * set and land on the wrong page. Filtering the strip by the same state is
     * the only fix at the root: whatever the shopper can click is guaranteed to
     * be in the list. */
    var photos = [];
    stripVisible().forEach(function (review) {
      review.photos.forEach(function (photo) {
        photos.push({ src: photo.src, full: photo.full, review: review });
      });
    });
    /* An open lightbox points into the old `strip` by INDEX, so replacing the
     * array under it makes that index meaningless: open tile 13 of the
     * metafield's 15 photos, let `loadStrip` land with 25 in a different order,
     * and Next jumps to an unrelated photo while the counter goes from "13 / 15"
     * to "14 / 25". Re-anchor by `src` — the same photo is the same URL — and
     * only fall back to 0 when the photo on screen is gone from the new set. */
    var pinned = lightbox && lightbox.getAttribute('aria-hidden') === 'false'
      ? strip[lightboxAt] && strip[lightboxAt].src
      : null;

    strip = photos;

    if (pinned) {
      var found = -1;
      for (var s = 0; s < photos.length; s += 1) {
        if (photos[s].src === pinned) { found = s; break; }
      }
      lightboxAt = found < 0 ? 0 : found;
      /* The counter must state the new total immediately, not wait for an arrow
       * press. */
      var counter = lightbox.querySelector('[data-ds-photo-lightbox-counter]');
      if (counter && photos.length) counter.textContent = (lightboxAt + 1) + ' / ' + photos.length;
    }

    if (!photos.length) {
      /* Do NOT conclude anything before the answer arrives. A null `stripRows`
       * means `loadStrip` has not returned, and the set under consideration is
       * still the metafield's five reviews — on a product whose first five carry
       * no photos, the whole block would be hidden and then reappear seconds
       * later, shoving the list and everything under it down. That is precisely
       * the jump the placeholders exist to prevent. Keep the block and its
       * placeholders until there is a real answer.
       *
       * Once the answer is in and still empty (filtered to 1★ with no 1★ review
       * carrying photos), then remove it, rather than leaving an empty rail with
       * a badge reading 0. */
      if (!stripSettled) return;
      track.innerHTML = '';
      block.classList.add('sf-hidden');
      block.classList.remove('sf-flex');
      return;
    }
    track.innerHTML = '';

    /* Figma shows ten tiles and folds the remainder into the last one as
     * "+7" — so the strip never grows past ten no matter how many photos the
     * product has collected. The tenth stands for itself plus the hidden ones,
     * which is why the count subtracts nine and not ten. */
    var MAX_TILES = 10;
    /* Before `loadStrip` returns, this set is only the photos of the metafield's
     * reviews — LOADING, not an answer. Say so: measured, the strip drew 7 tiles
     * and quietly became 19, with the count following and nothing in between to
     * signal it.
     *
     * So while waiting, the rest of the row is placeholders placed AFTER the real
     * photos: the first-paint data stays viewable immediately, and the room for
     * what is coming is already reserved — when it lands it replaces in place
     * rather than growing. The "+N" overflow tile waits too: do not print N
     * before N is known. */
    var loading = !stripSettled;
    /* While loading, the LAST tile is always a placeholder, even when ten photos
     * are already in hand.
     *
     * Without this rule, a first strip page that returns ten photos looks
     * finished — ten real photos, no placeholders, badge hidden — and then the
     * second request lands and the tenth tile quietly becomes "+31" while the
     * badge appears. Measured exactly that: three states, the middle one carrying
     * no sign at all that more was on the way.
     *
     * Reserving the last tile makes that slot visibly pending for the whole wait,
     * and when the data lands it becomes either a real photo or the "+N" chip —
     * replaced in place, not grown. */
    var cap = loading ? MAX_TILES - 1 : MAX_TILES;
    var shown = photos.slice(0, cap);
    var hidden = photos.length - (MAX_TILES - 1);

    shown.forEach(function (photo, index) {
      var overflow = !loading && photos.length > MAX_TILES && index === MAX_TILES - 1;
      var source = overflow ? morePhotoTemplate : photoTemplate;
      var tile = source.content.firstElementChild.cloneNode(true);
      var img = tile.querySelector('img');
      if (img) {
        img.setAttribute('src', photo.src);
        img.removeAttribute('srcset');
        img.setAttribute('alt', '');
      }
      if (overflow) {
        var badge = tile.querySelector('[data-ds-reviews-photo-more]');
        if (badge) badge.textContent = '+' + hidden;
      }
      tile.setAttribute('data-ds-reviews-photo-index', String(index));
      track.appendChild(tile);
    });

    /* Liquid's placeholder block covers the stretch BEFORE JS runs. From here on
     * the placeholders live inside the track itself, after the real photos, so
     * take one of them as a template before removing the block — the classes stay
     * written in Liquid rather than retyped in JS. */
    var strip_skeleton = root.querySelector('[data-ds-reviews-photos-skeleton]');
    if (strip_skeleton) {
      if (!stripPlaceholder && strip_skeleton.firstElementChild) {
        stripPlaceholder = strip_skeleton.firstElementChild.cloneNode(true);
      }
      strip_skeleton.remove();
    }

    if (loading && stripPlaceholder) {
      for (var g = shown.length; g < MAX_TILES; g += 1) {
        var ghost = stripPlaceholder.cloneNode(true);
        ghost.setAttribute('aria-hidden', 'true');
        ghost.setAttribute('data-ds-reviews-photo-ghost', '');
        track.appendChild(ghost);
      }
    }

    /* The badge counts EXACTLY the photos in the strip — which is also the number
     * the lightbox can page through, so the label and the thing being clicked
     * tell one story. It is NOT the product's total: knowing that would mean
     * reading every review, and Judge.me has no endpoint that counts them.
     * Redrawn whenever the strip changes, so it starts as the metafield's photos
     * and becomes the count of whatever `loadStrip` brought back.
     *
     * ds-badge keeps its copy in a `.label` span beside optional icons — write to
     * that, not to the badge, or the icons go with the text. */
    var badge = root.querySelector('[data-ds-reviews-photos-count]');
    if (badge) {
      var label = badge.querySelector('.label') || badge.querySelector('[data-ds-badge] > span') || badge;
      label.textContent = String(strip.length);
      /* While loading, show NO number. The first-paint figure counts the
       * metafield's five reviews, not the strip's set — publishing it promises
       * something about to be corrected, and it was measured going from 7 to 19
       * under the shopper's hand. */
      badge.classList.toggle('sf-hidden', loading || strip.length === 0);
    }

    block.classList.remove('sf-hidden');
    block.classList.add('sf-flex');
    syncStripNav();
  }

  /* Arrows only where they do something. A strip of three photos on a desktop
   * column never scrolls, and ds-product-rail already set the precedent: drop
   * the nav rather than leave two dead controls on a row that cannot move. */
  function syncStripNav() {
    var track = root.querySelector('[data-ds-reviews-photos-track]');
    var nav = root.querySelector('[data-ds-reviews-photos] [data-ds-carousel-nav]');
    if (!track || !nav) return;

    var scrolls = track.scrollWidth > track.clientWidth + 1;
    nav.hidden = !scrolls;
    if (!scrolls) return;

    var prev = nav.querySelector('[data-ds-carousel-nav-prev]');
    var next = nav.querySelector('[data-ds-carousel-nav-next]');
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  /* The two CONTENT checkboxes carry no number.
   *
   * "With photos": Judge.me has no endpoint, no parameter and no aggregate for
   * photos — all 34 operations in their docs were checked, and no path contains
   * media/picture/photo. The only thing close is `has_published_pictures` on
   * `GET /reviews`, and that endpoint needs a private token, so it cannot ship in
   * a theme. The number is therefore only obtainable by reading every review.
   *
   * "Verified": `verified_only=true` does return a `total_count`, so it is
   * countable in one request. Dropped anyway so the two chips agree — one chip
   * with a number beside one without reads as "that one has none".
   *
   * A bare label works fine; a filter need not announce its result before you
   * use it. */

  /* The VARIANT group only exists when Judge.me actually carried one — it is a
   * custom question the merchant may never have asked, so the Liquid ships the
   * fieldset empty and hidden and this fills it from the parsed set or leaves it
   * out entirely. Cloning the checkbox already in the CONTENT group keeps every
   * class in Liquid, the same rule the photo tiles follow. */
  function renderVariants() {
    var group = root.querySelector('[data-ds-reviews-group="variant"]');
    var slot = root.querySelector('[data-ds-reviews-variants]');
    var sample = root.querySelector('[data-ds-reviews-filter="photo"] [data-ds-checkbox]');
    if (!group || !slot || !sample) return;

    var names = [];
    (stripRows || all).forEach(function (review) {
      if (review.variant && names.indexOf(review.variant) === -1) names.push(review.variant);
    });
    if (!names.length) return;

    slot.innerHTML = '';
    names.forEach(function (name, index) {
      var wrap = document.createElement('span');
      wrap.setAttribute('data-ds-reviews-variant', name);
      var box = sample.cloneNode(true);
      var input = box.querySelector('input');
      var id = root.id + '-variant-' + index;
      if (input) {
        input.id = id;
        input.name = 'ds-reviews-variant';
        /* Keep whatever is already selected. `renderVariants` runs again when
         * `loadStrip` returns, and hard-coding `false` here makes the shopper's
         * tick vanish from the panel while `state.variants` is still filtering —
         * the next interaction reads the DOM back and silently drops that
         * filter. */
        input.checked = state.variants.indexOf(name) !== -1;
        input.removeAttribute('data-ds-checkbox-indeterminate');
      }
      var label = box.querySelector('label');
      if (label) label.setAttribute('for', id);
      var text = box.querySelector('label > span:last-child > span:first-child');
      if (text) text.textContent = name;
      wrap.appendChild(box);
      slot.appendChild(wrap);
    });

    group.classList.remove('sf-hidden');
    group.classList.add('sf-flex');
  }

  /* ── Panels ───────────────────────────────────────────────────────────────
   * A dropdown from md up and a bottom sheet below it, one tree either way.
   * Open/closed is [aria-hidden] alone — src/reviews-panel.css carries the fade
   * and the slide off it, so toggling a display utility here would cut the
   * close animation off (experience.md, "Toggling sf-hidden killed the close
   * animation"). Body scroll is only locked for the sheet: locking it for a
   * desktop dropdown would freeze the page behind a 240px panel.
   */
  function panel(name) {
    return root.querySelector('[data-ds-reviews-panel="' + name + '"]');
  }

  function panelOpen(name) {
    var box = panel(name);
    return !!box && box.getAttribute('aria-hidden') === 'false';
  }

  /* One at a time, expressed as "which panel is open" rather than as a toggle
   * per panel: opening one has to close the other (two dropdowns overlap on a
   * narrow column, two sheets stack), and writing that as setPanel calling
   * itself made opening Sort close Sort — the nested call re-ran the same loop
   * and shut the panel that had just been opened. One writer over both panels
   * cannot have that bug. `name` is null for "none open". */
  function showPanel(name) {
    // Which presentation this panel is in. The breakpoint comes from isDesktop,
    // which reads the token, so the CSS and the JS cannot disagree about where
    // the sheet becomes a dropdown; src/reviews-panel.css hangs the full-height
    // slide off this attribute rather than off an @media whose 768 would have to
    // be typed a second time.
    var sheet = !isDesktop();

    ['filter', 'sort'].forEach(function (key) {
      var box = panel(key);
      if (!box) return;
      var open = key === name;

      if (sheet) box.setAttribute('data-ds-reviews-sheet', '');
      else box.removeAttribute('data-ds-reviews-sheet');
      var was = box.getAttribute('aria-hidden') === 'false';
      box.setAttribute('aria-hidden', open ? 'false' : 'true');

      var trigger = root.querySelector('[data-ds-reviews-toggle="' + key + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', String(open));

      // Opening moves focus onto the panel's first control — otherwise the
      // trigger reads "expanded" while keyboard/AT focus is still sitting on
      // the trigger itself, one Tab short of the content that just appeared.
      // Closing mirrors it back, but only if focus is still inside the panel
      // being closed — otherwise closing one panel would steal focus from the
      // control the shopper just moved to.
      if (open) {
        /* The first VISIBLE one, not the first in the markup. The panel header
         * carries `md:sf-hidden`, so from md up its close button is display:none
         * — calling `focus()` on it silently does nothing. */
        var fields = box.querySelectorAll(
          'input, select, textarea, button, [href], [tabindex]:not([tabindex="-1"])'
        );
        for (var f = 0; f < fields.length; f++) {
          if (fields[f].offsetParent === null) continue;
          if (typeof fields[f].focus === 'function') fields[f].focus();
          break;
        }
      } else if (was && trigger && typeof trigger.focus === 'function' && box.contains(document.activeElement)) {
        trigger.focus();
      }
    });

    // Only the mobile sheet locks the page; a 240px desktop dropdown that froze
    // the whole document behind it would be a bug, not a modal.
    document.documentElement.style.overflow = name && sheet ? 'hidden' : '';
  }

  function closePanels() {
    showPanel(null);
  }

  /* The Sort trigger reads the choice back ("Sort by: Most Helpful"), which is
   * the whole point of collapsing a select into a button — the value has to stay
   * visible while the panel is shut. */
  function renderSortTrigger() {
    var trigger = root.querySelector('[data-ds-reviews-toggle="sort"]');
    var picked = root.querySelector('[data-ds-reviews-sort-option]:checked');
    if (!trigger || !picked) return;
    var label = picked.closest('label');
    var text = label && label.querySelector('span');
    // ds-button wraps its copy in a <span> beside the optional icons; writing to
    // the control itself would take the chevron out with the text.
    var slot = trigger.querySelector(':scope > span');
    if (!slot || !text) return;
    var pattern = root.getAttribute('data-ds-reviews-sort-pattern') || '%s';

    /* Two weights, not one string: Figma 7327:24854 sets "Sort by:" in Medium and
     * the chosen value in SemiBold. Built from nodes rather than innerHTML — the
     * label comes from the translation file, and a translation file is not a
     * place that should carry markup. */
    var parts = pattern.split('%s');
    var value = document.createElement('span');
    value.className = 'sf-font-semibold';
    value.setAttribute('data-ds-reviews-sort-value', '');
    value.textContent = text.textContent.trim();

    slot.textContent = '';
    slot.appendChild(document.createTextNode(parts[0]));
    slot.appendChild(value);
    if (parts[1]) slot.appendChild(document.createTextNode(parts[1]));
  }

  /* The Filter trigger carries the number of reviews the current selection
   * yields, the way Figma 7262:24752 draws it ("Filter (6)"). With nothing
   * selected it is just "Filter". */
  function renderFilterTrigger() {
    var trigger = root.querySelector('[data-ds-reviews-toggle="filter"]');
    if (!trigger) return;
    var slot = trigger.querySelector(':scope > span');
    if (!slot) return;
    if (!trigger.dataset.dsLabel) trigger.dataset.dsLabel = slot.textContent.trim();

    var picked =
      (state.rating ? 1 : 0) + (state.photo ? 1 : 0) + (state.verified ? 1 : 0) + state.variants.length;
    if (!picked) {
      slot.textContent = trigger.dataset.dsLabel;
      return;
    }
    var total = queryTotal();
    if (total === null) {
      slot.textContent = trigger.dataset.dsLabel;
      return;
    }
    var pattern = root.getAttribute('data-ds-reviews-count-pattern') || '%1 (%2)';
    slot.textContent = pattern
      .replace('%1', trigger.dataset.dsLabel)
      .replace('%2', String(total));
  }

  /* How many reviews the current selection will yield — or `null` when that
   * cannot be known.
   *
   * It can be known because each star row already carries its own count
   * (`data-ds-reviews-rating-total`, server-rendered), and that count lives in
   * the same universe as the server's: measured on product 9902457880859
   * (2026-09-17) the histogram says 4 stars = 41, and `filter_rating=4` returns
   * exactly `total_count=41`. `filter_rating` matches EXACTLY rather than "and
   * up", so one lookup settles it — no request.
   *
   * "With photos", "Verified buyer" and the variant filter have no such cell to
   * read, and knowing them would mean reading every review. Return `null` so the
   * display drops the number. A figure that is true-of-what-loaded is a figure
   * that will change under the shopper's hand, which is worse than none. */
  function queryTotal() {
    /* The photo and variant filters run LOCALLY, so the server's `total_count`
     * says nothing about them. But a number does exist: the button reads "Show N
     * reviews", and the N it promises is the row count the filter will put on
     * screen — `visible().length`. Not an approximation of "how many reviews on
     * this product carry photos"; that is a different question and Judge.me
     * cannot answer it.
     *
     * The condition is that the set must be STILL, or the number moves under the
     * shopper's hand. For the photo filter the set is only still once `loadStrip`
     * has FULLY finished — it may take up to two requests, see
     * `STRIP_MAX_PAGES`. Until then, no number. */
    if (state.photo) {
      /* Gate on `stripSettled`, NOT on `stripRows`: `loadStrip` assigns
       * `stripRows` right after the first page and then fetches a second, so
       * treating `stripRows` as "done" publishes a number that is still growing —
       * ticking "With photos" in that window takes the button from "Show 20
       * reviews" to "Show 23 reviews" with the shopper touching nothing. Exactly
       * what this gate exists to prevent. */
      if (!stripSettled) return null;
      /* Settled with no photos means the answer is 0, not "unknown" — `visible()`
       * returns [] and that 0 goes straight to the button. */
      return visible().length;
    }
    /* The variant filter yields NO number. Its set is `loadedRows()`, and that
     * set grows every time the shopper turns a page — the button would walk from
     * "Show 2 reviews" to "Show 9 reviews" with nobody touching it. The same
     * instability the branch above rejects, so reject it identically. The photo
     * branch can produce a number because its set is `stripRows`, a finished
     * fetch that does not grow; variants have no equivalent, and Judge.me has no
     * parameter that filters by variant either. */
    if (state.variants.length) return null;
    /* Once this query has made a request, the server has stated its total. That
     * is the real number for every sort/rating/verified combination, including
     * "Verified buyer", which no table lookup can answer. It only appears after
     * the data lands, and once landed it does not move. */
    if (pagesTotalFromServer) return pagesTotal;
    if (state.verified) return null;
    if (state.rating) return ratingTotal();
    return aggregate && typeof aggregate.count === 'number' ? aggregate.count : null;
  }

  /* The sheet's primary action counts what the shopper is about to see, so the
   * number has to move with every tick rather than only on open. */
  function renderApply() {
    var button = root.querySelector('[data-ds-reviews-apply]');
    if (!button) return;
    var slot = button.querySelector(':scope > span') || button;
    var total = queryTotal();
    if (total === null) {
      slot.textContent = root.getAttribute('data-ds-reviews-apply-plain') || button.textContent;
      return;
    }
    var pattern = root.getAttribute('data-ds-reviews-apply-pattern') || '%s';
    slot.textContent = pattern.replace('%s', String(total));
  }

  /* The whole set, once. Page 1 is already in the DOM, so this only runs when a
   * shopper actually reaches for a control that needs more than page 1.
   * `per_page=100` is what we ask for, but Judge.me caps what it actually sends
   * back well under that (30 on the store this was found on) and ignores the
   * rest of the request — so one call is not "the whole set", it is one page.
   * Keep asking for the next page until the running total reaches the response's
   * own `total_count`, a page comes back with no reviews at all, or a 20-page
   * safety cap trips. A page that repeats reviews already seen (Judge.me's
   * window can overlap the previous one when it silently caps `per_page`) is
   * not a stop signal by itself — the next page can still hold new ones. */
  /* ── Data: one UI page = one API page ────────────────────────────────────
   *
   * `per_page=5` is the number Judge.me's own widget uses, and it paginates
   * CORRECTLY: measured on a 420-review product, pages 1→84 each returned five
   * distinct reviews and page 85 came back empty — matching `total_count`
   * exactly.
   *
   * Asking for a large `per_page` does the opposite: the windows overlap. On the
   * same product, 20 pages at `per_page=100` returned 567 raw reviews but only
   * 277 distinct ones, and never an empty page to signal the end. The whole
   * earlier "gather the set" architecture was built on that broken mode, which is
   * why the pager read 56 pages instead of 84.
   *
   * Since the UI also shows five per page, the two line up: UI page N is API page
   * N — one request, no accumulation, no offset arithmetic, no de-duplication. */
  var pages = {};
  var stripRows = null;
  /* One placeholder sampled from Liquid's skeleton block, kept so it can be
   * cloned. */
  var stripPlaceholder = null;
  /* Whether `loadStrip` has an answer yet — including when the answer is
   * "failed".
   *
   * Do not use `!stripRows` as the loading flag: it merges "not back yet" with
   * "came back and failed", so a failed request leaves a row of placeholders
   * pulsing forever and a badge that never states a number. Failure is also an
   * ending, just one with less data. */
  var stripSettled = false;
  var pagesQuery = '';
  var pagesTotalFromServer = false;
  var pagesTotal = aggregate && aggregate.count ? aggregate.count : all.length;
  var lastKnownPage = 0;
  /* Where the pager's window currently stands — see `pageRun`. */
  var runStart = 1;
  var inflight = {};
  /* Which pages just failed (network error / non-OK response). Used to tell
   * "nothing yet" apart from "asked, and there are no reviews" — those say two
   * different things to the shopper. */
  var failed = {};
  var ticket = 0;

  /* Photo strip requests carry `per_page=20` and no `sort_by`.
   *
   * Omitting the sort is deliberate — the shop sets
   * `default_sort_method = pictures-first`, so the default already pushes reviews
   * with photos to the front; sending any `sort_by` overwrites that (measured:
   * no sort → 20 reviews all with photos; with a sort → 27 reviews, 1 with a
   * photo).
   *
   * `per_page=20` is a MEASURED number, not a chosen one: the endpoint caps a
   * response at 20 rows. Measured on product 9902457880859 (2026-09-17) —
   * per_page 5/10/15/20 returned exactly 5/10/15/20, while 25/30/50/100 all
   * returned 20. Asking for 30 is lying to yourself about 10 rows, and that was
   * the root of the 56-page pager: the page count divided by 30 while the server
   * served 20.
   *
   * The number of strip pages we may request, page 1 included. Two, no more:
   * enough to cover the photo block on every product in this store (the longest
   * measured is 23, and two pages cover 40) while staying a FIXED number — not
   * "ask until empty", which on another product could become hundreds of
   * requests. */
  var STRIP_MAX_PAGES = 2;

  function stripPageUrl(n) {
    var productId = root.getAttribute('data-ds-reviews-product');
    var shop = root.getAttribute('data-ds-reviews-shop');
    if (!productId || !shop) return '';
    return (
      API +
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify&product_id=' + encodeURIComponent(productId) +
      '&per_page=20&page=' + n
    );
  }

  function fetchStripPage(n) {
    var url = stripPageUrl(n);
    if (!url) return Promise.resolve(null);
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, PAGE_TIMEOUT);
    return fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        clearTimeout(timer);
        if (!payload || !payload.html) return [];
        var holder = document.createElement('div');
        holder.innerHTML = payload.html;
        return parseAll(holder);
      })
      .catch(function () {
        clearTimeout(timer);
        return null;
      });
  }

  function loadStrip() {
    if (!stripPageUrl(1)) {
      stripSettled = true;
      return Promise.resolve();
    }

    /* Ask for another page ONLY when the last one was all photo reviews — that is
     * evidence the photo block runs longer than what just arrived, not a guess.
     * The shop sets `default_sort_method = pictures-first`, so reviews with
     * photos sit in one block at the front (measured on three products: blocks of
     * 23 / 4 / 1), which makes "this page is all photos" mean the block's bottom
     * has not been reached.
     *
     * A page SHORTER than 20 is also the end, so stop. And the page count is
     * capped at `STRIP_MAX_PAGES`, making the worst case two requests, known in
     * advance. On a product with more than 40 photo reviews the filter still
     * cannot reach the tail — reaching it means reading every review, which is
     * sequential pagination. */
    function step(n, gathered) {
      return fetchStripPage(n).then(function (rows) {
        if (rows === null) return gathered;
        var merged = gathered.concat(rows);
        var everyHasPhoto = rows.length > 0 && rows.every(function (r) { return r.photos.length > 0; });
        if (n < STRIP_MAX_PAGES && rows.length === 20 && everyHasPhoto) {
          /* Draw what is already in hand before asking for more: the shopper sees
           * photos immediately, and the rest lands in the slots the placeholders
           * are holding. */
          stripRows = merged;
          renderPhotoStrip();
          return step(n + 1, merged);
        }
        return merged;
      });
    }

    return step(1, []).then(function (rows) {
      stripSettled = true;
      if (rows && rows.length) {
        stripRows = rows;
        renderVariants();
      }
      /* With nothing received, the strip keeps the metafield reviews' photos —
       * fewer, but real photos, which beats a row of empty boxes. */
      renderPhotoStrip();
      /* And redraw the two places that carry a NUMBER. The photo filter's count
       * is withheld until `stripSettled`, so if the shopper ticked "With photos"
       * during the wait, this is the only moment the button gets to learn the
       * answer — without this call it sits at "Show reviews" until the next
       * interaction. */
      renderFilterTrigger();
      renderApply();
    });
  }

  function currentQuery() {
    return currentSort() + '|' + (state.rating || '') + '|' + (state.verified ? '1' : '');
  }


  function pageUrl(n) {
    var productId = root.getAttribute('data-ds-reviews-product');
    var shop = root.getAttribute('data-ds-reviews-shop');
    if (!productId || !shop) return '';
    /* "Pictures first" means sending NO `sort_by`.
     *
     * `sort_by=pictures` is a dead parameter: the endpoint accepts it and ignores
     * it. Measured on product 9902457880859 (2026-09-17), first 40 reviews,
     * A = has photos:
     *
     *   no sort_by sent     AAAAAAAAAAAAAAAAAAAAAAA.................
     *   sort_by=pictures    A..A................A...............A...
     *   sort_by=helpful     A..A................A...............A...
     *   sort_by=date        A..A................A...............A...
     *
     * The bottom three lines are identical character for character — `pictures`
     * reorders nothing. The only thing that brings photos to the front is the
     * shop's default order (`default_sort_method = pictures-first` in
     * `jdgmSettings`), and the way to ask for it is to send no sort parameter at
     * all.
     *
     * This is also why `loadStrip` sends no sort. */
    var chosen = String(currentSort() || '');
    var parts = chosen.indexOf('pictures') === 0 ? [] : chosen.split('|');
    return (
      API +
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify&product_id=' + encodeURIComponent(productId) +
      '&per_page=' + PER_PAGE + '&page=' + n +
      (parts[0] ? '&sort_by=' + encodeURIComponent(parts[0]) : '') +
      (parts[1] ? '&sort_dir=' + encodeURIComponent(parts[1]) : '') +
      (state.rating ? '&filter_rating=' + encodeURIComponent(state.rating) : '') +
      (state.verified ? '&verified_only=true' : '')
    );
  }

  /* Changing the query changes the whole set. Drop the old query's loaded pages
   * rather than keeping a cache per sort/rating/verified combination — returning
   * to an earlier choice costs exactly one request, which is not worth holding
   * memory for. */
  function syncQuery() {
    var q = currentQuery();
    if (q === pagesQuery) return;
    pagesQuery = q;
    pages = {};
    inflight = {};
    failed = {};
    lastKnownPage = 0;
    pagesTotalFromServer = false;
    /* The new query's total — do NOT reset it to 0. At 0, `pageCount` falls back
     * to `all.length`, which is the metafield's five reviews, which is one page,
     * which means the pager disappears; that was the "change sort, come back to
     * Most helpful, lose pagination" bug, because the default query does not
     * fetch and so nothing rebuilt it.
     *
     * And read only sources that do NOT depend on the cache — the cache was
     * cleared a few lines above. `queryTotal()` is unusable here: it has branches
     * that return `visible().length`, and `visible()` reads `loadedRows()`, which
     * reads the very `pages` object just emptied → 0 → the pager disappears
     * again, only triggered by a variant instead of a sort.
     *
     * Rating has its count sitting on the star row already (server-rendered).
     * Everything else takes the whole set's total as the mark, and the first
     * request's `total_count` corrects it. */
    var rated = ratingTotal();
    pagesTotal = rated === null ? (aggregate && aggregate.count) || all.length : rated;
  }

  /* How many reviews sit at the selected star level, read from the
   * server-rendered attribute.
   *
   * `null` means UNKNOWN (no star selected, or the attribute could not be read).
   * `0` is an answer, not a blank — and it has to be returnable: a `0` folded
   * into `null` makes the button read "Show reviews" for a star level whose
   * correct answer is "Show 0 reviews", while `pagesTotal` jumps to the whole
   * product's total and draws a pager for an empty query. Measured on product
   * 9902474002715: 9 reviews, with 4 of the 5 star levels at zero. */
  function ratingTotal() {
    if (!state.rating) return null;
    var row = root.querySelector('[data-ds-reviews-rating-row="' + state.rating + '"]');
    var raw = row && row.getAttribute('data-ds-reviews-rating-total');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function fetchUiPage(n) {
    syncQuery();
    if (pages[n]) return Promise.resolve(pages[n]);
    if (inflight[n]) return inflight[n];
    var url = pageUrl(n);
    if (!url) return Promise.resolve([]);
    var q = pagesQuery;

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, PAGE_TIMEOUT);

    var req = fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        clearTimeout(timer);
        /* The query changed: this result is meaningless, and `syncQuery` already
         * replaced `inflight` with a fresh object, so there is nothing to clean
         * up. */
        if (q !== pagesQuery) return [];
        /* Non-OK response. `inflight[n]` must be cleared exactly as the catch
         * branch does: keeping a promise already resolved to [] means every later
         * click on that page resolves empty instantly, leaving the page dead
         * until the shopper changes sort/rating/verified or reloads. And do NOT
         * write `pages[n]` — a 503 is not "this page has no reviews". */
        if (!payload) {
          delete inflight[n];
          failed[n] = true;
          return [];
        }
        delete failed[n];
        var holder = document.createElement('div');
        holder.innerHTML = payload.html || '';
        var rows = parseAll(holder);
        pages[n] = rows;
        /* `!isNaN` rather than truthiness: `total_count: 0` is the server ANSWERING
         * that this query is empty, not the server staying silent. Discard it and
         * `pagesTotalFromServer` never turns on, `pagesTotal` keeps the guess made
         * before asking, the Load more pill measures against the wrong mark and
         * the chip loses its number. */
        var t = parseInt(payload.total_count, 10);
        if (!isNaN(t)) {
          pagesTotal = t;
          pagesTotalFromServer = true;
          renderFilterTrigger();
          renderApply();
        }
        /* The REAL bottom, measured by what the server returns rather than what it
         * claims.
         *
         * An empty page is the bottom: `per_page=5` returns empty in exactly the
         * right place (measured: page 85 of a 420-review product), unlike a large
         * `per_page`, which keeps returning rows forever.
         *
         * A SHORT page is also the bottom, and has to count — otherwise a product
         * whose `total_count` exceeds what it serves (measured: claims 210, serves
         * 192) stops on a page of 2 rows with `lastKnownPage` still 0, because
         * nobody ever asks for the empty page behind it. `per_page=5` returns
         * exactly 5 for every page that has data (measured pages 1→84), so fewer
         * than 5 means the end. */
        var got = holder.querySelectorAll('.jdgm-rev').length;
        if (!got) lastKnownPage = Math.max(1, n - 1);
        else if (got < PER_PAGE) lastKnownPage = n;
        delete inflight[n];
        return rows;
      })
      .catch(function () {
        clearTimeout(timer);
        /* Do not write to `pages`: a network blip is not "this page is empty", and
         * caching it as such means the page is never requested again. */
        delete inflight[n];
        if (q === pagesQuery) failed[n] = true;
        return [];
      });

    inflight[n] = req;
    return req;
  }

  /* Page N's reviews, or empty if it has not been fetched. There is NO exception
   * for page 1: the metafield is Judge.me's widget rendered in the shop's default
   * order, while the list asks in the selected sort — taking page 1 from one and
   * pages 2+ from the other stitches two different orderings together, measured
   * as 30 rendered rows holding only 23 distinct reviews. */
  function rowsForPage(n) {
    syncQuery();
    return pages[n] || [];
  }

  function pageCount() {
    var n = Math.max(1, Math.ceil((pagesTotal || all.length) / PER_PAGE));
    if (lastKnownPage) n = Math.min(n, lastKnownPage);
    return n;
  }

  // Pair the sort radios with the machine values the section listed beside their
  // labels — see the sort_values param on ds-product-reviews. Same positional
  // contract the <select> had; only the control changed.
  var sortBox = root.querySelector('[data-ds-reviews-sort]');
  var sortInputs = root.querySelectorAll('[data-ds-reviews-sort-option]');
  if (sortBox && sortInputs.length) {
    var values = (sortBox.getAttribute('data-ds-reviews-sort') || '').split(',');
    sortInputs.forEach(function (input, index) {
      if (values[index]) input.value = values[index];
    });
  }

  function currentSort() {
    var picked = root.querySelector('[data-ds-reviews-sort-option]:checked');
    return picked ? picked.value : '';
  }

  /* Every control in both panels reports through here: read the DOM back into
   * `state`, re-sort, and repaint. Reading the inputs rather than tracking each
   * one's own toggle means "Clear all" only has to reset the form controls. */
  function syncFromPanels() {
    var rating = root.querySelector('[name="ds-reviews-rating"]:checked');
    state.rating = rating ? parseInt(rating.value, 10) || 0 : 0;

    var photo = root.querySelector('[data-ds-reviews-filter="photo"] input');
    var verified = root.querySelector('[data-ds-reviews-filter="verified"] input');
    state.photo = !!(photo && photo.checked);
    state.verified = !!(verified && verified.checked);

    state.variants = [];
    root.querySelectorAll('[data-ds-reviews-variant] input:checked').forEach(function (input) {
      var wrap = input.closest('[data-ds-reviews-variant]');
      if (wrap) state.variants.push(wrap.getAttribute('data-ds-reviews-variant'));
    });

    state.shown = PER_PAGE;
    renderSortTrigger();
    // The strip must follow the filter, or the shopper can click a photo that is
    // not in the list and "See this review" lands on the wrong page.
    renderPhotoStrip();
    // A new query starts at its own page 1; `show` fetches exactly that page.
    show(1);
  }

  root.addEventListener('change', function (event) {
    if (!event.target.closest('[data-ds-reviews-panel]')) return;
    syncFromPanels();
    // A sort is a single choice, so the panel has said all it has to say — the
    // filter panel stays open because its choices combine.
    if (event.target.hasAttribute('data-ds-reviews-sort-option')) closePanels();
  });

  root.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ds-reviews-toggle]');
    if (toggle) {
      event.preventDefault();
      var name = toggle.getAttribute('data-ds-reviews-toggle');
      showPanel(panelOpen(name) ? null : name);
      return;
    }

    // Both the X and the "Show N reviews" button close; the filtering itself has
    // already happened on change, so Done confirms rather than applies.
    var dismiss = event.target.closest('[data-ds-reviews-panel-close], [data-ds-reviews-apply]');
    if (dismiss) {
      event.preventDefault();
      closePanels();
      return;
    }

    var clear = event.target.closest('[data-ds-reviews-clear]');
    if (clear) {
      event.preventDefault();
      root.querySelectorAll('[data-ds-reviews-panel="filter"] input').forEach(function (input) {
        input.checked = false;
      });
      syncFromPanels();
      return;
    }

    // Clicking the overlay of the mobile sheet, or anywhere outside an open
    // desktop dropdown, closes it. Inside the card, nothing.
    if (!event.target.closest('[data-ds-reviews-panel-card]')) closePanels();

    var more = event.target.closest('[data-ds-reviews-more]');
    if (more) {
      event.preventDefault();
      appendMore();
      return;
    }

    var page = event.target.closest('[data-ds-reviews-page]');
    if (page) {
      event.preventDefault();
      show(parseInt(page.getAttribute('data-page'), 10) || 1);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var pager = event.target.closest('[data-ds-reviews-prev], [data-ds-reviews-next]');
    if (pager) {
      event.preventDefault();
      var step = pager.hasAttribute('data-ds-reviews-next') ? 1 : -1;
      show(state.page + step);
      return;
    }

    var arrow = event.target.closest('[data-ds-carousel-nav-prev], [data-ds-carousel-nav-next]');
    if (arrow) {
      var track = root.querySelector('[data-ds-reviews-photos-track]');
      if (track) {
        var step = track.clientWidth * 0.8;
        track.scrollBy({ left: arrow.hasAttribute('data-ds-carousel-nav-next') ? step : -step, behavior: 'smooth' });
      }
    }
  });

  /* A dropdown has to close on a click anywhere else on the page, not just
   * elsewhere in the band — the handler above only sees clicks inside `root`. */
  document.addEventListener('click', function (event) {
    if (!panelOpen('filter') && !panelOpen('sort')) return;
    if (root.contains(event.target)) return;
    closePanels();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!panelOpen('filter') && !panelOpen('sort')) return;
    closePanels();
  });

  /* The write-a-review button is NOT wired here. It used to open Judge.me's own
   * form, because posting a review looked like it needed a token. It does not:
   * behaviors/review-form.js posts straight to their public endpoint, and owns
   * every [data-ds-reviews-write] control on the page. */


  /* ── Lightbox ─────────────────────────────────────────────────────────────
   * Opened from any photo tile — the strip's or one inside a review body. It
   * walks the flat `strip`, not the reviews, so "next" moves to the next photo
   * on the product the way the Figma frame's "2 / 14" implies, even when that
   * crosses into another review.
   */

  var lightbox = document.querySelector('[data-ds-photo-lightbox]');
  var lightboxAt = 0;
  var lightboxOpener = null;

  function lightboxShow(index) {
    if (!lightbox || !strip.length) return;
    lightboxAt = (index + strip.length) % strip.length;
    var shot = strip[lightboxAt];
    var review = shot.review || {};

    var img = lightbox.querySelector('[data-ds-photo-lightbox-image]');
    if (img) img.src = shot.full || shot.src;

    var author = lightbox.querySelector('[data-ds-photo-lightbox-author]');
    if (author) author.textContent = review.author || '';

    var verified = lightbox.querySelector('[data-ds-photo-lightbox-verified]');
    if (verified) verified.classList.toggle('sf-hidden', !review.verified);

    var date = lightbox.querySelector('[data-ds-photo-lightbox-date]');
    if (date) {
      date.setAttribute('datetime', review.dateIso || '');
      date.textContent = relativeDate(review.dateIso || '');
    }

    var stars = lightbox.querySelector('[data-ds-rating]');
    if (stars) setStars(stars, review.rating || 0);

    var title = lightbox.querySelector('[data-ds-photo-lightbox-title]');
    if (title) {
      title.textContent = review.title || '';
      title.classList.toggle('sf-hidden', !review.title);
    }

    var body = lightbox.querySelector('[data-ds-photo-lightbox-body]');
    if (body) body.textContent = review.body || '';

    // Judge.me only carries a variant when the merchant asks for one as a
    // custom question, so this line is usually absent rather than empty.
    var variant = lightbox.querySelector('[data-ds-photo-lightbox-variant]');
    if (variant) {
      variant.textContent = review.variant || '';
      variant.classList.toggle('sf-hidden', !review.variant);
    }

    var counter = lightbox.querySelector('[data-ds-photo-lightbox-counter]');
    if (counter) counter.textContent = (lightboxAt + 1) + ' / ' + strip.length;
  }

  function lightboxOpen(index, trigger) {
    if (!lightbox) return;
    lightboxOpener = trigger || null;
    lightboxShow(index);
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = lightbox.querySelector('[data-ds-photo-lightbox-close] button');
    if (close) close.focus();
  }

  function lightboxClose() {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lightboxOpener && typeof lightboxOpener.focus === 'function') lightboxOpener.focus();
    lightboxOpener = null;
  }

  /* A tile in the strip knows its index; a tile in a review body knows only its
   * URL, so it finds itself in the strip by that. */
  root.addEventListener('click', function (event) {
    var tile = event.target.closest('[data-ds-reviews-photo]');
    if (!tile || !lightbox || !strip.length) return;
    event.preventDefault();
    var index = tile.getAttribute('data-ds-reviews-photo-index');
    if (index === null) {
      var src = tile.getAttribute('data-ds-reviews-photo-src');
      index = 0;
      strip.forEach(function (shot, i) {
        if (shot.src === src) index = i;
      });
    }
    lightboxOpen(parseInt(index, 10) || 0, tile);
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.closest('[data-ds-photo-lightbox-close]')) {
        event.preventDefault();
        lightboxClose();
        return;
      }
      if (event.target.closest('[data-ds-photo-lightbox-prev]')) {
        event.preventDefault();
        lightboxShow(lightboxAt - 1);
        return;
      }
      if (event.target.closest('[data-ds-photo-lightbox-next]')) {
        event.preventDefault();
        lightboxShow(lightboxAt + 1);
        return;
      }
      if (event.target.closest('[data-ds-photo-lightbox-see]')) {
        event.preventDefault();
        var wanted = strip[lightboxAt] && strip[lightboxAt].review;
        lightboxClose();
        if (!wanted) return;
        // The review is rarely one of the rows already on screen, and the two
        // breakpoints hide it differently: desktop paginates, so the review sits
        // on a page that is not the current one; mobile appends, so it sits past
        // what has been appended so far. Reaching it therefore means moving the
        // page on desktop and raising the appended count on mobile — running the
        // desktop branch on mobile lands on the wrong row, or on no row at all.
        /* The review behind a photo comes from the strip's set (one `per_page=20`
         * request), while the list can be on any page of the current query — the
         * two barely overlap, so searching the list directly almost always misses
         * and the button silently does nothing. That was the bug.
         *
         * Turning on "With photos" is the correct and cheapest route: that
         * filter's set IS the strip's set, so the review is certainly present and
         * it costs no request. The shopper can see which mode they are in because
         * the Filter chip changes with it — carrying someone to the review they
         * clicked without saying so is the confusing version.
         *
         * Matched on `id` rather than object identity: the review in `strip` and
         * the one in the list are parsed from two different responses, so the same
         * review is two objects. When `loadStrip` fails, the strip is built from
         * the metafield while `photoPool()` returns the list's rows — `indexOf`
         * never matches and the button goes silent again, the very bug this
         * exists to fix. */
        var rows = visible();
        var at = indexOfReview(rows, wanted);
        if (at < 0 && wanted.photos && wanted.photos.length) {
          var box = root.querySelector('[data-ds-reviews-filter="photo"] input');
          if (box && !box.checked) {
            box.checked = true;
            /* Through `syncFromPanels` rather than assigning `state.photo`
             * directly: it is the one place that reads the DOM back into state, so
             * the Filter chip, the Done button and the list all tell one story. */
            syncFromPanels();
            rows = visible();
            at = indexOfReview(rows, wanted);
          }
        }
        if (at < 0) return;
        var node;
        if (isDesktop()) {
          state.page = Math.floor(at / PER_PAGE) + 1;
          renderList();
          node = list.children[at % PER_PAGE];
        } else {
          if (at >= state.shown) state.shown = at + 1;
          renderList();
          node = list.children[at];
        }
        if (node) node.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') lightboxClose();
      if (event.key === 'ArrowLeft') lightboxShow(lightboxAt - 1);
      if (event.key === 'ArrowRight') lightboxShow(lightboxAt + 1);
    });

    /* Touch/pen swipe over the photo — the same step the arrows do. The viewer
     * is a single <img> whose src is swapped (no scroll track), so this can't
     * follow the finger; it commits on release past a threshold, and Judge.me's
     * strip wraps via the modulo in lightboxShow. touch-action: pan-y keeps the
     * mobile bottom-sheet vertically scrollable while horizontal drags are ours. */
    var swipeArea = lightbox.querySelector('[data-ds-photo-lightbox-viewer]');
    if (swipeArea) {
      swipeArea.style.touchAction = 'pan-y';
      var sx = 0, sy = 0, sdx = 0, sid = null, sDown = false, sHor = false;

      // Kill the browser's native image drag while a mouse drag is ours.
      swipeArea.addEventListener('dragstart', function (event) {
        if (sDown) event.preventDefault();
      });

      swipeArea.addEventListener('pointerdown', function (event) {
        // Primary button only; touch, pen and mouse all drag to step photos.
        if (event.button != null && event.button > 0) return;
        sDown = true; sHor = false; sdx = 0;
        sx = event.clientX; sy = event.clientY; sid = event.pointerId;
      });

      swipeArea.addEventListener('pointermove', function (event) {
        if (!sDown || event.pointerId !== sid) return;
        var mx = event.clientX - sx;
        var my = event.clientY - sy;
        if (!sHor) {
          if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
          // A mostly-vertical drag is the shopper scrolling the sheet — bow out.
          if (Math.abs(mx) <= Math.abs(my)) { sDown = false; return; }
          sHor = true;
          try { swipeArea.setPointerCapture(sid); } catch (err) {}
        }
        sdx = mx;
        event.preventDefault();
      });

      var endSwipe = function (event) {
        if (!sDown || (sid !== null && event.pointerId !== sid)) return;
        var moved = sdx;
        var wasHorizontal = sHor;
        sDown = false; sHor = false;
        try { if (sid !== null) swipeArea.releasePointerCapture(sid); } catch (err) {}
        sid = null;
        if (!wasHorizontal) return;
        var threshold = Math.min(80, (swipeArea.clientWidth || 1) * 0.2);
        if (moved <= -threshold) lightboxShow(lightboxAt + 1);
        else if (moved >= threshold) lightboxShow(lightboxAt - 1);
      };

      swipeArea.addEventListener('pointerup', endSwipe);
      swipeArea.addEventListener('pointercancel', endSwipe);
    }
  }

  /* Rotating a phone or dragging a desktop window across md swaps which control
   * owns the list. Without this the shopper keeps whichever they had — a pager
   * on a 375 screen, or a stranded "Load more" beside page numbers. */
  var stripTrack = root.querySelector('[data-ds-reviews-photos-track]');
  if (stripTrack) stripTrack.addEventListener('scroll', syncStripNav, { passive: true });

  var wasDesktop = isDesktop();
  window.addEventListener('resize', function () {
    syncStripNav();
    var now = isDesktop();
    if (now === wasDesktop) return;
    wasDesktop = now;
    // The same panel is a sheet on one side of md and a dropdown on the other,
    // and the two lock body scroll differently. Closing on the way across is
    // cheaper than reconciling that, and leaves no scroll lock stranded on a
    // desktop page.
    closePanels();
    state.page = 1;
    state.shown = PER_PAGE;
    renderList();
  });

  /* Mount costs exactly TWO requests and no more: one for the list's page 1, one
   * for the photo strip (`per_page=20`, the endpoint's measured hard cap). Later
   * pages are fetched as they are clicked.
   *
   * The page count comes from the metafield's `data-number-of-reviews`, so the
   * pager is there immediately, and the first request's `total_count` corrects it
   * if they disagree. */
  renderSortTrigger();
  renderFilterTrigger();

  /* The list does NOT come from the metafield, not even its first page. The
   * metafield is the Judge.me widget's HTML rendered in the shop's default order
   * (`pictures-first`), while the list asks the API in the selected sort —
   * `helpful` by default. Two different orderings. Taking page 1 from one and
   * pages 2+ from the other stitches two lists together: measured on product
   * 9902457880859, 30 rendered rows held only 23 distinct reviews — 7 repeats —
   * and photos appeared only in the first five rows, because exactly those five
   * came from the pictures-first ordering.
   *
   * So page 1 goes to the API like every other page: one ordering, nothing
   * repeated, nothing missed. The cost is one request on arrival, and the skeleton
   * already exists to cover exactly that stretch. The metafield still supplies the
   * score, the histogram and SEO — the things that do not depend on order. */
  setBusy(true);
  show(1);
  // Draw the strip immediately from the metafield's photos; `loadStrip` then
  // replaces it with the wider set. Drawing it up front keeps the block present
  // from the start rather than appearing late and shoving the list down.
  renderPhotoStrip();
  renderVariants();
  renderApply();
  loadStrip();
}

function init(scope) {
  (scope || document).querySelectorAll(ROOT).forEach(function (root) {
    if (root.dataset.dsBound) return;
    root.dataset.dsBound = '1';
    setup(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  init();
}

// Theme editor re-renders a section into a fresh subtree; bind that one too.
document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-reviews" failed to initialise:', sfError);
}
})();

/* product-variants.js */
(function () {
try {
/* product-variants — fully client-side PDP variant selection.
 * Reads every variant's option values + availability from a JSON payload
 * embedded once by ds-product-variants.liquid, so changing ANY option (Style,
 * Color, Size, ...) resolves the matching variant and updates selection,
 * cross-option availability, price, gallery and URL instantly — no server
 * round-trip, even when the change invalidates other options' selections.
 * Progressive enhancement: without JS every value remains a normal variant
 * URL, server-resolved to its best matching variant.
 * Authoring rules: src/behaviors/README.md. No import/export.
 *
 * ponytail: cross-option fallback (picking a replacement Color/Size when the
 * current one doesn't exist for a newly picked Style) matches on exact option
 * values only — it does not replicate ds-product-variant-value.liquid's
 * by-name colour matching across style-scoped strings ("Tshirt Red" ->
 * "Hoodie Red"). It falls back to the first catalogue match instead. Add the
 * by-name heuristic here if a merchant reports colour resetting oddly.
 */

function dsParseVariants(picker) {
  var script = picker.querySelector('script[data-ds-product-variants-json]');
  if (!script) return [];
  try {
    var parsed = JSON.parse(script.textContent);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function dsInitialSelection(picker, variants) {
  var id = Number(picker.dataset.dsSelectedVariantId);
  var current = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].id === id) { current = variants[i]; break; }
  }
  if (!current) current = variants[0];
  return { 1: current.option1, 2: current.option2, 3: current.option3 };
}

// Resolve the variant to select after `position` changes to `value`, keeping
// as much of the rest of `selection` as possible: options before `position`
// must match exactly (mirrors the picker's own colour/size scoping), options
// after are kept on a best-effort basis, available beats unavailable.
function dsPickVariant(variants, selection, position) {
  var best = null;
  var bestScore = -1;
  var i, p, v, score, priorOk;

  for (i = 0; i < variants.length; i++) {
    v = variants[i];
    if (v['option' + position] !== selection[position]) continue;

    priorOk = true;
    for (p = 1; p < position; p++) {
      if (selection[p] != null && v['option' + p] !== selection[p]) { priorOk = false; break; }
    }
    if (!priorOk) continue;

    score = v.available ? 1000 : 0;
    for (p = position + 1; p <= 3; p++) {
      if (selection[p] != null && v['option' + p] === selection[p]) score += 10;
    }
    if (score > bestScore) { bestScore = score; best = v; }
  }

  if (!best) {
    for (i = 0; i < variants.length; i++) {
      if (variants[i]['option' + position] === selection[position]) { best = variants[i]; break; }
    }
  }
  return best;
}

// Does some available variant carry `value` at `position` given only the
// options BEFORE `position` (mirrors dsPickVariant's priorOk) — later
// options are best-effort, not a filter. Checking ALL positions instead would
// deadlock: e.g. after Style changes and auto-corrects Color, the old Style
// value would depend on the new Color matching it, which it never will, so
// it would stay hidden forever with nothing left to reveal it.
function dsValueAvailable(variants, selection, position, value) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (v['option' + position] !== value || !v.available) continue;

    var ok = true;
    for (var p = 1; p < position; p++) {
      if (selection[p] != null && v['option' + p] !== selection[p]) { ok = false; break; }
    }
    if (ok) return true;
  }
  return false;
}

function dsSetLinkSelected(link, selected) {
  link.toggleAttribute('aria-current', selected);

  if (link.hasAttribute('data-ds-color-swatch')) {
    link.classList.toggle('sf-border-transparent', selected);
    link.classList.toggle('sf-outline', selected);
    link.classList.toggle('sf-outline-ring', selected);
    link.classList.toggle('sf-outline-secondary', selected);
    link.classList.toggle('sf-outline-offset-selected', selected);
    link.classList.toggle('sf-border-default', !selected);
    link.classList.toggle('hover:sf-border-strong', !selected);
  } else {
    // Border width stays fixed (sf-border-emphasis, set server-side); only
    // colour toggles, so selecting a value never resizes its box and shifts
    // the row (was device-dependent since it hinged on text-wrap timing).
    link.classList.toggle('sf-border-action-secondary', selected);
    link.classList.toggle('sf-text-badge-secondary', selected);
    link.classList.toggle('sf-border-default', !selected);
    link.classList.toggle('sf-text-primary', !selected);
  }
}

function dsSyncDroplistTriggers(picker) {
  picker.querySelectorAll('[data-ds-variant-droplist]').forEach(function (droplist) {
    var selectedRow = droplist.querySelector('[data-ds-variants-layout="row"][aria-current]');
    var trigger = droplist.querySelector('[data-ds-variants-layout="trigger"]');
    if (!selectedRow || !trigger) return;

    var rowLabel = selectedRow.querySelector('[data-ds-variants-label]');
    var triggerLabel = trigger.querySelector('[data-ds-variants-label]');
    if (rowLabel && triggerLabel) triggerLabel.textContent = rowLabel.textContent;

    var rowPrice = selectedRow.querySelector('[data-ds-variants-price]');
    var triggerPrice = trigger.querySelector('[data-ds-variants-price]');
    if (triggerPrice) triggerPrice.textContent = rowPrice ? rowPrice.textContent : '';

    trigger.setAttribute('data-ds-variants-value', selectedRow.getAttribute('data-ds-variants-value') || '');
  });
}

function dsUpdatePrice(productSection, variant) {
  var price = productSection.querySelector('[data-ds-product-price]');
  if (!price) return;

  var amount = price.querySelector('[data-ds-price-amount]');
  if (amount) amount.textContent = variant.price || '';

  var compare = price.querySelector('[data-ds-price-compare]');
  if (compare) {
    compare.textContent = variant.compareAtPrice || '';
    compare.hidden = !variant.compareAtPrice;
  }

  var discount = price.querySelector('[data-ds-price-discount]');
  if (discount) {
    var label = discount.querySelector('[data-ds-badge] .label');
    if (label) label.textContent = variant.discount || '';
    discount.hidden = !variant.discount;
  }
}

function dsUpdateForms(productSection, variantId) {
  productSection.querySelectorAll('input[name="id"]').forEach(function (input) {
    input.value = variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function dsUpdateGallery(productSection, imageId) {
  if (!imageId) return;
  var tile = productSection.querySelector('[data-ds-thumbnail-rail-image-id="' + imageId + '"] [data-ds-thumbnail]');
  if (tile) tile.click();
}

function dsApplyVariant(picker, productSection, variants, selection, variant) {
  [1, 2, 3].forEach(function (p) {
    if (variant['option' + p] != null) selection[p] = variant['option' + p];
  });

  picker.querySelectorAll('[data-ds-product-variant-option]').forEach(function (wrapper) {
    var position = Number(wrapper.dataset.optionPosition);
    var value = wrapper.dataset.optionValue;
    if (!position || value == null) return;

    var selected = selection[position] === value;
    var available = dsValueAvailable(variants, selection, position, value);
    wrapper.hidden = !available && !selected;

    var link = wrapper.querySelector('[data-ds-variants], [data-ds-color-swatch]');
    if (link) dsSetLinkSelected(link, selected);
  });

  dsSyncDroplistTriggers(picker);
  dsUpdatePrice(productSection, variant);
  dsUpdateForms(productSection, variant.id);
  dsUpdateGallery(productSection, variant.imageId);

  var url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  url.searchParams.delete('option_values');
  url.searchParams.delete('section_id');
  window.history.replaceState({}, '', url.toString());

  productSection.dispatchEvent(new CustomEvent('variant:change', {
    detail: { variantId: variant.id, url: url.toString() },
    bubbles: true,
  }));
}

if (!document.__dsProductVariantsBound) {
  document.__dsProductVariantsBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest(
      '[data-ds-product-variants] a[data-ds-variants], [data-ds-product-variants] a[data-ds-color-swatch]'
    );
    if (!link) return;

    var wrapper = link.closest('[data-ds-product-variant-option]');
    var picker = link.closest('[data-ds-product-variants]');
    var productSection = link.closest('[data-ds-product-section]');
    if (!wrapper || !picker || !productSection) return;

    var position = Number(wrapper.dataset.optionPosition);
    var value = wrapper.dataset.optionValue;
    if (!position || value == null) return;

    if (!picker.__dsVariants) picker.__dsVariants = dsParseVariants(picker);
    var variants = picker.__dsVariants;
    if (!variants.length) return; // no JSON payload — fall back to native navigation

    if (!picker.__dsSelection) picker.__dsSelection = dsInitialSelection(picker, variants);
    var selection = picker.__dsSelection;
    var previous = selection[position];
    selection[position] = value;

    var variant = dsPickVariant(variants, selection, position);
    if (!variant) { selection[position] = previous; return; }

    event.preventDefault();
    dsApplyVariant(picker, productSection, variants, selection, variant);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-variants" failed to initialise:', sfError);
}
})();

/* region-modal.js */
(function () {
try {
/* region-modal — opens the shared "Region and language" dialog (ds-region-modal)
 * from any [data-ds-locale-open] trigger (header / footer locale selector),
 * filters the country list, and on row-click sets the localization form's
 * country_code and submits it (POST /localization) to switch country + currency.
 *
 * Singleton: ds-region-modal is meant to render once per page, but the header and
 * footer selectors may each include one. On init we keep the first modal in the
 * DOM and remove any extras so every trigger drives the same dialog.
 *
 * Progressive enhancement: without this script the triggers are inert and the
 * modal stays hidden — nothing breaks, the country just can't be changed from the
 * selector until JS loads.
 *
 * Open/closed is one attribute, [aria-hidden]. src/region-modal.css carries the
 * fade + slide off it so the sheet stays painted while it animates out; toggling
 * a display utility here would cut that off.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsRegionModalBound) return;
  document.__dsRegionModalBound = true;

  var lastTrigger = null;

  function getModal() {
    return document.querySelector('[data-ds-region-modal]');
  }

  function dedupe() {
    var modals = document.querySelectorAll('[data-ds-region-modal]');
    for (var i = 1; i < modals.length; i++) {
      modals[i].parentNode && modals[i].parentNode.removeChild(modals[i]);
    }
  }

  function openModal(trigger) {
    // Sections can mount after this behavior initializes (Theme Editor and
    // Storybook do this), so enforce the singleton again at interaction time.
    dedupe();
    var modal = getModal();
    if (!modal) return;
    lastTrigger = trigger || null;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var search = modal.querySelector('[data-ds-region-search]');
    if (search) {
      search.value = '';
      applyFilter(modal, '');
      // Focus after paint so the dialog is visible first.
      window.requestAnimationFrame(function () {
        search.focus();
      });
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function isOpen(modal) {
    return !!modal && modal.getAttribute('aria-hidden') === 'false';
  }

  // Tab must cycle inside the dialog while it is open, otherwise focus walks the
  // page behind the sheet — which is still rendered ([aria-hidden] only).
  function trapTab(e) {
    var modal = getModal();
    if (!isOpen(modal)) return;
    var dialog = modal.querySelector('[data-ds-region-dialog]') || modal;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  function applyFilter(modal, rawQuery) {
    var query = (rawQuery || '').trim().toLowerCase();
    var searching = query.length > 0;

    var popularGroup = modal.querySelector('[data-ds-region-group="popular"]');
    var allLabel = modal.querySelector('[data-ds-region-all-label]');
    var allGroup = modal.querySelector('[data-ds-region-group="all"]');
    var empty = modal.querySelector('[data-ds-region-empty]');

    // While searching, collapse the "popular" shortcut list and its label so
    // results aren't duplicated — filter within the full list only.
    if (popularGroup) popularGroup.hidden = searching;
    if (allLabel) allLabel.hidden = searching;

    var visible = 0;
    var scope = searching ? [allGroup] : [popularGroup, allGroup];
    scope.forEach(function (group) {
      if (!group) return;
      var options = group.querySelectorAll('[data-ds-region-option]');
      options.forEach(function (opt) {
        var haystack = opt.getAttribute('data-search') || '';
        var match = !searching || haystack.indexOf(query) !== -1;
        var li = opt.closest('li') || opt;
        li.hidden = !match;
        if (match) visible++;
      });
    });

    if (empty) empty.classList.toggle('sf-hidden', visible > 0);
  }

  function selectCountry(option) {
    var modal = getModal();
    if (!modal) return;
    var form = modal.querySelector('[data-ds-region-form]');
    var input = modal.querySelector('[data-ds-region-country-input]');
    var value = option.getAttribute('data-value');
    if (!form || !input || !value) return;
    input.value = value;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  dedupe();

  // Open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ds-locale-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
    }
  });

  // Close (X button) + close on overlay (click outside the dialog) + select row
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-ds-region-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    var option = e.target.closest('[data-ds-region-option]');
    if (option) {
      e.preventDefault();
      selectCountry(option);
      return;
    }

    var modal = getModal();
    if (isOpen(modal) && e.target === modal) {
      closeModal();
    }
  });

  // Filter as the user types
  document.addEventListener('input', function (e) {
    if (!e.target.closest) return;
    if (!e.target.matches('[data-ds-region-search]')) return;
    var modal = e.target.closest('[data-ds-region-modal]');
    if (modal) applyFilter(modal, e.target.value);
  });

  // Esc closes; Tab stays inside the dialog
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = getModal();
      if (isOpen(modal)) closeModal();
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "region-modal" failed to initialise:', sfError);
}
})();

/* review-form.js */
(function () {
try {
/* review-form — opens the write-a-review sheet and posts it to Judge.me.
 *
 * This one CAN submit for real, which the rest of the reviews work could not.
 * Judge.me's own widget posts a review to `api.judge.me/api/v1/reviews` with a
 * body of `{url, shop_domain, platform}` plus the fields — and no api_token
 * anywhere (their `shopParams()` returns exactly those three). So a storefront
 * may post directly: no App Proxy, no secret in the theme. Photos use the same
 * public pair — GET a presigned target, PUT the file, send the returned key
 * back as `picture_keys[n]`.
 *
 * Moderation is why the success state says "once our team has checked it over"
 * rather than "your review is live": Judge.me queues new reviews, and a shopper
 * who does not know that submits again.
 *
 * Open/close follows region-modal.js exactly — [aria-hidden] on the overlay
 * drives both the animation (review-form.css) and the a11y tree, focus is
 * trapped while open and handed back to whatever opened it on close.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var FORM = '[data-ds-review-form]';
var TRIGGER = '[data-ds-reviews-write]';
var API = 'https://api.judge.me/api/v1/reviews';
var PRESIGN = 'https://api.judge.me/api/v1/pictures/presigned_data';
// The ceiling in Judge.me's own presigned policy (content-length-range).
var MAX_PHOTO_BYTES = 10 * 1024 * 1024;

var FOCUSABLE =
  'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

function visible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function setup(overlay) {
  var dialog = overlay.querySelector('[data-ds-review-form-dialog]');
  var form = overlay.querySelector('[data-ds-review-form-element]');
  var body = overlay.querySelector('[data-ds-review-form-body]');
  var counter = overlay.querySelector('[data-ds-review-form-counter]');
  var submitBox = overlay.querySelector('[data-ds-review-form-submit]');
  var errorBox = overlay.querySelector('[data-ds-review-form-error]');
  var done = overlay.querySelector('[data-ds-review-form-done]');
  if (!dialog || !form || !body) return;

  var submitOff = overlay.querySelector('[data-ds-review-form-submit-off]');
  var submitOn = overlay.querySelector('[data-ds-review-form-submit-on]');
  var submit = submitOn && submitOn.querySelector('button');
  var max = parseInt(overlay.getAttribute('data-ds-review-form-max'), 10) || 200;
  var min = parseInt(overlay.getAttribute('data-ds-review-form-min'), 10) || 10;
  var maxPhotos = parseInt(overlay.getAttribute('data-ds-review-form-photos'), 10) || 5;
  var files = [];
  var opener = null;
  // Copy the behaviour needs but must not contain: a behaviour cannot call `| t`,
  // so every string rides in on an attribute.
  var copy = {
    helper: overlay.getAttribute('data-ds-review-form-helper') || '',
    helperShort: overlay.getAttribute('data-ds-review-form-helper-short') || '',
    removePhoto: overlay.getAttribute('data-ds-review-form-photo-remove') || '',
    photosFull: overlay.getAttribute('data-ds-review-form-photos-full') || '',
    photoTooBig: overlay.getAttribute('data-ds-review-form-photo-too-big') || '',
  };

  /* ── open / close ─────────────────────────────────────────────────────── */

  function open(trigger) {
    opener = trigger || null;
    overlay.setAttribute('aria-hidden', 'false');
    // Lock the page behind the modal on <body>, the same handle region-modal.js
    // and the cart/header drawers use — locking <html> here left the page
    // scrolling underneath on the storefronts this actually ships to.
    document.body.style.overflow = 'hidden';
    var first = dialog.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  function isOpen() {
    return overlay.getAttribute('aria-hidden') === 'false';
  }

  // Any write-a-review control on the page opens this one sheet — the band's
  // button and the empty state's both carry the same hook. The hook sits on a
  // full-width wrapper (ds-button has no attributes slot), so only a click that
  // actually lands on the button/link inside opens — not the empty flex space.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER);
    if (!trigger || overlay.contains(trigger)) return;
    var control = event.target.closest('button, a');
    if (!control || !trigger.contains(control)) return;
    event.preventDefault();
    open(control);
  });

  overlay.addEventListener('click', function (event) {
    // Clicking the scrim closes; clicking anywhere inside the card does not.
    if (event.target === overlay) {
      close();
      return;
    }
    if (event.target.closest('[data-ds-review-form-close], [data-ds-review-form-cancel]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    // Tab must cycle inside the dialog, or focus walks the page behind it.
    var stops = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), visible);
    if (!stops.length) return;
    var first = stops[0];
    var last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ── stars ────────────────────────────────────────────────────────────── */

  /* Fill every star up to the chosen one. Both glyphs are already in the label
   * (see ds-review-form.liquid) — the colour stays orange throughout and only
   * the hollow/solid pair swaps, which is what Figma draws. */
  function paintStars(value) {
    overlay.querySelectorAll('[data-ds-review-form-star-label]').forEach(function (label) {
      var index = parseInt(label.getAttribute('data-ds-review-form-star-label'), 10);
      var hollow = label.querySelector('[data-ds-review-form-star-hollow]');
      var solid = label.querySelector('[data-ds-review-form-star-solid]');
      if (hollow) hollow.classList.toggle('sf-hidden', index <= value);
      if (solid) solid.classList.toggle('sf-hidden', index > value);
    });
  }

  overlay.addEventListener('change', function (event) {
    var star = event.target.closest('[data-ds-review-form-star]');
    if (!star) return;
    paintStars(parseInt(star.value, 10) || 0);
    refresh();
  });

  /* ── body counter ─────────────────────────────────────────────────────── */

  var helper = overlay.querySelector('[data-ds-review-form-body-helper]');

  body.addEventListener('input', function () {
    if (counter) counter.textContent = body.value.length + '/' + max;
    // Figma's desktop frame shows the budget and its mobile frame shows the
    // floor; both are true, so the helper says whichever one the shopper is
    // currently failing. Silent while the field is still untouched.
    if (helper) {
      var length = body.value.trim().length;
      helper.textContent = length > 0 && length < min ? copy.helperShort : copy.helper;
    }
    refresh();
  });

  /* ── photos ───────────────────────────────────────────────────────────── */

  var fileInput = overlay.querySelector('[data-ds-review-form-file]');
  var thumbs = overlay.querySelector('[data-ds-review-form-thumbs]');

  // The dashed dropzone is a <label> wrapping this screen-reader-only file input
  // (ds-review-form.liquid), so a click anywhere in the box opens the native
  // picker with no JS — nothing to bind here, only its `change` to read below.

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var overflowed = false;
      var oversized = false;
      Array.prototype.forEach.call(fileInput.files || [], function (file) {
        if (files.length >= maxPhotos) {
          overflowed = true;
          return;
        }
        // Judge.me's presigned policy carries content-length-range 0..10485760,
        // so a bigger file is rejected by S3 with nothing useful to show for it.
        if (file.size > MAX_PHOTO_BYTES) {
          oversized = true;
          return;
        }
        files.push(file);
      });
      fileInput.value = '';
      // Dropping the extras silently looks like the picker failed.
      if ((overflowed || oversized) && errorBox) {
        errorBox.textContent = oversized ? copy.photoTooBig : copy.photosFull;
        errorBox.classList.remove('sf-hidden');
      }
      renderThumbs();
      refresh();
    });
  }

  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    thumbs.classList.toggle('sf-hidden', files.length === 0);
    thumbs.classList.toggle('sf-flex', files.length > 0);
    files.forEach(function (file, index) {
      var item = document.createElement('li');
      item.className = 'sf-relative sf-h-review-photo-strip sf-w-review-photo-strip sf-overflow-hidden sf-rounded-md sf-bg-subtle';
      var img = document.createElement('img');
      img.className = 'sf-h-full sf-w-full sf-object-cover';
      img.alt = '';
      img.src = URL.createObjectURL(file);
      item.appendChild(img);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'sf-absolute sf-right-1 sf-top-1 sf-inline-flex sf-h-6 sf-w-6 sf-cursor-pointer sf-items-center sf-justify-center sf-rounded-circle sf-border-0 sf-bg-inverse sf-text-inverse';
      remove.textContent = '×';
      remove.setAttribute('aria-label', copy.removePhoto);
      remove.setAttribute('data-ds-review-form-remove', String(index));
      item.appendChild(remove);
      thumbs.appendChild(item);
    });
  }

  overlay.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-ds-review-form-remove]');
    if (!remove) return;
    event.preventDefault();
    files.splice(parseInt(remove.getAttribute('data-ds-review-form-remove'), 10), 1);
    renderThumbs();
  });

  /* Judge.me's public two-step, matched to what their own uploader actually
   * sends (widget_form.js `_prepareFormData`). The shape is easy to get wrong
   * and fails silently, which is what happened here first: the presigned
   * response has NO `fields.key` — the key is built from a top-level
   * `key_prefix` plus the filename, appended BEFORE the other fields, with the
   * file last. Reading `fields.key` threw, the catch swallowed it, and every
   * photo was quietly dropped from the review.
   *
   * S3 answers 201 (the policy sets success_action_status), and the key we
   * built is what Judge.me wants back as `picture_keys[n]`.
   */

  // Their normalisation, kept identical so a name we accept is a name S3's
  // policy accepts: strip anything outside [a-z0-9-_.], and if that leaves no
  // basename at all, stand a timestamp in for it.
  function safeName(file) {
    var stripped = String(file.name || '').replace(/[^a-z0-9-_.]/gi, '');
    var parts = stripped.split('.');
    var ext = parts.pop();
    if (!parts.join('').length) stripped = Date.now() + '.' + ext;
    return encodeURIComponent(stripped);
  }

  function uploadPhotos() {
    if (!files.length) return Promise.resolve([]);
    var shop = overlay.getAttribute('data-ds-review-form-shop');
    var query =
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify';

    return fetch(PRESIGN + query)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (presigned) {
        if (!presigned || !presigned.url || !presigned.key_prefix) return [];
        return Promise.all(
          files.map(function (file) {
            var key = presigned.key_prefix + safeName(file);
            var data = new FormData();
            data.append('key', key);
            Object.keys(presigned.fields || {}).forEach(function (field) {
              data.append(field, presigned.fields[field]);
            });
            data.append('file', file);
            return fetch(presigned.url, { method: 'POST', body: data })
              .then(function (r) { return r.ok ? key : null; })
              .catch(function () { return null; });
          }),
        ).then(function (keys) { return keys.filter(Boolean); });
      })
      .catch(function () { return []; });
  }

  /* ── validity ─────────────────────────────────────────────────────────── */

  function rating() {
    var picked = overlay.querySelector('[data-ds-review-form-star]:checked');
    return picked ? parseInt(picked.value, 10) : 0;
  }

  function refresh() {
    var name = overlay.querySelector('[data-ds-review-form-name]');
    var email = overlay.querySelector('[data-ds-review-form-email]');
    var ready = !!(
      rating() > 0 &&
      body.value.trim().length >= min &&
      name && name.value.trim() &&
      email && email.value.trim() && email.checkValidity()
    );
    if (submitOff) submitOff.classList.toggle('sf-hidden', ready);
    if (submitOn) submitOn.classList.toggle('sf-hidden', !ready);
  }

  form.addEventListener('input', refresh);

  /* ── submit ───────────────────────────────────────────────────────────── */

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!submit || submit.disabled) return;

    var shop = overlay.getAttribute('data-ds-review-form-shop');
    var productId = overlay.getAttribute('data-ds-review-form-product');
    var name = overlay.querySelector('[data-ds-review-form-name]');
    var email = overlay.querySelector('[data-ds-review-form-email]');

    submit.disabled = true;
    if (errorBox) errorBox.classList.add('sf-hidden');

    uploadPhotos().then(function (keys) {
      var payload = new FormData();
      payload.append('url', shop);
      payload.append('shop_domain', shop);
      payload.append('platform', 'shopify');
      payload.append('id', productId);
      payload.append('rating', String(rating()));
      payload.append('body', body.value.trim());
      payload.append('name', name ? name.value.trim() : '');
      payload.append('email', email ? email.value.trim() : '');
      keys.forEach(function (key, index) {
        payload.append('picture_keys[' + index + ']', key);
      });

      return fetch(API, { method: 'POST', body: payload })
        .then(function (response) {
          if (!response.ok) throw new Error('rejected');
          form.classList.add('sf-hidden');
          if (done) {
            done.classList.remove('sf-hidden');
            done.classList.add('sf-flex');
          }
        })
        .catch(function () {
          if (errorBox) {
            errorBox.textContent = overlay.getAttribute('data-ds-review-form-error-text') || errorBox.textContent;
            errorBox.classList.remove('sf-hidden');
          }
          submit.disabled = false;
        });
    });
  });

  paintStars(0);
  refresh();
}

function init(scope) {
  (scope || document).querySelectorAll(FORM).forEach(function (overlay) {
    if (overlay.dataset.dsBound) return;
    overlay.dataset.dsBound = '1';
    setup(overlay);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  init();
}

document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "review-form" failed to initialise:', sfError);
}
})();

/* save-for-later.js */
(function () {
try {
/* save-for-later — the cart's "Save for later" list.
 *
 * WHERE IT LIVES (DEFAULT0260): localStorage, not a customer metafield. A theme
 * has no backend, and a metafield can only be written for a logged-in customer
 * through the Admin API — impossible for the guest who is most of a POD store's
 * traffic (Baymard: save-for-later is a cart-abandonment tool, so it has to work
 * before sign-in). localStorage keeps it client-only and guest-first. The
 * trade-off, accepted here: the list is per-browser, not cross-device, and is
 * cleared with site data. The cart itself stays the source of truth for the
 * purchase; this is only a holding shelf.
 *
 * Snapshot: saving a line reads what the cart page renders — title, image,
 * price, variant, and the VISIBLE personalization (line item properties). Hidden
 * `_`-properties are not in the DOM (Liquid drops them), so Move to Cart cannot
 * restore them; a proof URL a POD app stamped as `_proof` would be re-generated
 * by that app on the new line, not carried. Documented, not silent.
 *
 * Moving to cart re-adds by variant id (the part of the line key before ':')
 * with the saved properties, then reloads so the line list and Order Summary
 * reflect the new line — no partial client re-render to drift from the server.
 *
 * Reads/writes the grid rendered by snippets/ds-cart-saved.liquid, cloning its
 * <template> per entry. Binds data-ds-* only. Authoring rules: README.md.
 */
var SFL_CART_ITEM = '[data-ds-cart-item]';

function sflKey() {
  var host = '';
  try { host = window.location.host || ''; } catch (e) { host = ''; }
  return 'ds:cart:saved:' + host;
}

function sflRead() {
  try {
    var raw = window.localStorage.getItem(sflKey());
    var list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

function sflWrite(list) {
  try {
    window.localStorage.setItem(sflKey(), JSON.stringify(list));
  } catch (e) {
    /* private mode / quota — the shelf is a convenience, so fail quiet */
  }
}

function sflUrl(path) {
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  return (root || '/') + path;
}

// The line key is `<variant_id>:<properties_hash>`; the id is what /cart/add.js
// wants back.
function sflVariantId(key) {
  return String(key || '').split(':')[0];
}

function sflText(root, selector) {
  var el = root.querySelector(selector);
  return el ? el.textContent.trim() : '';
}

function sflSnapshot(line) {
  var key = line.getAttribute('data-ds-cart-item-key') || '';
  var img = line.querySelector('img[src]');
  var titleEl = line.querySelector('[data-ds-cart-item-title]');
  var options = [];
  // The chosen options render as the caption spans directly under the title.
  var optionWrap = titleEl && titleEl.parentNode ? titleEl.parentNode.querySelector('div') : null;
  if (optionWrap) {
    optionWrap.querySelectorAll('span').forEach(function (span) {
      var text = span.textContent.trim();
      if (text) options.push(text);
    });
  }
  var properties = {};
  line.querySelectorAll('[data-ds-cart-item-properties] > div').forEach(function (row) {
    var dt = row.querySelector('dt');
    var dd = row.querySelector('dd');
    if (dt && dd) properties[dt.textContent.trim()] = dd.textContent.trim();
  });
  return {
    id: sflVariantId(key),
    key: key,
    title: titleEl ? titleEl.textContent.trim() : '',
    url: titleEl && titleEl.getAttribute('href') ? titleEl.getAttribute('href') : '',
    image: img ? img.getAttribute('src') : '',
    price: sflText(line, '[data-ds-price-amount]'),
    compareAt: sflText(line, '[data-ds-price-compare]'),
    variant: options.join(' / '),
    properties: properties,
  };
}

function sflAddEntry(entry) {
  if (!entry.id) return;
  var list = sflRead().filter(function (e) { return e.key !== entry.key; });
  list.unshift(entry);
  sflWrite(list);
}

function sflRemoveEntry(key) {
  sflWrite(sflRead().filter(function (e) { return e.key !== key; }));
}

// Fill one cloned card from an entry, toggling the optional rows off when the
// entry has nothing for them.
function sflFillCard(card, entry) {
  card.setAttribute('data-ds-cart-favorite-key', entry.key);
  var title = card.querySelector('[data-ds-cart-favorite-title]');
  if (title) {
    title.textContent = entry.title || '';
    if (entry.url && title.tagName === 'A') title.setAttribute('href', entry.url);
    else if (title.tagName === 'A') title.removeAttribute('href');
  }
  var img = card.querySelector('img');
  if (img) {
    if (entry.image) { img.setAttribute('src', entry.image); img.setAttribute('alt', entry.title || ''); }
  }
  var toggle = function (selector, value) {
    var el = card.querySelector(selector);
    if (!el) return;
    if (value) { el.textContent = value; el.hidden = false; el.style.display = ''; }
    else { el.hidden = true; el.style.display = 'none'; }
  };
  toggle('[data-ds-cart-favorite-variant]', entry.variant);
  toggle('[data-ds-cart-favorite-type]', entry.productType);
  var amount = card.querySelector('[data-ds-price-amount]');
  if (amount) amount.textContent = entry.price || '';
  var compare = card.querySelector('[data-ds-price-compare]');
  if (compare) {
    if (entry.compareAt) { compare.textContent = entry.compareAt; compare.hidden = false; compare.style.display = ''; }
    else { compare.hidden = true; compare.style.display = 'none'; }
  }
  var unit = card.querySelector('[data-ds-price-unit]');
  if (unit) { unit.hidden = !entry.unit; unit.style.display = entry.unit ? '' : 'none'; if (entry.unit) unit.textContent = entry.unit; }
  return card;
}

function sflRender() {
  var section = document.querySelector('[data-ds-cart-saved]');
  if (!section) return;
  var grid = section.querySelector('[data-ds-cart-saved-grid]');
  var template = section.querySelector('[data-ds-cart-saved-template]');
  if (!grid || !template) return;
  var list = sflRead();
  var count = section.querySelector('[data-ds-cart-saved-count]');
  if (count) count.textContent = String(list.length);

  if (!list.length) {
    section.hidden = true;
    grid.textContent = '';
    return;
  }
  section.hidden = false;

  var pageSize = Number(section.getAttribute('data-ds-cart-saved-page-size')) || 4;
  var expanded = section.getAttribute('data-ds-cart-saved-expanded') === 'true';
  var shown = expanded ? list : list.slice(0, pageSize);

  grid.textContent = '';
  shown.forEach(function (entry) {
    var clone = template.content.firstElementChild.cloneNode(true);
    sflFillCard(clone, entry);
    grid.appendChild(clone);
  });

  var moreWrap = section.querySelector('[data-ds-cart-saved-more-wrap]');
  if (moreWrap) moreWrap.hidden = expanded || list.length <= pageSize;
}

function sflSave(line) {
  var key = line.getAttribute('data-ds-cart-item-key');
  if (!key) return;
  sflAddEntry(sflSnapshot(line));
  // Take the line out of the cart. Saving is intentional — no undo window; the
  // way back is Move to Cart — so this commits straight away.
  fetch(sflUrl('cart/change.js'), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      if (!result.ok) {
        // Put the entry back on the shelf's failure: the line is still in the cart.
        sflRemoveEntry(key);
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
        return;
      }
      if (line.parentNode) line.parentNode.removeChild(line);
      document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: result.data }));
      sflRender();
    })
    .catch(function (error) {
      sflRemoveEntry(key);
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
    });
}

function sflMoveToCart(card) {
  var key = card.getAttribute('data-ds-cart-favorite-key');
  var entry = sflRead().filter(function (e) { return e.key === key; })[0];
  if (!entry || !entry.id) return;
  card.setAttribute('aria-busy', 'true');
  fetch(sflUrl('cart/add.js'), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: entry.id, quantity: 1, properties: entry.properties || {} }),
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      card.removeAttribute('aria-busy');
      if (!result.ok) {
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
        return;
      }
      sflRemoveEntry(key);
      document.dispatchEvent(new CustomEvent('ds:cart:moved', { detail: { id: entry.id } }));
      // Reload so the line list and Order Summary come from the server, not a
      // client guess. Tests set __dsSflNoReload to inspect the call instead.
      if (!window.__dsSflNoReload) window.location.reload();
      else sflRender();
    })
    .catch(function (error) {
      card.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
    });
}

if (!document.__dsSflBound) {
  document.__dsSflBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var save = target.closest('[data-ds-cart-item-save]');
    if (save) {
      var line = save.closest(SFL_CART_ITEM);
      if (line) { event.preventDefault(); sflSave(line); }
      return;
    }

    var move = target.closest('[data-ds-cart-favorite-move]');
    if (move) {
      var card = move.closest('[data-ds-cart-favorite]');
      if (card) { event.preventDefault(); sflMoveToCart(card); }
      return;
    }

    var remove = target.closest('[data-ds-cart-favorite-remove]');
    if (remove) {
      var rcard = remove.closest('[data-ds-cart-favorite]');
      if (rcard) { event.preventDefault(); sflRemoveEntry(rcard.getAttribute('data-ds-cart-favorite-key')); sflRender(); }
      return;
    }

    var more = target.closest('[data-ds-cart-saved-more]');
    if (more) {
      var section = more.closest('[data-ds-cart-saved]');
      if (section) { event.preventDefault(); section.setAttribute('data-ds-cart-saved-expanded', 'true'); sflRender(); }
    }
  });

  sflRender();
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "save-for-later" failed to initialise:', sfError);
}
})();

/* scroll-top.js */
(function () {
try {
/* scroll-top — reveals the site-wide floating "scroll to top" FAB once the page
 * has been scrolled past a threshold, and smooth-scrolls to the top on click.
 * Binds [data-ds-scroll-top] (see snippets/ds-scroll-to-top.liquid). Each button
 * carries its own reveal threshold in data-ds-scroll-top (px, merchant setting).
 *
 * Progressive enhancement: the button server-renders hidden (inline display:none)
 * and this reveals it on scroll, so with no JS it never shows — a scroll-to-top
 * control can only smooth-scroll with JS anyway (same reveal-on-scroll shape as
 * sticky-bar.js). Honours prefers-reduced-motion by jumping instead of animating.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsScrollTopBound) {
  document.__dsScrollTopBound = true;

  // Toggle each FAB's inline display in step with the scroll position. Inline
  // display (not a class) so it overrides the responsive device-visibility
  // utilities the button carries; '' restores those, 'none' hides.
  function dsScrollTopUpdate() {
    var buttons = document.querySelectorAll('[data-ds-scroll-top]');
    if (!buttons.length) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    for (var i = 0; i < buttons.length; i++) {
      var after = Number(buttons[i].getAttribute('data-ds-scroll-top')) || 0;
      buttons[i].style.display = y > after ? '' : 'none';
    }
  }

  // Delegate on document so a button added by a Theme-Editor section re-render is
  // handled without re-binding.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ds-scroll-top]');
    if (!trigger) return;
    event.preventDefault();
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', dsScrollTopUpdate, { passive: true });
  window.addEventListener('resize', dsScrollTopUpdate);
  // Theme editor re-adds/reorders sections without a full reload.
  document.addEventListener('shopify:section:load', dsScrollTopUpdate);

  dsScrollTopUpdate();
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "scroll-top" failed to initialise:', sfError);
}
})();

/* size-guide.js */
(function () {
try {
/* size-guide — opens the size-guide dialog (ds-size-guide) from its
 * [data-ds-size-guide-open] link on the size option's label row, closes it on X,
 * overlay click and Esc, and keeps Tab inside the dialog while it is open.
 *
 * Not a singleton: the picker renders one guide per product, but a page may hold
 * more than one product block (quick view, bundles), so every handler resolves
 * the dialog from the trigger's own subtree and falls back to the only one in the
 * document. Nothing is deduped or removed.
 *
 * Progressive enhancement: without this script the link is inert and the dialog
 * stays hidden — the variant picker itself is untouched.
 *
 * Open/closed is one attribute, [aria-hidden]. src/size-guide.css carries the
 * fade + slide off it, so the sheet stays painted while it animates out;
 * toggling a display utility here would cut that off.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsSizeGuideBound) return;
  document.__dsSizeGuideBound = true;

  var lastTrigger = null;

  // The trigger sits next to its own dialog, so walk up to the nearest shared
  // ancestor that holds one before falling back to the page's only guide.
  function modalFor(el) {
    var node = el;
    while (node && node !== document) {
      var found = node.querySelector && node.querySelector('[data-ds-size-guide]');
      if (found) return found;
      node = node.parentNode;
    }
    return document.querySelector('[data-ds-size-guide]');
  }

  function isOpen(modal) {
    return !!modal && modal.getAttribute('aria-hidden') === 'false';
  }

  function openModal(trigger) {
    var modal = modalFor(trigger);
    if (!modal) return;
    lastTrigger = trigger || null;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var close = modal.querySelector('[data-ds-size-guide-close]');
    if (close) {
      // Focus after paint so the dialog is visible first.
      window.requestAnimationFrame(function () {
        close.focus();
      });
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function openModalEl() {
    var modals = document.querySelectorAll('[data-ds-size-guide]');
    for (var i = 0; i < modals.length; i++) {
      if (isOpen(modals[i])) return modals[i];
    }
    return null;
  }

  // Tab must cycle inside the dialog while it is open, otherwise focus walks the
  // page behind the sheet — which is still rendered ([aria-hidden] only).
  function trapTab(e) {
    var modal = openModalEl();
    if (!modal) return;
    var dialog = modal.querySelector('[data-ds-size-guide-dialog]') || modal;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var trigger = e.target.closest('[data-ds-size-guide-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }

    var close = e.target.closest('[data-ds-size-guide-close]');
    if (close) {
      e.preventDefault();
      closeModal(close.closest('[data-ds-size-guide]') || openModalEl());
      return;
    }

    // Overlay: the click landed on the backdrop itself, not inside the card.
    if (e.target.matches && e.target.matches('[data-ds-size-guide]') && isOpen(e.target)) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = openModalEl();
      if (modal) closeModal(modal);
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "size-guide" failed to initialise:', sfError);
}
})();

/* sticky-bar.js */
(function () {
try {
/* sticky-bar — mobile fixed add-to-cart bar for the PDP.
 * Binds [data-ds-product-sticky-bar] (see snippets/ds-product-sticky-bar.liquid).
 * Reveals the bar once the main buy box ([data-ds-product-buy-buttons]) scrolls
 * out of view upward, and hides it again when the buy box returns. The bar's
 * "Add to Cart" ([data-ds-sticky-atc]) DELEGATES to the real submit, so native
 * and BuildYou (personalized) add-to-cart both run unchanged — the bar never
 * posts to the cart itself.
 *
 * Generic activator only: no pricing/variant logic (that lives in the theme).
 * The bar starts hidden (sf-hidden); this reveals it, so with no JS it never
 * shows and the in-flow buy button still works.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsStickyBarBound) {
  document.__dsStickyBarBound = true;

  var stickyBar = document.querySelector('[data-ds-product-sticky-bar]');
  var stickyBuyBox = document.querySelector('[data-ds-product-buy-buttons]');

  if (stickyBar) {
    if (stickyBuyBox && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          // Reveal only when the buy box has scrolled ABOVE the viewport. While
          // it is on screen (or still below, before the shopper reaches it),
          // the in-flow button is enough and the bar stays hidden.
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.remove('sf-hidden');
          } else {
            stickyBar.classList.add('sf-hidden');
          }
        },
        { threshold: 0 }
      );
      stickyObserver.observe(stickyBuyBox);
    }

    stickyBar.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ds-sticky-atc]');
      if (!trigger) return;
      event.preventDefault();
      // Forward to the real control: the SDK's aliased button when personalized,
      // else the native form submit. Clicking a disabled one is a no-op (the SDK
      // disables it until the customization form is ready).
      var main =
        (stickyBuyBox && stickyBuyBox.querySelector('.cus-add_to_cart')) ||
        (stickyBuyBox && stickyBuyBox.querySelector('button[type="submit"]'));
      if (main) {
        if (main.disabled) return;
        main.click();
      } else if (stickyBuyBox) {
        stickyBuyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "sticky-bar" failed to initialise:', sfError);
}
})();

/* tags-input.js */
(function () {
try {
/* tags-input — add a tag on Enter (as a removable chip + hidden input) and
 * remove it on chip click. Binds [data-ds-tags-input] and its children (see
 * snippets/ds-tags-input.liquid). New chips are cloned from the snippet's
 * [data-ds-tags-input-template] (a ds-chip with a __DS_TAG__ placeholder) so no
 * client-side Liquid render is needed — this is why it ships. Progressive
 * enhancement: server-rendered tags submit and remove-markup exists without JS;
 * only adding via the keyboard is enhanced.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var TAGS = '[data-ds-tags-input]';
var TAGS_LIST = '[data-ds-tags-input-list]';
var TAGS_FIELD = '[data-ds-tags-input-field]';
var TAGS_TEMPLATE = '[data-ds-tags-input-template]';
var TAG_MARKER = '__DS_TAG__';

function addTag(root, value) {
  var list = root.querySelector(TAGS_LIST);
  var template = root.querySelector(TAGS_TEMPLATE);
  var field = root.querySelector(TAGS_FIELD);
  if (!list || !template || !field) return;

  var chip = template.content.querySelector('[data-ds-chip]');
  if (!chip) return;
  chip = chip.cloneNode(true);

  // Swap the placeholder in the visible label text node.
  var walker = document.createTreeWalker(chip, NodeFilter.SHOW_TEXT, null);
  var node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.indexOf(TAG_MARKER) !== -1) {
      node.nodeValue = node.nodeValue.replace(TAG_MARKER, value);
    }
  }
  // Accessible name: "<remove-copy>: <value>", falling back to the value alone.
  var removeCopy = root.getAttribute('data-ds-tags-input-remove');
  chip.setAttribute('aria-label', removeCopy ? removeCopy + ': ' + value : value);

  // Each tag is a hidden <input> immediately before its chip so the set submits.
  var hidden = document.createElement('input');
  hidden.type = 'hidden';
  hidden.name = field.name || 'tags';
  hidden.value = value;

  list.insertBefore(hidden, field);
  list.insertBefore(chip, field);
}

if (!document.__dsTagsInputBound) {
  document.__dsTagsInputBound = true;

  document.addEventListener('keydown', function (e) {
    // Ignore the Enter that only commits an IME composition. Vietnamese/CJK IMEs
    // fire a keydown (isComposing, keyCode 229) to end composition then a real
    // Enter; compositionend re-inserts the text between them, so handling the
    // first would add the tag twice.
    if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
    var field = e.target;
    if (!(field instanceof HTMLInputElement) || !field.matches(TAGS_FIELD)) return;
    e.preventDefault();
    var value = field.value.trim();
    if (!value) return;
    var root = field.closest(TAGS);
    if (root) addTag(root, value);
    field.value = '';
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest && e.target.closest('[data-ds-chip-remove]');
    if (!remove || !remove.closest(TAGS)) return;
    var chip = remove.closest('[data-ds-chip]');
    // Drop the chip and the hidden input right before it, else the removed tag
    // lingers in the submitted form set.
    var hidden = chip && chip.previousElementSibling;
    if (hidden instanceof HTMLInputElement && hidden.type === 'hidden') hidden.remove();
    if (chip) chip.remove();
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "tags-input" failed to initialise:', sfError);
}
})();

/* toast.js */
(function () {
try {
/* toast — the queue behind ds-toast: one strip at a time, auto-dismissed,
 * announced politely.
 *
 * Any behaviour can raise one by dispatching ds:toast with
 * { message, highlight, image, action, detail }. Taking the action dispatches it
 * with that detail; letting the toast go instead dispatches ds:toast:dismissed
 * with the same detail, which is how cart-lines.js knows an undo window closed.
 *
 * The copy is cloned into the live region rather than swapped into one node:
 * aria-live announces insertions, so a reused node would go unread. Up to three
 * stand at once; anything past that queues.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var TOAST_REGION = '[data-ds-toast-region]';
var TOAST_TEMPLATE = '[data-ds-toast-template]';
var TOAST_LIFETIME = 8000;

var toastQueue = [];
var toastVisible = [];
// Stacked, not serialised: a queued toast would leave its own removal without an
// Undo affordance while the one before it counted down.
var TOAST_MAX_VISIBLE = 3;

function toastRegion() {
  return document.querySelector(TOAST_REGION);
}

// `taken` says the action was used. Otherwise the toast simply ran out, which
// is what closes an undo window — cart-lines.js commits the removal on it.
function toastClose(node, taken) {
  if (!node) return;
  if (node.__dsToastTimer) window.clearTimeout(node.__dsToastTimer);
  var at = toastVisible.indexOf(node);
  if (at > -1) toastVisible.splice(at, 1);
  if (node.parentNode) node.parentNode.removeChild(node);
  if (!taken && node.__dsToastDetail) {
    document.dispatchEvent(new CustomEvent('ds:toast:dismissed', { detail: node.__dsToastDetail }));
  }
  toastPump();
}

function toastRender(next) {
  var region = toastRegion();
  var template = document.querySelector(TOAST_TEMPLATE);
  if (!region || !template) return;

  var node = template.content.firstElementChild.cloneNode(true);
  var message = node.querySelector('[data-ds-toast-message]');
  if (message) {
    message.textContent = '';
    if (next.highlight) {
      var strong = document.createElement('strong');
      strong.className = 'sf-font-semibold';
      strong.textContent = next.highlight;
      message.appendChild(strong);
      message.appendChild(document.createTextNode(' '));
    }
    message.appendChild(document.createTextNode(next.message || ''));
  }

  var image = node.querySelector('[data-ds-toast-image]');
  if (image && next.image) {
    image.src = next.image;
    image.alt = '';
    image.removeAttribute('hidden');
  } else if (image) {
    // Drop the whole frame: removing only the <img> leaves ds-image's tinted box.
    var frame = image.closest('[data-ds-image]') || image;
    var slot = frame.parentNode && frame.parentNode.hasAttribute('data-ds-toast-image-slot')
      ? frame.parentNode
      : frame;
    if (slot.parentNode) slot.parentNode.removeChild(slot);
  }

  var undo = node.querySelector('[data-ds-toast-undo]');
  if (undo) {
    if (next.action) {
      undo.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent(next.action, { detail: next.detail || null }));
        toastClose(node, true);
      });
    } else if (undo.parentNode) {
      undo.parentNode.removeChild(undo);
    }
  }

  var close = node.querySelector('[data-ds-toast-close]');
  if (close) close.addEventListener('click', function () { toastClose(node, false); });

  // Dismissing without the action tells the raiser its window has closed.
  if (next.action) node.__dsToastDetail = next.detail || null;
  node.__dsToastTimer = window.setTimeout(function () { toastClose(node, false); }, next.lifetime || TOAST_LIFETIME);
  region.appendChild(node);
  toastVisible.push(node);
}

function toastPump() {
  while (toastVisible.length < TOAST_MAX_VISIBLE && toastQueue.length) {
    toastRender(toastQueue.shift());
  }
}

function toastPush(detail) {
  if (!detail || (!detail.message && !detail.highlight)) return;
  toastQueue.push(detail);
  toastPump();
}

if (!document.__dsToastBound) {
  document.__dsToastBound = true;

  document.addEventListener('ds:toast', function (event) {
    toastPush(event.detail);
  });

  document.addEventListener('ds:cart:removed', function (event) {
    var detail = event.detail || {};
    var region = toastRegion();
    if (!region) return;
    toastPush({
      highlight: detail.title || '',
      message: region.getAttribute('data-ds-toast-removed') || 'was removed',
      image: detail.image || '',
      action: detail.pending ? 'ds:cart:undo' : '',
      detail: detail.undo || null,
    });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "toast" failed to initialise:', sfError);
}
})();

/* upload.js */
(function () {
try {
/* upload — show the chosen file name(s) next to a file input.
 * Binds [data-ds-upload-input] with a [data-ds-upload-input-filename] label
 * (see snippets/ds-upload-input.liquid). The label's data-ds-upload-input-empty
 * holds the placeholder shown when nothing is selected. Progressive enhancement:
 * the native file input works without JS; only the label echo is enhanced.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsUploadBound) {
  document.__dsUploadBound = true;
  document.addEventListener('change', function (e) {
    var field = e.target;
    if (!(field instanceof HTMLInputElement) || field.type !== 'file') return;
    var root = field.closest('[data-ds-upload-input]');
    var label = root && root.querySelector('[data-ds-upload-input-filename]');
    if (!label) return;
    var names = field.files ? Array.from(field.files).map(function (f) { return f.name; }) : [];
    label.textContent = names.length ? names.join(', ') : (label.dataset.dsUploadInputEmpty || '');
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "upload" failed to initialise:', sfError);
}
})();

/* variant-droplist.js */
(function () {
try {
/* variant-droplist — open/close for droplist-style option pickers.
 * The trigger (ds-variants layout:trigger) toggles a listbox of row values.
 * Selection itself is handled by product-variants.js (rows are variant links);
 * this module only manages open/close, the chevron, and keyboard/outside-click
 * dismissal. Progressive enhancement: without JS the rows are normal variant
 * links inside a list that is only visually collapsed.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function dsDroplistTrigger(dl) {
  return dl.querySelector('[data-ds-variants-layout="trigger"]');
}

function dsDroplistList(dl) {
  return dl.querySelector('[data-ds-variant-droplist-list]');
}

function dsDroplistSetOpen(dl, open) {
  dl.setAttribute('data-open', open ? 'true' : 'false');

  var trigger = dsDroplistTrigger(dl);
  if (trigger) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    var icon = trigger.querySelector('svg');
    var chevron = icon ? icon.parentElement : null;
    if (chevron) chevron.classList.toggle('sf-rotate-180', open);
  }

  var list = dsDroplistList(dl);
  if (list) list.hidden = !open;
}

function dsDroplistCloseAll(except) {
  document.querySelectorAll('[data-ds-variant-droplist][data-open="true"]').forEach(function (dl) {
    if (dl !== except) dsDroplistSetOpen(dl, false);
  });
}

if (!document.__dsVariantDroplistBound) {
  document.__dsVariantDroplistBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-ds-variant-droplist] [data-ds-variants-layout="trigger"]');
    if (trigger) {
      event.preventDefault();
      var dl = trigger.closest('[data-ds-variant-droplist]');
      var isOpen = dl.getAttribute('data-open') === 'true';
      dsDroplistCloseAll(dl);
      dsDroplistSetOpen(dl, !isOpen);
      return;
    }

    // Selecting a row closes the list; product-variants.js applies the variant.
    var row = target.closest('[data-ds-variant-droplist-list] a[data-ds-variants]');
    if (row) {
      var owner = row.closest('[data-ds-variant-droplist]');
      if (owner) dsDroplistSetOpen(owner, false);
      return;
    }

    // Click outside any droplist closes them all.
    if (!target.closest('[data-ds-variant-droplist]')) dsDroplistCloseAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-ds-variant-droplist][data-open="true"]');
    if (!open) return;
    dsDroplistSetOpen(open, false);
    var trigger = dsDroplistTrigger(open);
    if (trigger) trigger.focus();
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "variant-droplist" failed to initialise:', sfError);
}
})();
